webpackJsonp([0],{

/***/ "+4kz":
/***/ (function(module, exports) {

module.exports = {"v":"4.10.1","fr":24,"ip":0,"op":159,"w":400,"h":400,"nm":"Tutorial_tinder","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"WEET IK NIET Outlines","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":127,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":131,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":150,"s":[100],"e":[0]},{"t":152}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[200,178,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-2.86,-0.303],[0,0],[-1.474,0.13],[-0.174,0.78],[0,0],[0,0],[-5.374,0],[-2.297,0.303],[-0.174,0.65],[0,0],[4.55,0],[1.906,-0.173],[0.086,-0.476],[0,0],[0,0],[3.163,0],[0.216,-0.65],[0,0],[0,0],[4.983,0],[-0.13,-0.476]],"o":[[0.173,0.78],[0,0],[1.473,0],[2.86,-0.346],[0,0],[0,0],[0.26,1.214],[1.43,0],[2.296,-0.303],[0,0],[0.13,-0.606],[-1.17,0],[-1.907,0.174],[0,0],[0,0],[-0.217,-0.606],[-3.164,0],[0,0],[0,0],[-0.13,-0.823],[-4.507,0],[0,0]],"v":[[-111.473,-1.625],[-106.923,0],[-102.763,0.195],[-98.343,0],[-93.793,-1.69],[-88.983,-19.5],[-84.563,-1.625],[-76.113,0.195],[-70.523,-0.26],[-66.818,-1.69],[-58.953,-44.785],[-65.583,-45.695],[-70.198,-45.435],[-73.188,-44.46],[-76.958,-16.835],[-83.718,-44.72],[-88.788,-45.63],[-93.858,-44.655],[-100.748,-16.965],[-103.933,-44.33],[-111.603,-45.565],[-118.168,-44.85]],"c":true},"ix":2},"nm":"W","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"W","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,3.835],[0.91,0],[0,0],[0,-1.126],[0,0],[-1.647,0],[0,0],[-0.26,1.474],[0,0.932],[0.13,0.824],[0.736,0],[0,0],[0,0],[0,0],[-0.195,1.235],[0,0.91],[0.823,0]],"o":[[0,0],[0,0],[0.91,0],[0,-3.835],[0,0],[-0.997,0],[0,0],[0,1.344],[0,0],[0.606,0],[0.26,-1.473],[0,-0.931],[-0.26,-1.906],[0,0],[0,0],[0,0],[0.52,0],[0.195,-1.235],[0,-3.033],[0,0]],"v":[[-41.599,-27.43],[-41.599,-33.995],[-29.574,-33.995],[-28.209,-39.747],[-29.574,-45.5],[-52.844,-45.5],[-54.339,-43.81],[-54.339,-2.015],[-51.869,0],[-29.639,0],[-28.339,-2.21],[-27.949,-5.818],[-28.144,-8.45],[-29.639,-11.31],[-41.599,-11.31],[-41.599,-17.81],[-33.344,-17.81],[-32.272,-19.663],[-31.979,-22.88],[-33.214,-27.43]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"E","np":3,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,3.835],[0.91,0],[0,0],[0,-1.126],[0,0],[-1.647,0],[0,0],[-0.26,1.474],[0,0.932],[0.13,0.824],[0.736,0],[0,0],[0,0],[0,0],[-0.195,1.235],[0,0.91],[0.823,0]],"o":[[0,0],[0,0],[0.91,0],[0,-3.835],[0,0],[-0.997,0],[0,0],[0,1.344],[0,0],[0.606,0],[0.26,-1.473],[0,-0.931],[-0.26,-1.906],[0,0],[0,0],[0,0],[0.52,0],[0.195,-1.235],[0,-3.033],[0,0]],"v":[[-9.554,-27.43],[-9.554,-33.995],[2.471,-33.995],[3.836,-39.747],[2.471,-45.5],[-20.799,-45.5],[-22.294,-43.81],[-22.294,-2.015],[-19.824,0],[2.406,0],[3.706,-2.21],[4.096,-5.818],[3.901,-8.45],[2.406,-11.31],[-9.554,-11.31],[-9.554,-17.81],[-1.299,-17.81],[-0.227,-19.663],[0.066,-22.88],[-1.169,-27.43]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"E","np":3,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-0.304,1.994],[0,0.997],[0.13,0.954],[0.736,0],[0,0],[0.303,-1.993],[0,-0.996],[-0.13,-0.953],[-0.737,0],[0,0],[0,0],[-4.29,0],[0,0.867]],"o":[[0,0],[0.736,0],[0.13,-0.953],[0,-0.996],[-0.304,-1.993],[0,0],[-0.737,0],[-0.13,0.954],[0,0.997],[0.303,1.994],[0,0],[0,0],[0,0.867],[4.29,0],[0,0]],"v":[[29.315,-33.67],[36.92,-33.67],[38.48,-36.66],[38.675,-39.585],[38.48,-42.51],[36.92,-45.5],[8.645,-45.5],[7.085,-42.51],[6.89,-39.585],[7.085,-36.66],[8.645,-33.67],[16.445,-33.67],[16.445,-1.04],[22.88,0.26],[29.315,-1.04]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"T","np":3,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.26,-1.863],[0,-0.953],[-0.174,-0.91],[-0.737,0],[0,0],[-0.304,1.864],[0,0.954],[0.173,0.91],[0.736,0],[0,0],[0,0],[0,0],[-0.26,1.864],[0,0.954],[0.173,0.91],[0.736,0],[0,0],[0.303,-1.863],[0,-0.953],[-0.13,-0.91],[-0.737,0],[0,0],[0,0]],"o":[[-0.737,0],[-0.174,0.91],[0,0.954],[0.26,1.864],[0,0],[0.736,0],[0.173,-0.91],[0,-0.953],[-0.304,-1.863],[0,0],[0,0],[0,0],[0.736,0],[0.173,-0.91],[0,-0.953],[-0.26,-1.863],[0,0],[-0.737,0],[-0.13,0.91],[0,0.954],[0.303,1.864],[0,0],[0,0],[0,0]],"v":[[54.405,-11.18],[52.91,-8.385],[52.65,-5.59],[52.91,-2.795],[54.405,0],[76.31,0],[77.87,-2.795],[78.13,-5.59],[77.87,-8.385],[76.31,-11.18],[71.76,-11.18],[71.76,-34.32],[76.115,-34.32],[77.61,-37.115],[77.87,-39.91],[77.61,-42.705],[76.115,-45.5],[54.275,-45.5],[52.715,-42.705],[52.52,-39.91],[52.715,-37.115],[54.275,-34.32],[58.89,-34.32],[58.89,-11.18]],"c":true},"ix":2},"nm":"I","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"I","np":3,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-1.387,-0.346],[0,0],[-0.824,0.303],[-1.994,1.734],[0,0.087],[0,0],[0,0],[0,0.087],[5.763,0],[0.303,-0.606],[0,0],[0,0],[4.333,0],[0,-0.736],[0,0],[-2.167,-0.173],[0,0],[0,0.65]],"o":[[0,0],[0,0],[0.78,1.43],[0,0],[0.823,0],[2.686,-0.996],[0.823,-0.65],[0,0],[0,0],[0.043,-0.086],[-0.304,-0.996],[-3.164,0],[0,0],[0,0],[0,-0.736],[-4.334,0],[0,0],[0,0.434],[0,0],[4.073,0],[0,0]],"v":[[95.484,-16.575],[96.524,-16.575],[103.934,-2.405],[107.184,0.26],[108.744,0.39],[111.214,-0.065],[118.234,-4.16],[119.469,-5.265],[106.339,-23.4],[117.649,-43.81],[117.714,-44.07],[108.614,-45.565],[103.414,-44.655],[95.484,-28.015],[95.484,-44.655],[88.984,-45.76],[82.484,-44.655],[82.484,-1.04],[85.734,-0.13],[89.374,0.065],[95.484,-0.91]],"c":true},"ix":2},"nm":"K","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"K","np":3,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[7.378,0],[0,-1.506],[0,0],[0,0],[3.291,0.437],[2.458,0],[0,-1.19],[0,0],[-7.339,0],[0,1.428],[0,0],[0,0],[-7.458,0],[0,1.666]],"o":[[0,-1.506],[-7.378,0],[0,0],[0,0],[-0.714,-1.19],[-3.293,-0.435],[-6.268,0],[0,0],[0,1.428],[7.337,0],[0,0],[0,0],[0.634,1.19],[7.456,0],[0,0]],"v":[[-52.121,15.961],[-63.188,13.7],[-74.255,15.961],[-74.255,53.327],[-93.295,16.675],[-99.304,14.236],[-107.932,13.581],[-117.333,15.366],[-117.333,94.977],[-106.325,97.119],[-95.318,94.977],[-95.318,57.968],[-75.445,95.096],[-63.307,96.881],[-52.121,94.382]],"c":true},"ix":2},"nm":"N","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"N","np":3,"cix":2,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.476,-3.41],[0,-1.744],[-0.318,-1.666],[-1.35,0],[0,0],[-0.556,3.412],[0,1.746],[0.316,1.666],[1.348,0],[0,0],[0,0],[0,0],[-0.476,3.412],[0,1.746],[0.316,1.666],[1.348,0],[0,0],[0.554,-3.41],[0,-1.744],[-0.238,-1.666],[-1.35,0],[0,0],[0,0]],"o":[[-1.35,0],[-0.318,1.666],[0,1.746],[0.476,3.412],[0,0],[1.348,0],[0.316,-1.666],[0,-1.744],[-0.556,-3.41],[0,0],[0,0],[0,0],[1.348,0],[0.316,-1.666],[0,-1.744],[-0.476,-3.41],[0,0],[-1.35,0],[-0.238,1.666],[0,1.746],[0.554,3.412],[0,0],[0,0],[0,0]],"v":[[-40.578,76.532],[-43.315,81.649],[-43.791,86.766],[-43.315,91.883],[-40.578,97],[-0.475,97],[2.381,91.883],[2.857,86.766],[2.381,81.649],[-0.475,76.532],[-8.805,76.532],[-8.805,34.168],[-0.832,34.168],[1.905,29.051],[2.381,23.934],[1.905,18.817],[-0.832,13.7],[-40.816,13.7],[-43.672,18.817],[-44.029,23.934],[-43.672,29.051],[-40.816,34.168],[-32.367,34.168],[-32.367,76.532]],"c":true},"ix":2},"nm":"I","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"I","np":3,"cix":2,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,7.021],[1.666,0],[0,0],[0,-2.062],[0,0],[-3.016,0],[0,0],[-0.476,2.698],[0,1.707],[0.238,1.508],[1.348,0],[0,0],[0,0],[0,0],[-0.357,2.261],[0,1.666],[1.506,0]],"o":[[0,0],[0,0],[1.666,0],[0,-7.021],[0,0],[-1.826,0],[0,0],[0,2.46],[0,0],[1.11,0],[0.476,-2.696],[0,-1.705],[-0.476,-3.49],[0,0],[0,0],[0,0],[0.952,0],[0.357,-2.261],[0,-5.552],[0,0]],"v":[[34.152,46.782],[34.152,34.763],[56.167,34.763],[58.666,24.231],[56.167,13.7],[13.565,13.7],[10.828,16.794],[10.828,93.311],[15.35,97],[56.048,97],[58.428,92.954],[59.142,86.35],[58.785,81.53],[56.048,76.294],[34.152,76.294],[34.152,64.394],[49.265,64.394],[51.229,61.003],[51.764,55.112],[49.503,46.782]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"E","np":3,"cix":2,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-0.556,3.65],[0,1.826],[0.238,1.746],[1.348,0],[0,0],[0.554,-3.648],[0,-1.824],[-0.238,-1.744],[-1.35,0],[0,0],[0,0],[-7.854,0],[0,1.588]],"o":[[0,0],[1.348,0],[0.238,-1.744],[0,-1.824],[-0.556,-3.648],[0,0],[-1.35,0],[-0.238,1.746],[0,1.826],[0.554,3.65],[0,0],[0,0],[0,1.588],[7.854,0],[0,0]],"v":[[105.314,35.358],[119.237,35.358],[122.093,29.884],[122.45,24.529],[122.093,19.174],[119.237,13.7],[67.472,13.7],[64.616,19.174],[64.259,24.529],[64.616,29.884],[67.472,35.358],[81.752,35.358],[81.752,95.096],[93.533,97.476],[105.314,95.096]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.541176470588,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"T","np":3,"cix":2,"ix":10,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":153,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"WAAR Outlines","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":71,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":75,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":100,"s":[100],"e":[0]},{"t":102}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[202,239,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.048,-0.428],[0,0],[-2.086,0.184],[-0.246,1.104],[0,0],[0,0],[-7.606,0],[-3.252,0.428],[-0.246,0.92],[0,0],[6.44,0],[2.698,-0.244],[0.122,-0.674],[0,0],[0,0],[4.476,0],[0.306,-0.92],[0,0],[0,0],[7.052,0],[-0.184,-0.674]],"o":[[0.244,1.104],[0,0],[2.084,0],[4.048,-0.49],[0,0],[0,0],[0.368,1.718],[2.024,0],[3.25,-0.428],[0,0],[0.184,-0.858],[-1.656,0],[-2.7,0.246],[0,0],[0,0],[-0.308,-0.858],[-4.478,0],[0,0],[0,0],[-0.184,-1.164],[-6.38,0],[0,0]],"v":[[-118.22,-2.3],[-111.78,0],[-105.892,0.276],[-99.636,0],[-93.196,-2.392],[-86.388,-27.6],[-80.132,-2.3],[-68.172,0.276],[-60.26,-0.368],[-55.016,-2.392],[-43.884,-63.388],[-53.268,-64.676],[-59.8,-64.308],[-64.032,-62.928],[-69.368,-23.828],[-78.936,-63.296],[-86.112,-64.584],[-93.288,-63.204],[-103.04,-24.012],[-107.548,-62.744],[-118.404,-64.492],[-127.696,-63.48]],"c":true},"ix":2},"nm":"W","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.796078431373,0.131118819293,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"W","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.822,0.244],[0,0.43],[0,0],[8.402,0],[0,-0.49],[0,0],[-1.412,-0.336],[-2.944,0],[-0.368,1.902],[0,0],[0,0],[0,0],[-5.336,0]],"o":[[2.82,-0.244],[0,0],[0,-0.49],[-8.404,0],[0,0],[0,0.184],[1.41,0.338],[5.52,0],[0,0],[0,0],[0,0],[0.428,1.718],[1.656,0]],"v":[[9.384,-0.184],[13.616,-1.196],[-2.3,-63.572],[-14.904,-64.308],[-27.508,-63.572],[-43.792,-1.288],[-41.676,-0.506],[-35.144,0],[-26.312,-2.852],[-23.644,-14.26],[-9.016,-14.26],[-5.98,-2.392],[2.668,0.184]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-16.376,-44.988],[-15.824,-44.988],[-11.684,-25.944],[-21.344,-25.944]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.796078431373,0.131118819293,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"A","np":5,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.822,0.244],[0,0.43],[0,0],[8.402,0],[0,-0.49],[0,0],[-1.412,-0.336],[-2.944,0],[-0.368,1.902],[0,0],[0,0],[0,0],[-5.336,0]],"o":[[2.82,-0.244],[0,0],[0,-0.49],[-8.404,0],[0,0],[0,0.184],[1.41,0.338],[5.52,0],[0,0],[0,0],[0,0],[0.428,1.718],[1.656,0]],"v":[[69.644,-0.184],[73.876,-1.196],[57.96,-63.572],[45.356,-64.308],[32.752,-63.572],[16.468,-1.288],[18.584,-0.506],[25.116,0],[33.948,-2.852],[36.616,-14.26],[51.244,-14.26],[54.28,-2.392],[62.928,0.184]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[43.884,-44.988],[44.436,-44.988],[48.576,-25.944],[38.916,-25.944]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.796078431373,0.131118819293,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"A","np":5,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-2.392,0],[-3.68,2.638],[-0.492,1.472],[0,0],[-1.472,3.098],[0,3.804],[16.13,0],[0,0],[0,-2.146],[0,0],[-5.888,0],[0,0.982]],"o":[[0,0],[0,0],[1.164,1.718],[2.392,0],[2.698,-1.9],[0,0],[2.698,-1.84],[1.472,-3.096],[0,-12.572],[0,0],[-2.27,0],[0,0],[0,0.92],[5.826,0],[0,0]],"v":[[97.52,-22.172],[100.372,-22.172],[109.02,-2.024],[114.356,0.552],[123.464,-3.404],[128.248,-8.464],[116.656,-27.784],[122.912,-35.19],[125.12,-45.54],[100.924,-64.4],[83.352,-64.4],[79.948,-61.18],[79.948,-1.196],[88.78,0.184],[97.52,-1.288]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[-1.136,-1.072],[0,-2.208],[5.826,0],[0,0],[0,0]],"o":[[2.576,0],[1.134,1.074],[0,4.846],[0,0],[0,0],[0,0]],"v":[[99.452,-48.116],[105.018,-46.506],[106.72,-41.584],[97.98,-34.316],[97.52,-34.316],[97.52,-48.116]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.796078431373,0.131118819293,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"R","np":5,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":71,"op":103,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"NIET WAAR Outlines","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":28,"s":[0],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":31,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":48,"s":[100],"e":[0]},{"t":50}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[202,206,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[47.543,47.543,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[13.392,0],[0,-2.734],[0,0],[0,0],[5.974,0.793],[4.462,0],[0,-2.16],[0,0],[-13.321,0],[0,2.592],[0,0],[0,0],[-13.537,0],[0,3.024]],"o":[[0,-2.734],[-13.392,0],[0,0],[0,0],[-1.296,-2.16],[-5.977,-0.79],[-11.377,0],[0,0],[0,2.592],[13.318,0],[0,0],[0,0],[1.151,2.16],[13.534,0],[0,0]],"v":[[-94.605,-147.096],[-114.693,-151.2],[-134.781,-147.096],[-134.781,-79.272],[-169.341,-145.8],[-180.249,-150.228],[-195.909,-151.416],[-212.973,-148.176],[-212.973,-3.672],[-192.993,0.216],[-173.013,-3.672],[-173.013,-70.848],[-136.941,-3.456],[-114.909,-0.216],[-94.605,-4.752]],"c":true},"ix":2},"nm":"N","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"N","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.864,-6.19],[0,-3.166],[-0.577,-3.024],[-2.45,0],[0,0],[-1.009,6.193],[0,3.169],[0.574,3.024],[2.447,0],[0,0],[0,0],[0,0],[-0.864,6.193],[0,3.169],[0.574,3.024],[2.447,0],[0,0],[1.006,-6.19],[0,-3.166],[-0.432,-3.024],[-2.45,0],[0,0],[0,0]],"o":[[-2.45,0],[-0.577,3.024],[0,3.169],[0.864,6.193],[0,0],[2.447,0],[0.574,-3.024],[0,-3.166],[-1.009,-6.19],[0,0],[0,0],[0,0],[2.447,0],[0.574,-3.024],[0,-3.166],[-0.864,-6.19],[0,0],[-2.45,0],[-0.432,3.024],[0,3.169],[1.006,6.193],[0,0],[0,0],[0,0]],"v":[[-73.654,-37.152],[-78.622,-27.864],[-79.486,-18.576],[-78.622,-9.288],[-73.654,0],[-0.862,0],[4.322,-9.288],[5.186,-18.576],[4.322,-27.864],[-0.862,-37.152],[-15.982,-37.152],[-15.982,-114.048],[-1.51,-114.048],[3.458,-123.336],[4.322,-132.624],[3.458,-141.912],[-1.51,-151.2],[-74.086,-151.2],[-79.27,-141.912],[-79.918,-132.624],[-79.27,-123.336],[-74.086,-114.048],[-58.75,-114.048],[-58.75,-37.152]],"c":true},"ix":2},"nm":"I","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"I","np":3,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,12.744],[3.024,0],[0,0],[0,-3.743],[0,0],[-5.474,0],[0,0],[-0.864,4.897],[0,3.098],[0.432,2.737],[2.447,0],[0,0],[0,0],[0,0],[-0.648,4.104],[0,3.024],[2.734,0]],"o":[[0,0],[0,0],[3.024,0],[0,-12.744],[0,0],[-3.314,0],[0,0],[0,4.465],[0,0],[2.015,0],[0.864,-4.894],[0,-3.095],[-0.864,-6.335],[0,0],[0,0],[0,0],[1.728,0],[0.648,-4.104],[0,-10.078],[0,0]],"v":[[61.99,-91.152],[61.99,-112.968],[101.95,-112.968],[106.486,-132.084],[101.95,-151.2],[24.622,-151.2],[19.654,-145.584],[19.654,-6.696],[27.862,0],[101.734,0],[106.054,-7.344],[107.35,-19.332],[106.702,-28.08],[101.734,-37.584],[61.99,-37.584],[61.99,-59.184],[89.422,-59.184],[92.986,-65.34],[93.958,-76.032],[89.854,-91.152]],"c":true},"ix":2},"nm":"E","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"E","np":3,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-1.009,6.625],[0,3.314],[0.432,3.169],[2.447,0],[0,0],[1.006,-6.622],[0,-3.311],[-0.432,-3.166],[-2.45,0],[0,0],[0,0],[-14.256,0],[0,2.882]],"o":[[0,0],[2.447,0],[0.432,-3.166],[0,-3.311],[-1.009,-6.622],[0,0],[-2.45,0],[-0.432,3.169],[0,3.314],[1.006,6.625],[0,0],[0,0],[0,2.882],[14.256,0],[0,0]],"v":[[191.158,-111.888],[216.43,-111.888],[221.614,-121.824],[222.262,-131.544],[221.614,-141.264],[216.43,-151.2],[122.47,-151.2],[117.286,-141.264],[116.638,-131.544],[117.286,-121.824],[122.47,-111.888],[148.39,-111.888],[148.39,-3.456],[169.774,0.864],[191.158,-3.456]],"c":true},"ix":2},"nm":"T","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"T","np":3,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-7.04,-0.745],[0,0],[-3.628,0.32],[-0.428,1.92],[0,0],[0,0],[-13.227,0],[-5.655,0.745],[-0.428,1.6],[0,0],[11.2,0],[4.693,-0.425],[0.213,-1.173],[0,0],[0,0],[7.785,0],[0.533,-1.6],[0,0],[0,0],[12.265,0],[-0.32,-1.173]],"o":[[0.425,1.92],[0,0],[3.625,0],[7.04,-0.852],[0,0],[0,0],[0.64,2.988],[3.52,0],[5.652,-0.745],[0,0],[0.32,-1.492],[-2.88,0],[-4.695,0.428],[0,0],[0,0],[-0.535,-1.493],[-7.788,0],[0,0],[0,0],[-0.32,-2.025],[-11.095,0],[0,0]],"v":[[-205.599,131],[-194.399,135],[-184.159,135.48],[-173.279,135],[-162.079,130.84],[-150.239,87],[-139.359,131],[-118.559,135.48],[-104.799,134.36],[-95.679,130.84],[-76.319,24.76],[-92.639,22.52],[-103.999,23.16],[-111.359,25.56],[-120.639,93.56],[-137.279,24.92],[-149.759,22.68],[-162.239,25.08],[-179.199,93.24],[-187.039,25.88],[-205.919,22.84],[-222.079,24.6]],"c":true},"ix":2},"nm":"W","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"W","np":3,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-4.908,0.425],[0,0.747],[0,0],[14.613,0],[0,-0.852],[0,0],[-2.455,-0.585],[-5.12,0],[-0.64,3.308],[0,0],[0,0],[0,0],[-9.28,0]],"o":[[4.905,-0.425],[0,0],[0,-0.852],[-14.615,0],[0,0],[0,0.32],[2.452,0.588],[9.6,0],[0,0],[0,0],[0,0],[0.745,2.988],[2.88,0]],"v":[[16.32,134.68],[23.68,132.92],[-4,24.44],[-25.92,23.16],[-47.84,24.44],[-76.16,132.76],[-72.48,134.12],[-61.12,135],[-45.76,130.04],[-41.12,110.2],[-15.68,110.2],[-10.4,130.84],[4.64,135.32]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-28.48,56.76],[-27.52,56.76],[-20.32,89.88],[-37.12,89.88]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"A","np":5,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-4.908,0.425],[0,0.747],[0,0],[14.612,0],[0,-0.852],[0,0],[-2.455,-0.585],[-5.12,0],[-0.64,3.308],[0,0],[0,0],[0,0],[-9.28,0]],"o":[[4.905,-0.425],[0,0],[0,-0.852],[-14.615,0],[0,0],[0,0.32],[2.452,0.588],[9.6,0],[0,0],[0,0],[0,0],[0.745,2.988],[2.88,0]],"v":[[121.12,134.68],[128.48,132.92],[100.8,24.44],[78.88,23.16],[56.96,24.44],[28.64,132.76],[32.32,134.12],[43.68,135],[59.04,130.04],[63.68,110.2],[89.12,110.2],[94.4,130.84],[109.44,135.32]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[76.32,56.76],[77.28,56.76],[84.48,89.88],[67.68,89.88]],"c":true},"ix":2},"nm":"A","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"A","np":5,"cix":2,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[-4.16,0],[-6.4,4.587],[-0.855,2.56],[0,0],[-2.56,5.387],[0,6.615],[28.052,0],[0,0],[0,-3.732],[0,0],[-10.24,0],[0,1.708]],"o":[[0,0],[0,0],[2.025,2.988],[4.16,0],[4.693,-3.305],[0,0],[4.692,-3.2],[2.56,-5.385],[0,-21.865],[0,0],[-3.947,0],[0,0],[0,1.6],[10.133,0],[0,0]],"v":[[169.6,96.44],[174.56,96.44],[189.6,131.48],[198.88,135.96],[214.72,129.08],[223.04,120.28],[202.88,86.68],[213.76,73.8],[217.6,55.8],[175.52,23],[144.96,23],[139.04,28.6],[139.04,132.92],[154.4,135.32],[169.6,132.76]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[-1.975,-1.865],[0,-3.84],[10.133,0],[0,0],[0,0]],"o":[[4.48,0],[1.973,1.868],[0,8.428],[0,0],[0,0],[0,0]],"v":[[172.96,51.32],[182.64,54.12],[185.6,62.68],[170.4,75.32],[169.6,75.32],[169.6,51.32]],"c":true},"ix":2},"nm":"R","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.890196078431,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"R","np":5,"cix":2,"ix":8,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":51,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"tut_hand","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":12,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":16,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":26,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":55,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":60,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":63,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":67,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":106,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":110,"s":[100],"e":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":155,"s":[100],"e":[100]},{"t":158}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0.221],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":23,"s":[0],"e":[7.694]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":26,"s":[7.694],"e":[-31.826]},{"t":33,"s":[-31.826],"h":1},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":46,"s":[-31.826],"e":[14.073]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":55,"s":[14.073],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":60,"s":[0.221],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":63,"s":[0.221],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":67,"s":[0.221],"e":[-18.226]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":72,"s":[-18.226],"e":[35.937]},{"t":80,"s":[35.937],"h":1},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":96,"s":[35.937],"e":[-13.67]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":106,"s":[-13.67],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":110,"s":[0.221],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":113,"s":[0.221],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":117,"s":[0.221],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":125,"s":[0.221],"e":[0.221]},{"t":130,"s":[0.221],"h":1},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":148,"s":[0.221],"e":[0.221]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":155,"s":[0.221],"e":[0.221]},{"t":158}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":0,"s":[259,269,0],"e":[259,269,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":12,"s":[259,269,0],"e":[259,269,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":16,"s":[259,269,0],"e":[247.5,265,0],"to":[-1.91666662693024,-0.66666668653488,0],"ti":[1.16666662693024,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":23,"s":[247.5,265,0],"e":[252,269,0],"to":[-1.16666662693024,0,0],"ti":[38.5833320617676,-1.66666662693024,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":26,"s":[252,269,0],"e":[16,275,0],"to":[-38.5833320617676,1.66666662693024,0],"ti":[120.083335876465,-63.9166679382324,0]},{"t":33,"s":[16,275,0],"h":1},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":46,"s":[16,275,0],"e":[259,269,0],"to":[-9.83728790283203,5.23608589172363,0],"ti":[-31.4132099151611,0.77563482522964,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":55,"s":[259,269,0],"e":[259,269,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":60,"s":[259,269,0],"e":[259,269,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":63,"s":[259,269,0],"e":[250,269.5,0],"to":[-1.5,0.08333333581686,0],"ti":[1.5,1.83333337306976,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":67,"s":[250,269.5,0],"e":[250,258,0],"to":[-1.5,-1.83333337306976,0],"ti":[-32.25,1.25,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":72,"s":[250,258,0],"e":[443.5,262,0],"to":[32.25,-1.25,0],"ti":[-32.25,-0.66666668653488,0]},{"t":80,"s":[443.5,262,0],"h":1},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":96,"s":[443.5,262,0],"e":[235,268.5,0],"to":[-34.75,1.08333337306976,0],"ti":[30.75,-1.16666662693024,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":106,"s":[235,268.5,0],"e":[259,269,0],"to":[-30.75,1.16666662693024,0],"ti":[-4,-0.08333333581686,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":110,"s":[259,269,0],"e":[259,269,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":113,"s":[259,269,0],"e":[254.5,271,0],"to":[-0.75,0.33333334326744,0],"ti":[0.75,-4.16666650772095,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":117,"s":[254.5,271,0],"e":[254.5,294,0],"to":[-0.75,4.16666650772095,0],"ti":[0,-3.83333325386047,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":122,"s":[254.5,294,0],"e":[254.5,294,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":125,"s":[254.5,294,0],"e":[254.5,-3,0],"to":[0,-49.5,0],"ti":[-0.75,3.25,0]},{"t":130,"s":[254.5,-3,0],"h":1},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":148,"s":[254.5,-3,0],"e":[259,274.5,0],"to":[0.18600076436996,-0.80600327253342,0],"ti":[-0.56399923563004,-30.3306255340576,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":155,"s":[259,274.5,0],"e":[259,269,0],"to":[0.75,40.3333320617676,0],"ti":[0,0.91666668653488,0]},{"t":158}],"ix":2},"a":{"a":0,"k":[75.5,100,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":0,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":12,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":16,"s":[100,100,100],"e":[93.409,93.409,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":23,"s":[93.409,93.409,100],"e":[93.409,93.409,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":26,"s":[93.409,93.409,100],"e":[98.49,98.49,100]},{"t":33,"s":[98.49,98.49,100],"h":1},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0.58,0.58,0.876]},"n":["0p667_1_0p333_0p58","0p667_1_0p333_0p58","0p667_1_0p333_0p876"],"t":46,"s":[98.49,98.49,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":55,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":60,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":63,"s":[100,100,100],"e":[84.697,84.697,100]},{"i":{"x":[0.667,0.667,0.667],"y":[0.429,0.429,-1.267]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_0p429_0p333_0","0p667_0p429_0p333_0","0p667_-1p267_0p333_0"],"t":67,"s":[84.697,84.697,100],"e":[88.664,88.664,100]},{"t":80,"s":[88.664,88.664,100],"h":1},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":96,"s":[88.664,88.664,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":106,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":110,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":113,"s":[100,100,100],"e":[87.342,87.342,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":117,"s":[87.342,87.342,100],"e":[87.342,87.342,100]},{"i":{"x":[0.667,0.667,0.667],"y":[0.438,0.438,-1.076]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_0p438_0p333_0","0p667_0p438_0p333_0","0p667_-1p076_0p333_0"],"t":125,"s":[87.342,87.342,100],"e":[91.032,91.032,100]},{"t":130,"s":[91.032,91.032,100],"h":1},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":148,"s":[91.032,91.032,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":155,"s":[100,100,100],"e":[100,100,100]},{"t":158}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-4.825,-0.131],[-12.68,0.328],[-3.322,0.764],[-3.19,2.375],[-2.63,6.832],[-2.057,7.179],[0.276,8.077],[-0.423,6.104],[0.463,2.727],[1.001,3.328],[6.764,-1.901],[-6.398,-4.548],[-1.053,1.557],[1.503,3.21],[5.879,-0.141],[3.478,-4.616],[-5.504,-2.276],[-0.731,0.925],[2.705,4.147],[7.131,0.587],[0.457,-1.485],[0.295,-3.487],[0,0],[-0.07,2.948],[-0.368,3.394],[-0.138,6.418],[10.698,8.047],[6.439,-1.914],[1.344,-6.85],[0.169,-6.245],[-0.729,-6.403],[0.002,-6.521],[0.677,-6.57],[-0.178,-3.032],[-0.088,-1.65],[-0.309,-0.459],[-0.962,0.6],[0.832,0.979],[1.431,1.799],[2.429,2.846],[2.061,1.566],[3.611,-0.38],[1.683,-7.243],[-3.517,-5.369],[-3.294,-5.559],[-3.006,-6.279],[-1.22,-1.562],[-0.969,-1.627],[-1.516,-3.427],[-1.674,-3.221],[-2.389,-2.768],[-3.417,-2.208],[-4.578,-0.444],[4.769,0.464],[2.329,3.588],[1.534,2.474],[1.246,2.15],[0.845,1.1],[0.753,1.598],[1.576,2.133],[1.906,2.423],[0.595,0.93],[0.605,1.198],[1.878,2.229],[2.194,4.945],[2.501,4.698],[-1.642,3.267],[-4.506,-0.589],[-3.283,-4.096],[-1.431,-2.578],[-3.053,-0.679],[0.218,4.47],[-0.322,5.906],[0.006,5.682],[0.596,5.452],[-0.6,5.669],[-0.114,5.876],[-0.989,2.473],[-4.596,0.443],[-2.767,-4.336],[-0.189,-3.445],[0.075,-6.507],[0.723,-6.174],[-0.09,-3.124],[-0.017,-3.203],[-0.403,4.746],[-0.805,2.614],[1.205,-0.917],[-2.647,-3.51],[-0.01,-3.489],[-0.367,0.884],[0.093,-0.117],[-1.217,0.321],[-0.095,0.033],[-0.366,-0.883],[-0.929,0.545],[-2.883,-1.376],[-0.654,-4.256],[-0.126,0.963],[0.056,-0.084],[-1.709,0.449],[-0.014,0.028],[-0.126,-0.962],[-2.443,-1.922],[-0.105,-3.056],[-0.148,-1.576],[0.1,-1.449],[-0.029,-2.625],[0.439,-6.818],[1.58,-4.344],[1.122,-3.909],[2.487,-5.835],[4.627,-1.307],[3.589,-0.123],[12.229,0.331]],"o":[[12.652,0.343],[3.334,-0.086],[3.873,-0.891],[6.13,-4.567],[2.689,-6.984],[2.23,-7.787],[-0.209,-6.09],[0.191,-2.767],[-0.562,-3.321],[-2.14,-7.105],[-5.984,1.682],[1.727,1.228],[2.351,-3.477],[-2.521,-5.381],[-5.773,0.138],[-2.979,3.955],[1.091,0.451],[3.47,-4.396],[-4.17,-6.396],[-1.659,-0.136],[-1.043,3.392],[0,0],[-0.015,-2.902],[0.081,-3.39],[0.69,-6.366],[0.248,-11.46],[-5.655,-4.254],[-6.766,2.01],[-1.213,6.181],[-0.172,6.366],[0.733,6.449],[-0.002,6.562],[-0.309,3.004],[0.096,1.643],[0.029,0.558],[-0.107,0.783],[1.361,0.169],[-0.165,-2.271],[-2.329,-2.928],[-1.674,-1.963],[-2.979,-2.262],[-7.285,0.767],[-1.535,6.605],[3.54,5.403],[3.582,6.045],[0.892,1.865],[1.16,1.483],[1.894,3.185],[1.496,3.379],[1.697,3.267],[2.492,2.889],[3.904,2.523],[4.801,0.467],[-4.106,-0.398],[-1.608,-2.479],[-1.309,-2.111],[-0.719,-1.24],[-1.083,-1.411],[-1.133,-2.405],[-1.852,-2.503],[-0.693,-0.882],[-0.709,-1.108],[-1.328,-2.631],[-3.481,-4.133],[-2.155,-4.857],[-1.543,-2.898],[2.025,-4.033],[5.426,0.71],[1.83,2.284],[1.364,2.456],[6.463,1.434],[-0.289,-5.906],[0.309,-5.687],[-0.005,-5.503],[-0.619,-5.655],[0.624,-5.883],[0.052,-2.7],[1.776,-4.44],[4.589,-0.443],[1.952,3.056],[0.36,6.536],[-0.072,6.236],[-0.377,3.211],[0.094,3.23],[0.026,4.892],[0.232,-2.73],[-1.207,0.917],[4.166,0.343],[2.121,2.814],[0.366,-0.884],[-0.093,0.118],[1.216,-0.321],[0.094,-0.033],[0.366,0.885],[0.036,-1.029],[2.642,-1.551],[4.149,1.98],[0.126,-0.964],[-0.057,0.084],[1.71,-0.449],[0.015,-0.027],[0.126,0.963],[0.853,-4.182],[2.605,2.05],[0.055,1.624],[0.135,1.446],[-0.182,2.622],[0.078,6.811],[-0.293,4.548],[-1.378,3.792],[-1.74,6.061],[-1.938,4.548],[-3.528,0.998],[-12.257,0.42],[-4.828,-0.131]],"v":[[-4.538,98.927],[33.497,98.904],[43.133,98.538],[53.775,93.73],[63.87,75.665],[71.962,54.434],[74.676,29.476],[74.836,11.153],[74.617,3.276],[73.258,-6.65],[54.982,-15.05],[49.574,-1.029],[54.704,-2.374],[51.73,-16.6],[37.95,-24.522],[23.445,-17.168],[24.859,-6.701],[28.507,-7.665],[25.773,-25.322],[6.658,-33.552],[3.042,-30.799],[2.45,-20.429],[9.95,-20.429],[10.902,-29.245],[10.579,-38.938],[9.997,-58.334],[2.799,-95.14],[-18.04,-96.749],[-30.143,-82.971],[-30.078,-63.868],[-30.645,-44.762],[-30.251,-25.164],[-30.409,-5.555],[-30.839,3.528],[-30.413,8.438],[-30.284,10.662],[-29.002,10.935],[-28.208,9.719],[-33.605,1.778],[-40.575,-7.078],[-45.784,-13.083],[-56.607,-15.337],[-73.546,-1.038],[-68.912,16.349],[-59.153,32.882],[-48.082,50.315],[-44.705,54.692],[-42.227,59.657],[-36.119,68.863],[-30.563,77.846],[-24.932,86.791],[-18.079,94.993],[-4.538,98.927],[-4.538,91.427],[-16.269,86.32],[-21.43,79.219],[-24.845,72.544],[-27.346,69.31],[-29.556,65.005],[-33.977,58.182],[-38.574,50.294],[-40.962,47.807],[-42.475,43.935],[-47.658,36.72],[-56.842,22.092],[-64.847,8.419],[-65.626,-0.933],[-53.348,-7.866],[-40.427,5.251],[-35.135,12.514],[-29.874,18.152],[-22.913,8.438],[-22.731,-8.963],[-22.75,-25.891],[-22.714,-42.773],[-22.78,-59.466],[-22.957,-77.076],[-21.799,-84.204],[-11.523,-90.357],[0.346,-86.781],[2.661,-77.255],[2.493,-57.842],[3.013,-38.95],[3.423,-29.965],[2.45,-20.429],[9.95,-20.429],[10.275,-28.804],[6.658,-26.052],[19.298,-21.537],[22.383,-10.669],[23.482,-13.321],[23.204,-12.969],[26.853,-13.933],[27.137,-14.031],[28.234,-11.379],[32.563,-15.49],[41.877,-16.342],[48.021,-3.522],[48.4,-6.412],[48.229,-6.159],[53.359,-7.505],[53.402,-7.587],[53.781,-4.698],[64.375,-6.519],[66.815,1.979],[67.689,6.566],[67.336,11.153],[67.176,18.956],[66.625,39.425],[64.529,53.249],[60.126,64.487],[53.297,82.675],[42.633,90.908],[32.284,91.464],[-4.538,91.427]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[75.33,99.644],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-1.661,0],[-2.421,0],[-2.422,0],[-2.422,0],[-2.422,0],[-2.421,0],[-2.422,0],[-2.423,0],[-2.425,0],[-2.425,0],[-1.49,0.365],[-1.371,0.714],[-1.17,1.027],[-0.897,1.285],[-0.571,1.474],[-0.933,2.41],[-0.935,2.411],[-0.934,2.413],[-0.935,2.413],[-0.517,1.579],[-0.435,1.606],[-0.35,1.626],[-0.263,1.644],[-0.176,1.655],[-0.088,1.662],[0,1.665],[0,2.291],[0,2.29],[0,2.29],[0,2.292],[0,2.293],[0,2.293],[0.652,2.584],[0.87,1.416],[1.444,0.829],[1.83,0.027],[1.231,-0.372],[0.806,-0.97],[-1.667,-1.611],[0.333,2.59],[0.587,1.514],[1.062,1.16],[1.552,0.605],[1.74,0.033],[1.325,-0.3],[1.119,-0.756],[0.679,-1.156],[-1.885,-1.335],[0.139,2.569],[0.506,1.538],[0.956,1.261],[1.354,0.894],[1.566,0.511],[1.623,0.211],[1.62,0],[0,-2.199],[0,2.198],[0,2.422],[0,2.424],[0,2.423],[0,2.424],[0,2.424],[0,2.425],[0,2.425],[0,2.425],[0,2.424],[0,2.426],[0,2.428],[-0.017,2.429],[0.865,2.762],[1.095,1.494],[1.569,0.977],[1.845,0.427],[1.89,0],[1.439,-0.299],[1.291,-0.702],[0.976,-1.124],[0.533,-1.341],[0.017,-2.439],[0,-2.45],[0,-2.45],[0,-2.45],[0,-2.449],[0,-2.451],[0,-2.451],[0,-2.45],[0,-2.448],[0,-2.45],[0,-2.449],[0,-2.451],[0,-2.451],[0,-2.451],[0,-2.452],[0,-2.45],[0,-2.45],[0,-2.454],[0,-2.454],[0,-2.455],[1.02,1.371],[1.562,2.1],[1.563,2.102],[1.563,2.104],[1.565,2.105],[1.591,2.085],[2.49,1.362],[1.861,0.137],[1.789,-0.698],[1.508,-1.222],[0.912,-1.158],[0.509,-1.371],[-0.025,-1.419],[-1.255,-2.126],[-1.27,-2.035],[-1.271,-2.036],[-1.27,-2.035],[-1.27,-2.035],[-1.27,-2.036],[-1.268,-2.034],[-1.271,-2.035],[-1.27,-2.033],[-1.271,-2.035],[-1.27,-2.035],[-1.271,-2.035],[-1.271,-2.037],[-1.271,-2.036],[-1.271,-2.037],[-1.271,-2.036],[-1.271,-2.037],[-1.271,-2.037],[-1.274,-2.04],[-1.274,-2.04],[-1.176,-1.117],[-1.429,-0.793],[-1.593,-0.412]],"o":[[2.42,0],[2.422,0],[2.421,0],[2.422,0],[2.421,0],[2.421,0],[2.423,0],[2.426,0],[2.425,0],[1.581,0],[1.521,-0.372],[1.38,-0.72],[1.161,-1.019],[0.878,-1.257],[0.933,-2.409],[0.935,-2.411],[0.934,-2.413],[0.936,-2.413],[0.601,-1.553],[0.519,-1.582],[0.434,-1.606],[0.349,-1.627],[0.261,-1.642],[0.175,-1.653],[0.088,-1.66],[0,-2.29],[0,-2.289],[0,-2.289],[0,-2.292],[0,-2.294],[0,-2.294],[0,-2.392],[-0.361,-1.428],[-0.812,-1.323],[-1.242,-0.711],[-1.85,-0.027],[-1.843,0.557],[-1.665,2],[1.653,1.597],[-0.178,-1.383],[-0.539,-1.392],[-0.976,-1.065],[-1.272,-0.495],[-1.749,-0.033],[-1.73,0.392],[-1.463,0.988],[-1.329,2.259],[1.824,1.293],[-0.073,-1.329],[-0.438,-1.334],[-0.834,-1.102],[-1.13,-0.746],[-1.287,-0.419],[-1.359,-0.176],[-0.76,2.063],[0,2.198],[0,-2.422],[0,-2.424],[0,-2.422],[0,-2.423],[0,-2.425],[0,-2.425],[0,-2.425],[0,-2.423],[0,-2.424],[0,-2.427],[0,-2.429],[0,-2.428],[0.02,-2.538],[-0.453,-1.445],[-0.926,-1.263],[-1.298,-0.808],[-1.482,-0.344],[-1.805,0],[-1.78,0.37],[-1.577,0.859],[-1.185,1.365],[-1.035,2.603],[-0.017,2.45],[0,2.45],[0,2.45],[0,2.451],[0,2.451],[0,2.451],[0,2.451],[0,2.449],[0,2.451],[0,2.449],[0,2.45],[0,2.451],[0,2.452],[0,2.451],[0,2.451],[0,2.452],[0,2.453],[0,2.455],[0,2.455],[0,1.709],[-1.562,-2.101],[-1.562,-2.102],[-1.563,-2.103],[-1.565,-2.104],[-1.565,-2.105],[-1.543,-2.019],[-1.334,-0.73],[-1.518,-0.111],[-1.384,0.54],[-1.433,1.161],[-1.156,1.467],[-0.659,1.779],[0.05,2.881],[1.219,2.067],[1.271,2.035],[1.27,2.035],[1.271,2.035],[1.271,2.036],[1.269,2.032],[1.271,2.035],[1.27,2.035],[1.271,2.036],[1.27,2.035],[1.271,2.036],[1.271,2.038],[1.272,2.036],[1.272,2.037],[1.271,2.036],[1.271,2.036],[1.272,2.036],[1.274,2.04],[1.273,2.04],[0.879,1.409],[1.194,1.133],[1.429,0.793],[1.57,0.406]],"v":[[-5.055,94.744],[-0.215,94.993],[4.63,94.737],[9.473,95.086],[14.317,94.877],[19.159,94.936],[24.002,94.876],[28.848,94.944],[33.699,94.702],[38.549,95.001],[43.112,94.091],[47.434,92.515],[51.365,90.058],[54.838,86.849],[56.661,82.485],[58.469,77.644],[60.283,72.8],[62.398,68.069],[63.825,63.071],[65.558,58.407],[67.628,53.813],[68.736,48.928],[69.585,43.993],[69.857,38.992],[70.266,34.025],[70.408,29.043],[70.068,24.462],[70.43,19.883],[70.287,15.305],[70.568,10.72],[70.921,6.133],[70.048,1.546],[69.755,-3.149],[68.437,-7.812],[64.667,-10.824],[60.146,-11.983],[55.462,-11.867],[51.757,-9.059],[50.368,-5.112],[50.149,-9.453],[48.493,-13.73],[46.508,-17.777],[42.751,-20.324],[38.268,-21.231],[33.681,-20.72],[29.562,-18.786],[26.166,-15.709],[24.663,-11.029],[25.091,-15.729],[23.855,-19.958],[22.017,-23.862],[19.039,-27.111],[14.886,-28.648],[10.596,-29.585],[6.14,-30.235],[5.732,-25.823],[5.679,-21.426],[6.418,-26.27],[6.675,-31.118],[5.82,-35.963],[6.402,-40.81],[6.283,-45.659],[5.789,-50.509],[5.707,-55.359],[5.734,-60.207],[6.205,-65.055],[6.161,-69.908],[6.084,-74.764],[5.81,-79.624],[5.041,-84.512],[3.066,-89.108],[-0.37,-92.922],[-5.214,-94.742],[-10.322,-94.595],[-15.092,-94.124],[-19.704,-92.788],[-23.833,-90.099],[-25.933,-85.634],[-27.096,-80.953],[-27.245,-76.053],[-26.98,-71.154],[-26.788,-66.254],[-26.961,-61.354],[-27.514,-56.452],[-27.596,-51.55],[-27.512,-46.649],[-26.883,-41.752],[-27.053,-36.851],[-27.116,-31.953],[-27.016,-27.052],[-27.034,-22.15],[-26.661,-17.247],[-26.836,-12.344],[-27.079,-7.443],[-27.542,-2.541],[-27.642,2.366],[-27.199,7.275],[-26.98,12.186],[-30.67,13.479],[-33.258,8.88],[-36.297,4.611],[-39.596,0.532],[-42.775,-3.64],[-46.18,-7.641],[-49.754,-11.279],[-54.784,-12.106],[-59.646,-11.393],[-63.937,-8.849],[-67.855,-5.762],[-70.262,-1.351],[-70.544,3.585],[-69.505,8.192],[-67.238,12.423],[-64.592,16.428],[-61.926,20.42],[-60.027,24.891],[-57.406,28.913],[-54.984,33.052],[-52.41,37.1],[-49.243,40.777],[-46.553,44.756],[-44.719,49.266],[-41.464,52.892],[-39.508,57.332],[-36.633,61.198],[-33.964,65.192],[-32.077,69.674],[-28.954,73.384],[-26.732,77.658],[-24.473,81.919],[-21.12,85.496],[-18.706,89.843],[-14.544,92.575],[-9.797,93.789]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.999999820485,0.999999760646,0.999999820485,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[75.848,100.077],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":159,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Shape Layer 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[200,200,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":2,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":116,"s":[10,10],"e":[153,153]},{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":118,"s":[153,153],"e":[231,231]},{"t":122}],"ix":2},"p":{"a":0,"k":[41,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.082475967705,0.57007586956,0.678431391716,1],"ix":3},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":116,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":120,"s":[100],"e":[0]},{"t":122}],"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":116,"s":[9],"e":[46]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":118,"s":[46],"e":[0]},{"t":122}],"ix":5},"lc":1,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-1,-4],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":116,"op":123,"st":95,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[200,200,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":2,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":65,"s":[10,10],"e":[153,153]},{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":67,"s":[153,153],"e":[231,231]},{"t":71}],"ix":2},"p":{"a":0,"k":[41,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.082475967705,0.57007586956,0.678431391716,1],"ix":3},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":65,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":69,"s":[100],"e":[0]},{"t":71}],"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":65,"s":[9],"e":[46]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":67,"s":[46],"e":[0]},{"t":71}],"ix":5},"lc":1,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-1,-4],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":65,"op":72,"st":44,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[200,200,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":2,"ty":"el","s":{"a":1,"k":[{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":21,"s":[10,10],"e":[153,153]},{"i":{"x":[0.833,0.833],"y":[0.833,0.833]},"o":{"x":[0.167,0.167],"y":[0.167,0.167]},"n":["0p833_0p833_0p167_0p167","0p833_0p833_0p167_0p167"],"t":23,"s":[153,153],"e":[231,231]},{"t":27}],"ix":2},"p":{"a":0,"k":[41,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.082475967705,0.57007586956,0.678431391716,1],"ix":3},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":21,"s":[100],"e":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":25,"s":[100],"e":[0]},{"t":27}],"ix":4},"w":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":21,"s":[9],"e":[46]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"n":["0p833_0p833_0p167_0p167"],"t":23,"s":[46],"e":[0]},{"t":27}],"ix":5},"lc":1,"lj":1,"ml":4,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-1,-4],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":21,"op":28,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"tut_card 3","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":106,"s":[0],"e":[100]},{"t":110}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":106,"s":[0],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":117,"s":[0],"e":[0]},{"t":125}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":106,"s":[204,518.5,0],"e":[204,185.5,0],"to":[0,-55.5,0],"ti":[0,52.5833320617676,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":110,"s":[204,185.5,0],"e":[204,203,0],"to":[0,-52.5833320617676,0],"ti":[0,-2.91666674613953,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":112,"s":[204,203,0],"e":[204,203,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":117,"s":[204,203,0],"e":[204,226.5,0],"to":[0,3.91666674613953,0],"ti":[0,-3.91666674613953,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":122,"s":[204,226.5,0],"e":[204,226.5,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":125,"s":[204,226.5,0],"e":[204,-118.5,0],"to":[0,-57.5,0],"ti":[0,57.5,0]},{"t":130}],"ix":2},"a":{"a":0,"k":[104,126.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":106,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":113,"s":[100,100,100],"e":[108,108,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":117,"s":[108,108,100],"e":[108,108,100]},{"t":125}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.848,0],[4.313,0],[4.313,0],[4.314,0],[4.314,0],[4.316,0],[4.315,0],[4.317,0],[4.317,0],[0,3.848],[0,4.313],[0,4.313],[0,4.314],[0,4.314],[0,4.316],[0,4.314],[0,4.317],[0,4.317],[-3.847,0],[-4.313,0],[-4.313,0],[-4.314,0],[-4.314,0],[-4.316,0],[-4.314,0],[-4.317,0],[-4.317,0],[0,-3.847],[0,-4.313],[0,-4.313],[0,-4.314],[0,-4.314],[0,-4.316],[0,-4.315],[0,-4.317],[0,-4.317]],"o":[[-4.313,0],[-4.313,0],[-4.313,0],[-4.314,0],[-4.316,0],[-4.314,0],[-4.317,0],[-4.318,0],[-3.847,0],[0,-4.313],[0,-4.313],[0,-4.313],[0,-4.314],[0,-4.316],[0,-4.314],[0,-4.318],[0,-4.318],[0,-3.847],[4.313,0],[4.313,0],[4.313,0],[4.314,0],[4.316,0],[4.314,0],[4.318,0],[4.318,0],[3.848,0],[0,4.313],[0,4.313],[0,4.313],[0,4.314],[0,4.316],[0,4.314],[0,4.317],[0,4.318],[0,3.848]],"v":[[34.486,41.582],[25.86,41.574],[17.234,41.84],[8.607,41.722],[-0.021,41.05],[-8.653,41.678],[-17.282,41.576],[-25.916,41.871],[-34.551,41.107],[-41.101,34.453],[-41.348,25.827],[-41.294,17.201],[-41.797,8.574],[-41.531,-0.054],[-41.348,-8.686],[-41.721,-17.314],[-41.735,-25.949],[-41.833,-34.584],[-34.551,-41.656],[-25.925,-41.396],[-17.299,-41.39],[-8.672,-41.472],[-0.044,-41.241],[8.588,-41.871],[17.216,-41.149],[25.851,-41.64],[34.486,-41.431],[41.576,-34.584],[41.586,-25.958],[41.833,-17.332],[41.271,-8.705],[41.635,-0.077],[41.278,8.555],[41.301,17.184],[41.25,25.818],[41.735,34.453]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":1,"lj":1,"ml":10,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.853739061543,0.935884064319,0.91048673742,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[103.894,153.145],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[8.365,8.848],[-8.366,8.848],[-11.913,5.303],[-11.913,-5.301],[-8.366,-8.848],[8.365,-8.848],[11.912,-5.301],[11.912,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[150.748,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[3.218,8.848],[-3.217,8.848],[-6.764,5.303],[-6.764,-5.301],[-3.217,-8.848],[3.218,-8.848],[6.764,-5.301],[6.764,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[121.231,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.958,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.958,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[20.612,8.848],[-20.611,8.848],[-24.158,5.303],[-24.158,-5.301],[-20.611,-8.848],[20.612,-8.848],[24.158,-5.301],[24.158,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[69.129,80.389],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[25.895,8.848],[-25.896,8.848],[-29.441,5.303],[-29.441,-5.301],[-25.896,-8.848],[25.895,-8.848],[29.441,-5.301],[29.441,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[133.297,80.389],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[25.895,8.848],[-25.896,8.848],[-29.441,5.303],[-29.441,-5.301],[-25.896,-8.848],[25.895,-8.848],[29.441,-5.301],[29.441,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[74.414,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.371,0],[4.412,0],[4.412,0],[4.412,0],[4.413,0],[4.412,0],[4.412,0],[4.413,0],[4.412,0],[4.414,0],[4.415,0],[4.413,0],[4.416,0],[4.416,0],[2.722,-1.575],[1.624,-2.808],[0,-3.371],[0,-4.441],[0,-4.442],[0,-4.44],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.442],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.441],[0,-4.443],[0,-4.445],[0,-4.443],[0,-4.446],[0,-4.447],[-1.574,-2.721],[-2.808,-1.624],[-3.371,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.413,0],[-4.413,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.413,0],[-4.414,0],[-4.413,0],[-4.416,0],[-4.416,0],[-2.722,1.576],[-1.625,2.809],[0,3.371],[0,4.44],[0,4.441],[0,4.441],[0,4.442],[0,4.442],[0,4.441],[0,4.441],[0,4.443],[0,4.444],[0,4.442],[0,4.442],[0,4.442],[0,4.442],[0,4.443],[0,4.445],[0,4.443],[0,4.445],[0,4.446],[1.575,2.723],[2.809,1.625]],"o":[[-4.412,0],[-4.412,0],[-4.414,0],[-4.414,0],[-4.413,0],[-4.412,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.414,0],[-4.414,0],[-4.417,0],[-4.417,0],[-3.371,0],[-2.808,1.624],[-1.575,2.722],[0,4.44],[0,4.441],[0,4.441],[0,4.442],[0,4.442],[0,4.441],[0,4.442],[0,4.443],[0,4.443],[0,4.443],[0,4.441],[0,4.441],[0,4.442],[0,4.444],[0,4.444],[0,4.443],[0,4.446],[0,4.446],[0,3.371],[1.625,2.809],[2.721,1.575],[4.412,0],[4.412,0],[4.413,0],[4.414,0],[4.412,0],[4.413,0],[4.411,0],[4.412,0],[4.414,0],[4.415,0],[4.414,0],[4.417,0],[4.417,0],[3.371,0],[2.809,-1.624],[1.576,-2.721],[0,-4.441],[0,-4.442],[0,-4.44],[0,-4.442],[0,-4.442],[0,-4.443],[0,-4.443],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.442],[0,-4.441],[0,-4.442],[0,-4.443],[0,-4.444],[0,-4.443],[0,-4.447],[0,-4.447],[0,-3.371],[-1.624,-2.808],[-2.722,-1.575]],"v":[[57.424,-98.088],[48.6,-98.529],[39.776,-98.645],[30.95,-98.915],[22.123,-98.637],[13.298,-98.234],[4.474,-98.876],[-4.351,-98.462],[-13.175,-98.227],[-22.002,-98.908],[-30.831,-98.506],[-39.658,-98.195],[-48.491,-98.923],[-57.324,-98.635],[-66.508,-95.891],[-73.22,-89.161],[-76.311,-79.984],[-75.933,-71.104],[-76.154,-62.221],[-75.354,-53.34],[-76.268,-44.456],[-75.998,-35.57],[-75.956,-26.688],[-76.036,-17.804],[-76.224,-8.919],[-75.348,-0.033],[-75.463,8.852],[-75.581,17.737],[-76.079,26.62],[-75.667,35.503],[-75.404,44.39],[-76.247,53.279],[-75.357,62.165],[-76.048,71.057],[-76.152,79.95],[-73.073,89.041],[-66.418,95.702],[-57.324,98.799],[-48.5,98.923],[-39.676,98.62],[-30.85,98.829],[-22.023,98.513],[-13.198,98.368],[-4.373,98.1],[4.45,98.136],[13.275,98.361],[22.102,98.645],[30.931,98.73],[39.758,98.171],[48.591,98.195],[57.424,98.697],[66.716,96.044],[73.113,89.007],[75.927,79.95],[76.292,71.069],[75.843,62.186],[76.269,53.305],[75.654,44.421],[75.46,35.536],[75.773,26.653],[76.311,17.768],[75.885,8.884],[75.779,-0.004],[76.095,-8.888],[75.548,-17.771],[75.461,-26.655],[76.242,-35.538],[75.967,-44.424],[75.443,-53.314],[75.889,-62.2],[75.548,-71.092],[75.905,-79.984],[73.443,-89.234],[66.878,-96.359]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":11,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.999999820485,0.999999760646,0.999999820485,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[103.811,126.422],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":3,"cix":2,"ix":7,"mn":"ADBE Vector Group","hd":false}],"ip":106,"op":131,"st":62,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"tut_card 2","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":55,"s":[0],"e":[100]},{"t":59}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":55,"s":[0],"e":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":66,"s":[0],"e":[-7.591]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":71,"s":[-7.591],"e":[23.395]},{"t":79}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":55,"s":[204,518.5,0],"e":[204,185.5,0],"to":[0,-55.5,0],"ti":[0,52.5833320617676,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":59,"s":[204,185.5,0],"e":[204,203,0],"to":[0,-52.5833320617676,0],"ti":[0,-2.91666674613953,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":61,"s":[204,203,0],"e":[204,203,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":66,"s":[204,203,0],"e":[189.5,202,0],"to":[-2.41666674613953,-0.16666667163372,0],"ti":[-26.2762145996094,12.293212890625,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":71,"s":[189.5,202,0],"e":[521,208.5,0],"to":[155.5,-72.75,0],"ti":[-55.25,-1.08333337306976,0]},{"t":79}],"ix":2},"a":{"a":0,"k":[104,126.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":55,"s":[100,100,100],"e":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":62,"s":[100,100,100],"e":[108,108,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":66,"s":[108,108,100],"e":[108,108,100]},{"t":71}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.848,0],[4.313,0],[4.313,0],[4.314,0],[4.314,0],[4.316,0],[4.315,0],[4.317,0],[4.317,0],[0,3.848],[0,4.313],[0,4.313],[0,4.314],[0,4.314],[0,4.316],[0,4.314],[0,4.317],[0,4.317],[-3.847,0],[-4.313,0],[-4.313,0],[-4.314,0],[-4.314,0],[-4.316,0],[-4.314,0],[-4.317,0],[-4.317,0],[0,-3.847],[0,-4.313],[0,-4.313],[0,-4.314],[0,-4.314],[0,-4.316],[0,-4.315],[0,-4.317],[0,-4.317]],"o":[[-4.313,0],[-4.313,0],[-4.313,0],[-4.314,0],[-4.316,0],[-4.314,0],[-4.317,0],[-4.318,0],[-3.847,0],[0,-4.313],[0,-4.313],[0,-4.313],[0,-4.314],[0,-4.316],[0,-4.314],[0,-4.318],[0,-4.318],[0,-3.847],[4.313,0],[4.313,0],[4.313,0],[4.314,0],[4.316,0],[4.314,0],[4.318,0],[4.318,0],[3.848,0],[0,4.313],[0,4.313],[0,4.313],[0,4.314],[0,4.316],[0,4.314],[0,4.317],[0,4.318],[0,3.848]],"v":[[34.486,41.582],[25.86,41.574],[17.234,41.84],[8.607,41.722],[-0.021,41.05],[-8.653,41.678],[-17.282,41.576],[-25.916,41.871],[-34.551,41.107],[-41.101,34.453],[-41.348,25.827],[-41.294,17.201],[-41.797,8.574],[-41.531,-0.054],[-41.348,-8.686],[-41.721,-17.314],[-41.735,-25.949],[-41.833,-34.584],[-34.551,-41.656],[-25.925,-41.396],[-17.299,-41.39],[-8.672,-41.472],[-0.044,-41.241],[8.588,-41.871],[17.216,-41.149],[25.851,-41.64],[34.486,-41.431],[41.576,-34.584],[41.586,-25.958],[41.833,-17.332],[41.271,-8.705],[41.635,-0.077],[41.278,8.555],[41.301,17.184],[41.25,25.818],[41.735,34.453]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":1,"lj":1,"ml":10,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.853739061543,0.935884064319,0.91048673742,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[103.894,153.145],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[8.365,8.848],[-8.366,8.848],[-11.913,5.303],[-11.913,-5.301],[-8.366,-8.848],[8.365,-8.848],[11.912,-5.301],[11.912,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[150.748,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[3.218,8.848],[-3.217,8.848],[-6.764,5.303],[-6.764,-5.301],[-3.217,-8.848],[3.218,-8.848],[6.764,-5.301],[6.764,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[121.231,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.958,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.958,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[20.612,8.848],[-20.611,8.848],[-24.158,5.303],[-24.158,-5.301],[-20.611,-8.848],[20.612,-8.848],[24.158,-5.301],[24.158,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[69.129,80.389],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[25.895,8.848],[-25.896,8.848],[-29.441,5.303],[-29.441,-5.301],[-25.896,-8.848],[25.895,-8.848],[29.441,-5.301],[29.441,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[133.297,80.389],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[25.895,8.848],[-25.896,8.848],[-29.441,5.303],[-29.441,-5.301],[-25.896,-8.848],[25.895,-8.848],[29.441,-5.301],[29.441,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[74.414,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.371,0],[4.412,0],[4.412,0],[4.412,0],[4.413,0],[4.412,0],[4.412,0],[4.413,0],[4.412,0],[4.414,0],[4.415,0],[4.413,0],[4.416,0],[4.416,0],[2.722,-1.575],[1.624,-2.808],[0,-3.371],[0,-4.441],[0,-4.442],[0,-4.44],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.442],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.441],[0,-4.443],[0,-4.445],[0,-4.443],[0,-4.446],[0,-4.447],[-1.574,-2.721],[-2.808,-1.624],[-3.371,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.413,0],[-4.413,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.413,0],[-4.414,0],[-4.413,0],[-4.416,0],[-4.416,0],[-2.722,1.576],[-1.625,2.809],[0,3.371],[0,4.44],[0,4.441],[0,4.441],[0,4.442],[0,4.442],[0,4.441],[0,4.441],[0,4.443],[0,4.444],[0,4.442],[0,4.442],[0,4.442],[0,4.442],[0,4.443],[0,4.445],[0,4.443],[0,4.445],[0,4.446],[1.575,2.723],[2.809,1.625]],"o":[[-4.412,0],[-4.412,0],[-4.414,0],[-4.414,0],[-4.413,0],[-4.412,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.414,0],[-4.414,0],[-4.417,0],[-4.417,0],[-3.371,0],[-2.808,1.624],[-1.575,2.722],[0,4.44],[0,4.441],[0,4.441],[0,4.442],[0,4.442],[0,4.441],[0,4.442],[0,4.443],[0,4.443],[0,4.443],[0,4.441],[0,4.441],[0,4.442],[0,4.444],[0,4.444],[0,4.443],[0,4.446],[0,4.446],[0,3.371],[1.625,2.809],[2.721,1.575],[4.412,0],[4.412,0],[4.413,0],[4.414,0],[4.412,0],[4.413,0],[4.411,0],[4.412,0],[4.414,0],[4.415,0],[4.414,0],[4.417,0],[4.417,0],[3.371,0],[2.809,-1.624],[1.576,-2.721],[0,-4.441],[0,-4.442],[0,-4.44],[0,-4.442],[0,-4.442],[0,-4.443],[0,-4.443],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.442],[0,-4.441],[0,-4.442],[0,-4.443],[0,-4.444],[0,-4.443],[0,-4.447],[0,-4.447],[0,-3.371],[-1.624,-2.808],[-2.722,-1.575]],"v":[[57.424,-98.088],[48.6,-98.529],[39.776,-98.645],[30.95,-98.915],[22.123,-98.637],[13.298,-98.234],[4.474,-98.876],[-4.351,-98.462],[-13.175,-98.227],[-22.002,-98.908],[-30.831,-98.506],[-39.658,-98.195],[-48.491,-98.923],[-57.324,-98.635],[-66.508,-95.891],[-73.22,-89.161],[-76.311,-79.984],[-75.933,-71.104],[-76.154,-62.221],[-75.354,-53.34],[-76.268,-44.456],[-75.998,-35.57],[-75.956,-26.688],[-76.036,-17.804],[-76.224,-8.919],[-75.348,-0.033],[-75.463,8.852],[-75.581,17.737],[-76.079,26.62],[-75.667,35.503],[-75.404,44.39],[-76.247,53.279],[-75.357,62.165],[-76.048,71.057],[-76.152,79.95],[-73.073,89.041],[-66.418,95.702],[-57.324,98.799],[-48.5,98.923],[-39.676,98.62],[-30.85,98.829],[-22.023,98.513],[-13.198,98.368],[-4.373,98.1],[4.45,98.136],[13.275,98.361],[22.102,98.645],[30.931,98.73],[39.758,98.171],[48.591,98.195],[57.424,98.697],[66.716,96.044],[73.113,89.007],[75.927,79.95],[76.292,71.069],[75.843,62.186],[76.269,53.305],[75.654,44.421],[75.46,35.536],[75.773,26.653],[76.311,17.768],[75.885,8.884],[75.779,-0.004],[76.095,-8.888],[75.548,-17.771],[75.461,-26.655],[76.242,-35.538],[75.967,-44.424],[75.443,-53.314],[75.889,-62.2],[75.548,-71.092],[75.905,-79.984],[73.443,-89.234],[66.878,-96.359]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":11,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.999999820485,0.999999760646,0.999999820485,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[103.811,126.422],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":3,"cix":2,"ix":7,"mn":"ADBE Vector Group","hd":false}],"ip":55,"op":80,"st":11,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"tut_card","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":0,"s":[0],"e":[100]},{"t":5}],"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":23,"s":[0],"e":[7.644]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"n":["0p667_1_0p333_0"],"t":26,"s":[7.644],"e":[-27.07]},{"t":33}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"n":"0p667_0p667_0p333_0p333","t":16,"s":[200,200,0],"e":[200,200,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":23,"s":[200,200,0],"e":[221.5,193.5,0],"to":[3.58333325386047,-1.08333337306976,0],"ti":[39.6666679382324,-4.25,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"n":"0p667_1_0p333_0","t":26,"s":[221.5,193.5,0],"e":[-125,246.5,0],"to":[-54.4068870544434,5.82930946350098,0],"ti":[123.25,-89.5,0]},{"t":33}],"ix":2},"a":{"a":0,"k":[104,126.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":16,"s":[100,100,100],"e":[108.586,108.586,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"n":["0p667_1_0p333_0","0p667_1_0p333_0","0p667_1_0p333_0"],"t":23,"s":[108.586,108.586,100],"e":[108.586,108.586,100]},{"t":26}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.848,0],[4.313,0],[4.313,0],[4.314,0],[4.314,0],[4.316,0],[4.315,0],[4.317,0],[4.317,0],[0,3.848],[0,4.313],[0,4.313],[0,4.314],[0,4.314],[0,4.316],[0,4.314],[0,4.317],[0,4.317],[-3.847,0],[-4.313,0],[-4.313,0],[-4.314,0],[-4.314,0],[-4.316,0],[-4.314,0],[-4.317,0],[-4.317,0],[0,-3.847],[0,-4.313],[0,-4.313],[0,-4.314],[0,-4.314],[0,-4.316],[0,-4.315],[0,-4.317],[0,-4.317]],"o":[[-4.313,0],[-4.313,0],[-4.313,0],[-4.314,0],[-4.316,0],[-4.314,0],[-4.317,0],[-4.318,0],[-3.847,0],[0,-4.313],[0,-4.313],[0,-4.313],[0,-4.314],[0,-4.316],[0,-4.314],[0,-4.318],[0,-4.318],[0,-3.847],[4.313,0],[4.313,0],[4.313,0],[4.314,0],[4.316,0],[4.314,0],[4.318,0],[4.318,0],[3.848,0],[0,4.313],[0,4.313],[0,4.313],[0,4.314],[0,4.316],[0,4.314],[0,4.317],[0,4.318],[0,3.848]],"v":[[34.486,41.582],[25.86,41.574],[17.234,41.84],[8.607,41.722],[-0.021,41.05],[-8.653,41.678],[-17.282,41.576],[-25.916,41.871],[-34.551,41.107],[-41.101,34.453],[-41.348,25.827],[-41.294,17.201],[-41.797,8.574],[-41.531,-0.054],[-41.348,-8.686],[-41.721,-17.314],[-41.735,-25.949],[-41.833,-34.584],[-34.551,-41.656],[-25.925,-41.396],[-17.299,-41.39],[-8.672,-41.472],[-0.044,-41.241],[8.588,-41.871],[17.216,-41.149],[25.851,-41.64],[34.486,-41.431],[41.576,-34.584],[41.586,-25.958],[41.833,-17.332],[41.271,-8.705],[41.635,-0.077],[41.278,8.555],[41.301,17.184],[41.25,25.818],[41.735,34.453]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":1,"lj":1,"ml":10,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.853739061543,0.935884064319,0.91048673742,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[103.894,153.145],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":3,"cix":2,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[8.365,8.848],[-8.366,8.848],[-11.913,5.303],[-11.913,-5.301],[-8.366,-8.848],[8.365,-8.848],[11.912,-5.301],[11.912,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[150.748,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[3.218,8.848],[-3.217,8.848],[-6.764,5.303],[-6.764,-5.301],[-3.217,-8.848],[3.218,-8.848],[6.764,-5.301],[6.764,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[121.231,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 3","np":2,"cix":2,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.958,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.958,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[20.612,8.848],[-20.611,8.848],[-24.158,5.303],[-24.158,-5.301],[-20.611,-8.848],[20.612,-8.848],[24.158,-5.301],[24.158,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[69.129,80.389],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 4","np":2,"cix":2,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[25.895,8.848],[-25.896,8.848],[-29.441,5.303],[-29.441,-5.301],[-25.896,-8.848],[25.895,-8.848],[29.441,-5.301],[29.441,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[133.297,80.389],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 5","np":2,"cix":2,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.959,0],[0,0],[0,1.958],[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0]],"o":[[0,0],[-1.959,0],[0,0],[0,-1.959],[0,0],[1.959,0],[0,0],[0,1.958]],"v":[[25.895,8.848],[-25.896,8.848],[-29.441,5.303],[-29.441,-5.301],[-25.896,-8.848],[25.895,-8.848],[29.441,-5.301],[29.441,5.303]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[74.414,54.098],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 6","np":2,"cix":2,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[3.371,0],[4.412,0],[4.412,0],[4.412,0],[4.413,0],[4.412,0],[4.412,0],[4.413,0],[4.412,0],[4.414,0],[4.415,0],[4.413,0],[4.416,0],[4.416,0],[2.722,-1.575],[1.624,-2.808],[0,-3.371],[0,-4.441],[0,-4.442],[0,-4.44],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.442],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.441],[0,-4.443],[0,-4.445],[0,-4.443],[0,-4.446],[0,-4.447],[-1.574,-2.721],[-2.808,-1.624],[-3.371,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.413,0],[-4.413,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.413,0],[-4.414,0],[-4.413,0],[-4.416,0],[-4.416,0],[-2.722,1.576],[-1.625,2.809],[0,3.371],[0,4.44],[0,4.441],[0,4.441],[0,4.442],[0,4.442],[0,4.441],[0,4.441],[0,4.443],[0,4.444],[0,4.442],[0,4.442],[0,4.442],[0,4.442],[0,4.443],[0,4.445],[0,4.443],[0,4.445],[0,4.446],[1.575,2.723],[2.809,1.625]],"o":[[-4.412,0],[-4.412,0],[-4.414,0],[-4.414,0],[-4.413,0],[-4.412,0],[-4.412,0],[-4.412,0],[-4.413,0],[-4.414,0],[-4.414,0],[-4.417,0],[-4.417,0],[-3.371,0],[-2.808,1.624],[-1.575,2.722],[0,4.44],[0,4.441],[0,4.441],[0,4.442],[0,4.442],[0,4.441],[0,4.442],[0,4.443],[0,4.443],[0,4.443],[0,4.441],[0,4.441],[0,4.442],[0,4.444],[0,4.444],[0,4.443],[0,4.446],[0,4.446],[0,3.371],[1.625,2.809],[2.721,1.575],[4.412,0],[4.412,0],[4.413,0],[4.414,0],[4.412,0],[4.413,0],[4.411,0],[4.412,0],[4.414,0],[4.415,0],[4.414,0],[4.417,0],[4.417,0],[3.371,0],[2.809,-1.624],[1.576,-2.721],[0,-4.441],[0,-4.442],[0,-4.44],[0,-4.442],[0,-4.442],[0,-4.443],[0,-4.443],[0,-4.442],[0,-4.443],[0,-4.442],[0,-4.442],[0,-4.441],[0,-4.442],[0,-4.443],[0,-4.444],[0,-4.443],[0,-4.447],[0,-4.447],[0,-3.371],[-1.624,-2.808],[-2.722,-1.575]],"v":[[57.424,-98.088],[48.6,-98.529],[39.776,-98.645],[30.95,-98.915],[22.123,-98.637],[13.298,-98.234],[4.474,-98.876],[-4.351,-98.462],[-13.175,-98.227],[-22.002,-98.908],[-30.831,-98.506],[-39.658,-98.195],[-48.491,-98.923],[-57.324,-98.635],[-66.508,-95.891],[-73.22,-89.161],[-76.311,-79.984],[-75.933,-71.104],[-76.154,-62.221],[-75.354,-53.34],[-76.268,-44.456],[-75.998,-35.57],[-75.956,-26.688],[-76.036,-17.804],[-76.224,-8.919],[-75.348,-0.033],[-75.463,8.852],[-75.581,17.737],[-76.079,26.62],[-75.667,35.503],[-75.404,44.39],[-76.247,53.279],[-75.357,62.165],[-76.048,71.057],[-76.152,79.95],[-73.073,89.041],[-66.418,95.702],[-57.324,98.799],[-48.5,98.923],[-39.676,98.62],[-30.85,98.829],[-22.023,98.513],[-13.198,98.368],[-4.373,98.1],[4.45,98.136],[13.275,98.361],[22.102,98.645],[30.931,98.73],[39.758,98.171],[48.591,98.195],[57.424,98.697],[66.716,96.044],[73.113,89.007],[75.927,79.95],[76.292,71.069],[75.843,62.186],[76.269,53.305],[75.654,44.421],[75.46,35.536],[75.773,26.653],[76.311,17.768],[75.885,8.884],[75.779,-0.004],[76.095,-8.888],[75.548,-17.771],[75.461,-26.655],[76.242,-35.538],[75.967,-44.424],[75.443,-53.314],[75.889,-62.2],[75.548,-71.092],[75.905,-79.984],[73.443,-89.234],[66.878,-96.359]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.097218143239,0.27294254677,0.313266350241,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":11,"ix":5},"lc":2,"lj":2,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.999999820485,0.999999760646,0.999999820485,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[103.811,126.422],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 7","np":3,"cix":2,"ix":7,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":45,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":1,"nm":"BG","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[200,200,0],"ix":2},"a":{"a":0,"k":[200,200,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"sw":400,"sh":400,"sc":"#ffffff","ip":0,"op":159,"st":0,"bm":0}]}

/***/ }),

/***/ "+Aaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("SkWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c20cb6d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("aMez");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c20cb6d4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+poC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['onClick', 'title', 'text', 'visual'],

	data: function data() {
		return {};
	},
	mounted: function mounted() {},


	watch: {},

	computed: {},

	methods: {}

});

/***/ }),

/***/ "+xvR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("eR96");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c97b79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("//19");
function injectStyle (ssrContext) {
  __webpack_require__("/lTi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22c97b79_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "//19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"world-quiz stage",class:'round_'+_vm.currentRound,style:({ 'background-image': _vm.backgroundImage }),attrs:{"id":"world-quiz-container"}},[_c('div',{staticClass:"world-quiz__background-overlay background-overlay"},[_c('div',[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header order-2"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.header)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.subheader)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.header)+"\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('div',{staticClass:"world-quiz__card"},[_c('div',{staticClass:"visual-holder"},[_c('div',{staticClass:"total-counter"},[_vm._v("Totaal"),_c('div',{staticClass:"count-value"},[_vm._v(_vm._s(_vm.totalCount))])]),_vm._v(" "),_c('div',{staticClass:"visual-base"},[_c('div',{staticClass:"visual-items overlay ui-droppable droppable",attrs:{"id":"valid_dropzone"}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.baseUrl + _vm.question.visual,"id":"visual-img"}})])]),_vm._v(" "),_c('div',{staticClass:"panel centered inventory flex flexColumn",attrs:{"id":"inventory"}},[_c('div',{staticClass:"icons flex flexRow flexContent-spaceBetween"},_vm._l((_vm.names),function(name,index){return _c('div',{key:"",staticClass:"draggable-holder"},[_c('div',{key:"",staticClass:"draggable ui-draggable ui-draggable-handle",attrs:{"id":_vm.names[index]}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.visuals[index]}})])])])})),_vm._v(" "),_c('div',{staticClass:"scores flex flexRow"},_vm._l((_vm.names),function(name,index){return _c('div',{staticClass:"scores__item"},[_c('span',{staticClass:"name-label"},[_vm._v(_vm._s(_vm.showNames[index]))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"score-label"},[_vm._v(_vm._s(Math.round((_vm.currentCount[index]/_vm.maxCount)*100))+"%")])])}))])])])]),_vm._v(" "),(_vm.roundData.hide_explanation === 'Popup')?_c('div',[_c('ExplanationPopup')],1):_vm._e(),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/gwQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("LqcC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f74bc9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("8AEU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f74bc9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/lTi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "01iT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

	props: [],
	beforeMount: function beforeMount() {
		this.setPreloadAssets(this.currentBlock);
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_1__const_base__["a" /* url */],
			imgArrayNow: [],
			imgArrayNext: []
		};
	},


	watch: {
		currentBlock: function currentBlock(val) {
			this.setPreloadAssets(val);
		}
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['loadAudio']), {
		setPreloadAssets: function setPreloadAssets(currentBlock) {
			//console.log("Preload: " + currentBlock);
			if (currentBlock == 0) this.loopThroughProperties(this.blocks[currentBlock], true);else this.imgArrayNow = this.imgArrayNext.slice();
			this.imgArrayNext = [];
			this.loopThroughProperties(this.blocks[currentBlock + 1], false);
		},
		loopThroughProperties: function loopThroughProperties(obj, current) {
			var _this = this;

			for (var propertyName in obj) {
				if (obj.hasOwnProperty(propertyName)) {

					var property = obj[propertyName];
					if (property == null) continue;

					if (propertyName == "visual") this.handleVisualByExtension(property, current);
					//if(propertyName == "background") this.handleVisualByExtension(property , current);
					if (propertyName == "intro_background") this.handleVisualByExtension(property, current);
					if (this.isArray(property)) {
						property.forEach(function (entry) {
							_this.loopThroughProperties(entry, current);
						});
					} else if (this.isObject(property)) {
						this.loopThroughProperties(property, current);
					}
				}
			}
		},
		isObject: function isObject(obj) {
			return obj === Object(obj);
		},
		isArray: function isArray(obj) {
			return obj.constructor === Array;
		},
		handleVisualByExtension: function handleVisualByExtension(visual, current) {

			var fileExtension = visual.substr(visual.lastIndexOf('.') + 1);

			switch (fileExtension.toLowerCase()) {
				case "svg":
				case "png":
				case "jpg":
				case "gif":
					if (current) {
						if (this.imgArrayNow.indexOf(visual) == -1) this.imgArrayNow.push(visual);
					} else {
						if (this.imgArrayNext.indexOf(visual) == -1) this.imgArrayNext.push(visual);
					}
					break;
			}
		}
	}),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["blocks", "currentBlock"]))

});

/***/ }),

/***/ "03eI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("+poC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1531cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("9a/C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1531cb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0iGd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__ = __webpack_require__("uQpZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import * as animationData from '../../assets/tut_tinder.json';




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__["a" /* default */]
	},

	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(function () {
				_this.setRoundState("rounds");
			}).then(function () {
				_this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": true });
			});
		}, 500);

		this.showTransitorScore(false);
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_1__const_base__["a" /* url */]
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setNextButtonAction', 'showNextButton', 'setRoundState', 'setRoundExplained', "showTransitorScore"])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['roundData', "stageData"]), {
		visualExists: function visualExists() {
			return this.roundData != null && this.roundData.questions.visual != null;
		},
		visualIsJson: function visualIsJson() {
			if (this.roundData == null || this.roundData.questions.visual == null) return false;
			var fileExtension = this.roundData.questions.visual.substr(this.roundData.questions.visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'json';
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.explanation_background + ')';
		}
	})

});

/***/ }),

/***/ "1w6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			apiUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["c" /* api_url */],
			language: __WEBPACK_IMPORTED_MODULE_3__const_base__["b" /* lang */],
			headerReady: true,
			visualReady: true,
			storyReady: true,
			showPopup: '',
			popupRound: 0,
			typeLabels: { economy: 'Economie', society: 'Mens', biosphere: 'Milieu' },
			sdgClusters: { society: [1, 2, 3, 4, 5, 7, 11, 16], economy: [8, 9, 10, 12], biosphere: [6, 13, 14, 15] }
		};
	},
	beforeMount: function beforeMount() {
		if (this.language == 'EN') {
			this.typeLabels = { economy: 'Economy', society: 'Society', biosphere: 'Biosphere' };
		}
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(_this.toNextStage).then(function () {
				_this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": false });
			});
		}, 500);

		this.showTransitorScore(true);

		this.initializeSDG();
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["showNextButton", "hideNextButton", "setNextButtonAction", "toNextStage", "stopBlockTransition", "showTransitorScore", "saveAnswerLogs"]), {
		initializeSDG: function initializeSDG() {

			console.log('sdgData');
			console.log(this.sdgData);

			var sendObj = {
				"user_id": this.userId,
				"instance_id": this.instanceId,
				"sdgData": this.sdgData
			};

			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(this.apiUrl + '/api/v2/savesdg', sendObj).then(function (response) {}).catch(function (response) {
				//console.log("Error: ");
				//console.log(response);
			});
		}
	}),

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		visualExists: function visualExists() {
			return this.stageData != null && this.stageData.visual != null;
		},
		sdgData: function sdgData() {

			console.log('compute sdgData');

			var sdgObject = {};

			sdgObject.sdgCount = {};

			for (var i = 0; i < this.blocks.length; i++) {
				var block = this.blocks[i];

				if (block.settings == null || typeof block.settings.score === 'undefined') continue;else if (block.settings.score.use != "Yes") continue;

				for (var j = 0; j < block.data_structure.length; j++) {
					var stage = block.data_structure[j];
					if (stage.type != 'Rounds') continue;

					for (var k = 0; k < stage.data.rounds.length; k++) {

						var roundData = { questions: [] };
						var round = stage.data.rounds[k];

						console.log('round');
						console.log(round);

						if (round.questions.usescore != "Yes") continue;

						//combine all found sdg's to an array as key => count
						if (typeof round.sdgs !== 'undefined') {

							for (var l = 0; l < round.sdgs.length; l++) {

								var sdgIndex = round.sdgs[l];

								if (typeof sdgObject.sdgCount[sdgIndex] === 'undefined') {

									sdgObject.sdgCount[sdgIndex] = 1;
								} else {
									sdgObject.sdgCount[sdgIndex] += 1;
								}
							}
						}
					}
				}
			}

			//sdgClusters
			sdgObject.clusters = {};
			sdgObject.sdgCountPerCluster = {};

			for (var property in this.sdgClusters) {
				if (this.sdgClusters.hasOwnProperty(property)) {

					var cluster = this.sdgClusters[property];
					var clusterCount = 0;

					sdgObject.sdgCountPerCluster[property] = {};

					for (var _j = 0; _j < cluster.length; _j++) {
						var sdgId = cluster[_j];

						if (sdgObject.sdgCount[cluster[_j]] > 0) {
							clusterCount += sdgObject.sdgCount[cluster[_j]];

							//add it to the sdgCountPerCluster object
							sdgObject.sdgCountPerCluster[property][cluster[_j]] = sdgObject.sdgCount[cluster[_j]];
						}
					}

					sdgObject.clusters[property] = clusterCount;
				}
			};

			//check the best scored SDG per cluster

			sdgObject.bestScoredSdgPerCluster = {};

			for (var _property in sdgObject.sdgCountPerCluster) {
				if (sdgObject.sdgCountPerCluster.hasOwnProperty(_property)) {

					console.log('checking ' + _property);

					sdgObject.bestScoredSdgPerCluster[_property] = 0;

					var highest = -1;
					for (var index in sdgObject.sdgCountPerCluster[_property]) {

						var sdgCount = sdgObject.sdgCountPerCluster[_property][index];

						console.log(index + '->' + sdgCount);

						if (sdgCount > highest) {
							highest = sdgCount;
							sdgObject.bestScoredSdgPerCluster[_property] = index;
						}
					}
				}
			}

			return sdgObject;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["globalSettings", "stageData", "lastStage", "blocks", "lastBlock", "transitorScore", "answerLogs", "instanceId", "userId", "userRole", "mbtiProfile", "challengeToken", "dcpProfileText"]), {

		backgroundImage: function backgroundImage() {
			if (typeof this.stageData.background === 'undefined') {
				return 'none';
			}
			return 'url(' + this.baseUrl + this.stageData.background + ')';
		}
	})
});

/***/ }),

/***/ "2bwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--multiquiz",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"multiquiz__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"flex flexColumn",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"flexHeaderContainer"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header"},[_vm._v("\n                            "+_vm._s(_vm.roundData.header)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"subHeader"},[_vm._v("\n                            "+_vm._s(_vm.questionData.subheader)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',[_vm._v(_vm._s(_vm.questionData.questiontext))])])])]),_vm._v(" "),(_vm.questionData != null)?_c('div',{staticClass:"buttonQuizContent"},[_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"shadow-box centered"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.visual}})])])]):_vm._e(),_vm._v(" "),(_vm.questionData != null)?_c('div',{staticClass:"button-conainer"},_vm._l((_vm.questionData.answers),function(answer,index){return _c('AnswerButton',{key:index,attrs:{"text":answer.answer_text,"on-click":function () {_vm.onQuestionAnswer(index)}}})})):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2ghZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bodymovin__ = __webpack_require__("Iwrh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bodymovin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bodymovin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler__ = __webpack_require__("k9Ku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_howler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__("/5sW");

//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['name', 'animationpath', 'audiopath', 'loop', 'ratio', 'autoplay', 'opacity'],
	mounted: function mounted() {
		this.initAudio();
		this.initAnimation();
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].unloadAnimation(this.name);
		__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].unloadAudio(this.name);
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			animation: null,
			sound: null
		};
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		play: function play() {
			if (!this.hasAudio) {
				if (this.animation != null) this.animation.goToAndPlay(0);
			} else if (this.animation != null && this.sound != null) {
				this.sound.play();
				this.animation.goToAndPlay(0);
			}
		},
		initAudio: function initAudio() {
			var _this = this;

			if (!this.hasAudio) return;

			__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].loadAudio(this.name, this.audiopath, function () {
				_this.sound = _this.getAudio();
				if (_this.autoplay == "false") return;
				if (_this.animation != null) {
					_this.sound.play();
					_this.animation = _this.playAnimation();
				}
			}, function () {
				console.log("Failed to load audio: " + _this.audiopath);
			});
		},
		initAnimation: function initAnimation() {
			var _this2 = this;

			__WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].loadAnimation(this.name, this.animationpath, document.getElementById(this.name), this.ratio, function () {
				_this2.animation = _this2.getAnimation();
				if (_this2.autoplay == "false") return;
				if (!_this2.hasAudio) _this2.playAnimation();else {
					if (_this2.sound != null) {
						_this2.sound = _this2.playAudio();
						_this2.animation.play();
					}
				}
			});
		},
		playAnimation: function playAnimation() {
			return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].playAnimation(this.name, { loop: this.loop == "true" });
		},
		getAnimation: function getAnimation() {
			return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].getAnimation(this.name, { loop: this.loop == "true" });
		},
		playAudio: function playAudio() {
			return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].playAudio(this.name, { loop: this.loop == "true" });
		},
		getAudio: function getAudio() {
			return __WEBPACK_IMPORTED_MODULE_5_vue__["a" /* default */].getAudio(this.name, { loop: this.loop == "true" });
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])([])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		hasAudio: function hasAudio() {
			return this.audiopath != "" && this.audiopath != undefined;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])([]))

});

/***/ }),

/***/ "2nQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_vue__ = __webpack_require__("03eI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Score: __WEBPACK_IMPORTED_MODULE_1__Score_vue__["a" /* default */],
		AnswerButton: __WEBPACK_IMPORTED_MODULE_2__Button_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			score: 0,
			answers: []
		};
	},
	mounted: function mounted() {
		this.score = 0;
		this.showTransitorScore(true);
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({

		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}

	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(["lastQuestion", "questionData", "roundData", "questionCount"])),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["completeRound", "toNextQuestion", "setRoundScore", "logAnswers", "increaseTransitorScore", "showTransitorScore", "setFeedbackData", "setUserRole"]), {
		onQuestionAnswer: function onQuestionAnswer(e) {
			var _this = this;

			this.answers.push(e);

			if (this.lastQuestion) {
				this.setRoundScore(this.score / this.questionCount * 100).then(function () {
					_this.logAnswers(_this.answers).then(function () {
						_this.setFeedbackData({
							answer: e
						}).then(function () {
							_this.completeRound().then(function () {
								_this.setUserRole(e);
							});
						});
					});
				});
			} else {
				this.toNextQuestion();
			}
		}
	})

});

/***/ }),

/***/ "3ftg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("9V5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9510d47c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("CdwQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9510d47c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3juA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gameType == 'worldquiz')?_c('World'):(_vm.gameType == 'impactcalculator')?_c('ImpactCalculator'):(_vm.gameType == 'mbtiprofile')?_c('MBTIprofile'):(_vm.gameType == 'teamrole')?_c('TeamRole'):_c('Default')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3pys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['index', 'answer', 'question', 'onClick', 'text'],

	data: function data() {
		return {};
	},
	mounted: function mounted() {},


	watch: {},

	computed: {},

	methods: {}

});

/***/ }),

/***/ "3xXr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sdg_vue__ = __webpack_require__("1w6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8868cec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sdg_vue__ = __webpack_require__("FcjQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sdg_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8868cec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sdg_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "48ih":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5JZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--intro__round",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"stage--intro__round__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container shadow-box"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.roundData.questions.intro_header)}}),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.roundData.questions.intro_subheader)}}),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.roundData.questions.intro_explanation)}})]),_vm._v(" "),(_vm.visualExists && _vm.visualIsJson)?_c('Lottie',{staticStyle:{"margin":"auto","position":"relative"},attrs:{"animationpath":_vm.baseUrl + _vm.roundData.questions.intro_visual,"name":"intro-animation","loop":"true","ratio":"meet","autoplay":"true"}}):(_vm.visualExists)?_c('div',{staticClass:"centered",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.roundData.questions.intro_visual}})]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5uXX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6J6/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['sliderValue', 'maxValue', 'stepSize', 'identifier', 'visual'],
	mounted: function mounted() {
		var self = this;

		//TODO calculate radius for smaller devices

		$('.slider').roundSlider({
			radius: 100,
			width: 10,
			max: this.maxValue,
			step: this.stepSize,
			circleShape: "pie",
			sliderType: "min-range",
			showTooltip: false,
			value: 0,
			startAngle: 316,
			handleShape: "round",
			handleSize: "+15",
			drag: function drag(data) {
				self.$emit('round-slide', data);
			},
			change: function change(data) {
				self.$emit('round-slide', data);
			}
		});
	},

	watch: {
		sliderValue: function sliderValue(val) {
			this.setValue(val);
		},

		maxValue: function maxValue(val) {
			this.setMaxValue(val);
		}
	},

	beforeDestroy: function beforeDestroy() {
		$('.slider').roundSlider('hide').roundSlider('destroy');
	},
	methods: {
		setValue: function setValue(value) {
			$('.slider').roundSlider("option", "value", value);
		},

		setMaxValue: function setMaxValue(value) {
			$('.slider').roundSlider("option", "max", value);
		}
	},
	computed: {
		addIdentifier: function addIdentifier() {
			return 'slider_' + this.identifier;
		}
	}
});

/***/ }),

/***/ "8AEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ab-quiz__button btn btn-progres ",on:{"click":_vm.onClick}},[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8CVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("f0Ze");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02791f80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("jBqf");
function injectStyle (ssrContext) {
  __webpack_require__("Zilf")
  __webpack_require__("48ih")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02791f80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02791f80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9KaW":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE0cHgiIGhlaWdodD0iMThweCIgdmlld0JveD0iMCAwIDE0IDE4IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4yICg1MTE2MCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXAgMzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJTeXN0ZWVtLW1vZHVsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyMi4wMDAwMDAsIC01NDQuMDAwMDAwKSIgc3Ryb2tlPSIjNDhEREZGIiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTI5LjAwMDAwMCwgNTUyLjAwMDAwMCkgcm90YXRlKC0xODAuMDAwMDAwKSB0cmFuc2xhdGUoLTEyOS4wMDAwMDAsIC01NTIuMDAwMDAwKSB0cmFuc2xhdGUoMTIzLjAwMDAwMCwgNTQ0LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTIiIHBvaW50cz0iMCA3IDYgMSAxMiA3Ij48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTYsMS40OTEwNzQyNyBMNiwxNS41IiBpZD0iUGF0aC00Ij48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),

/***/ "9V5l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			apiUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["c" /* api_url */],
			language: __WEBPACK_IMPORTED_MODULE_3__const_base__["b" /* lang */],
			headerReady: true,
			visualReady: true,
			storyReady: true,
			anonymous: true,
			name: '',
			surname: '',
			email: '',
			teamcode: '',
			selected: 0,
			gender: false,
			age: false,
			answers: [],
			placeHolderName: 'Naam',
			placeHolderEmail: 'E-mailadres',
			disabled_input: ''
		};
	},
	beforeMount: function beforeMount() {
		if (this.language == 'FR') {
			this.placeHolderName = 'Nom';
			this.placeHolderEmail = 'Adresse e-mail';
		} else if (this.language == 'EN') {
			this.placeHolderName = 'Name';
			this.placeHolderEmail = 'E-mailaddress';
		}
	},
	mounted: function mounted() {
		var _this = this;

		this.showTransitorScore(false);

		if (this.teamCode) {
			this.teamcode = this.teamCode;
		}

		//console.log(this.teamcode);

		if (typeof this.respondent !== 'undefined') {

			if (this.respondent !== 'false') {

				console.log('setting personal data');

				this.name = this.respondent.first_name;

				if (this.respondent.surname_prefix != '') {
					this.name = this.name + ' ' + this.respondent.surname_prefix;
				}

				if (this.respondent.surname != '') {
					this.name = this.name + ' ' + this.respondent.surname;
				}

				if (this.respondent.email != '') {
					this.email = this.respondent.email;
				}

				//find correct group

				for (var i = 0; i < this.globalGroups.length; i++) {
					if (this.respondent.company_group == this.globalGroups[i].value) {
						this.selected = this.globalGroups[i].value;
						break;
					}
				}
			}
		}

		if (this.lastStage) {
			// this.setNextButtonAction(this.stopBlockTransition).then(()=>{
			// 	this.showNextButton();
			// });
			this.setNextButtonAction(this.setAnsers);
		} else {
			this.setNextButtonAction(this.toNextStage).then(function () {
				_this.showNextButton();
			});
		}

		this.validate();

		$(document).ready(function (e) {
			$(".infoHolder__info-btn").click(function (event) {
				$(".infoHolder__txtBalloon").toggleClass("active");
				event.stopPropagation();
			});

			$(document).click(function (event) {
				if (!$(event.target).hasClass('link')) {
					$(".infoHolder__txtBalloon").removeClass("active");
				}
			});

			$(".close-btn-holder").click(function (event) {
				if (!$(event.target).hasClass('link')) {
					$(".infoHolder__txtBalloon").removeClass("active");
				}
			});
		});
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["showNextButton", "hideNextButton", "setNextButtonAction", "toNextStage", "stopBlockTransition", "showTransitorScore", "playAudio", "setTeamCode"]), {
		triggerPopup: function triggerPopup() {

			//console.log(this.anonymous);
			if (!this.anonymous) {
				$(".infoHolder__txtBalloon").toggleClass("active");
			}
		},
		validate: function validate() {

			var isValidated = true;

			//console.log(this.selected);

			if (this.selected === 0 && this.stageData.show_groups == "Yes") {
				isValidated = false;
			}

			if (!this.gender && this.stageData.show_gender == "Yes") {
				isValidated = false;
			}

			if (!this.age && this.stageData.show_age == "Yes") {
				isValidated = false;
			}

			//console.log(this.anonymous);
			if (!this.anonymous) {

				if (!this.name) {
					isValidated = false;
				}
				if (!this.email) {
					isValidated = false;
				}
			}

			if (isValidated) {
				this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": false, "btn-static": true });
			} else {
				this.hideNextButton();
			}

			if (this.anonymous) {

				//disable input fields
				$(".namefield").attr("disabled", true);
				$(".emailfield").attr("disabled", true);

				this.name = '';
				this.email = '';
			} else {

				$(".namefield").attr("disabled", false);
				$(".emailfield").attr("disabled", false);
			}

			return isValidated;
		},
		setAnsers: function setAnsers() {

			console.log('challenges_session_token: ' + this.challengeToken);

			var sendObj = {
				"user_id": this.userId,
				"instance_id": this.instanceId,
				"group": this.selected,
				"teamcode": this.teamcode,
				"gender": this.gender,
				"age": this.age,
				"name": this.name,
				"surname": this.surname,
				"email": this.email,
				"challenges_session_token": this.challengeToken
			};

			//console.log("sendObj");
			//console.log(sendObj);

			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(this.apiUrl + 'api/v2/savepersonaldata', sendObj).then(function (response) {
				//console.log(response.status);
				//console.log(response.statusText);
				//console.log(response.body);
			}).catch(function (response) {
				//console.log("Error: ");
				//console.log(response);
			});

			//this.$socket.emit('finished challenge', sendObj);

			this.setTeamCode(this.teamcode);

			// var data = {'instance_id': this.instanceId, 'client_id':this.userId, 'teamcode':this.teamcode};
			//             this.$socket.emit('join_instance', data);


			//store answers then:
			this.stopBlockTransition();
		}
	}),

	watch: {
		// whenever question changes, this function will run
		selected: function selected(newVar, oldVar) {
			this.validate();
		},
		gender: function gender(newVar, oldVar) {
			this.validate();
		},
		age: function age(newVar, oldVar) {
			this.validate();
		},
		anonymous: function anonymous(newVar, oldVar) {
			this.validate();
			this.triggerPopup();
		},
		name: function name(newVar, oldVar) {
			this.validate();
		},
		email: function email(newVar, oldVar) {
			this.validate();
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({

		backgroundImage: function backgroundImage() {

			if (typeof this.stageData.background === 'undefined' || this.stageData.background === null) {
				return 'none';
			}

			return 'url(' + this.baseUrl + this.stageData.background + ')';
		}

	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["stageData", "lastStage", "blocks", "scores", "lastBlock", "globalGroups", "instanceId", "userId", "teamCode", "respondent", "challengeToken", "instanceId", "userId"]))
});

/***/ }),

/***/ "9a/C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teamrole__button",on:{"click":_vm.onClick}},[_c('div',{staticClass:"visual"},[_c('img',{attrs:{"src":_vm.visual}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AK7e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentBlock_vue__ = __webpack_require__("UPRX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6908e3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentBlock_vue__ = __webpack_require__("yFxA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContentBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a6908e3c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContentBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B/ky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__world_Index_vue__ = __webpack_require__("RCas");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__impactcalculator_Index_vue__ = __webpack_require__("a9mt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mbtiprofile_Index_vue__ = __webpack_require__("XM2U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__teamrole_Index_vue__ = __webpack_require__("K/7s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__default_Index_vue__ = __webpack_require__("nU93");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Default: __WEBPACK_IMPORTED_MODULE_5__default_Index_vue__["a" /* default */],
		World: __WEBPACK_IMPORTED_MODULE_1__world_Index_vue__["a" /* default */],
		ImpactCalculator: __WEBPACK_IMPORTED_MODULE_2__impactcalculator_Index_vue__["a" /* default */],
		MBTIprofile: __WEBPACK_IMPORTED_MODULE_3__mbtiprofile_Index_vue__["a" /* default */],
		TeamRole: __WEBPACK_IMPORTED_MODULE_4__teamrole_Index_vue__["a" /* default */]
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		gameType: function gameType() {
			return this.roundData.gametype;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* mapGetters */])(['roundData']))

});

/***/ }),

/***/ "B6uW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--teamrole",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"multiquiz__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"flex flexColumn",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"flexHeaderContainer"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header"},[_vm._v("\n                            "+_vm._s(_vm.questionData.header)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"subHeader"},[_vm._v("\n                            "+_vm._s(_vm.questionData.subheader)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.questionData.questiontext))])])]),_vm._v(" "),(_vm.questionData != null)?_c('div',{staticClass:"buttonQuizContent"},[_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"shadow-box centered"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.visual}})])])]):_vm._e(),_vm._v(" "),(_vm.questionData != null)?_c('div',{staticClass:"button-conainer"},_vm._l((_vm.questionData.answers),function(answer,index){return _c('AnswerButton',{key:index,attrs:{"title":answer.title,"text":answer.answer_text,"visual":_vm.baseUrl + answer.visual,"on-click":function () {_vm.onQuestionAnswer(index)}}})})):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CKXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        data: null,
        gametype: "",
        score: 0,
        currentQuestion: 0,
        questionCount: 0,
        //completed: false,
        //explained: false,
        feedbackData: {},
        state: "intro" // intro, explanation, round, feedback
    },
    mutations: {
        initiateRound: function initiateRound(state) {
            state.state = "intro";
            state.currentQuestion = 0;
        },
        setRoundState: function setRoundState(state, roundState) {
            state.state = roundState;
        },
        setCurrentQuestion: function setCurrentQuestion(state, int) {
            state.currentQuestion = int;
        },
        setRoundData: function setRoundData(state, data) {
            state.data = data;
            state.questionCount = state.data == null || state.data.questions == null ? 0 : state.data.questions.questions.length;
            state.gametype = data == null || data.gametype == null ? "" : data.gametype;
            state.score = 0;
        },
        incrementScore: function incrementScore(state) {
            state.score++;
        },
        setRoundScore: function setRoundScore(state, score) {
            state.score = score;
        },
        setFeedbackData: function setFeedbackData(state, data) {
            state.feedbackData = data;
        }
    },
    actions: {
        addRoundScore: function addRoundScore(store) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("incrementScore");
                resolve();
            });
        },
        setRoundScore: function setRoundScore(store, score) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setRoundScore", score);
                resolve();
            });
        },
        setRoundData: function setRoundData(store, data) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("initiateRound");
                store.commit("setRoundData", data);
                if (data != null) {

                    console.log('setRoundData: hide_intro:');
                    console.log(data.questions.hide_intro);

                    if (data.questions.hide_intro == "Yes") {
                        if (data.questions.hide_explanation == "Yes" || data.questions.hide_explanation == "Popup") {
                            store.commit("setRoundState", "round");
                        } else {
                            store.commit("setRoundState", "explanation");
                        }
                    }
                }
                resolve();
            });
        },
        setRoundState: function setRoundState(store, state) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setRoundState", state);
                resolve();
            });
        },
        toNextQuestion: function toNextQuestion(store) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setCurrentQuestion", store.state.currentQuestion + 1);
                resolve();
            });
        },
        toPreviousQuestion: function toPreviousQuestion(store) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setCurrentQuestion", store.state.currentQuestion - 1);
                resolve();
            });
        },
        completeRound: function completeRound(store, data) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                if (store.state.data != null && store.state.data.hide_feedback == "Yes") {
                    var lastRound = store.getters.lastRound;
                    if (lastRound) store.dispatch("toNextStage");else store.dispatch("toNextRound");
                } else store.commit("setRoundState", "feedback");
                resolve();
            });
        },
        setFeedbackData: function setFeedbackData(store, data) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setFeedbackData", data);
                resolve();
            });
        }
    },
    getters: {
        roundScore: function roundScore(state) {
            return state.score;
        },
        roundState: function roundState(state) {
            return state.state;
        },
        questionData: function questionData(state) {
            if (state.data == undefined || state.data.questions == undefined || state.data.questions.questions.length == 0) return null;

            // console.log('ROUND JS questionData');

            // console.log(state.data.questions.questions[state.currentQuestion]);
            // console.log(state.currentQuestion+' of '+state.questionCount);

            return state.data.questions.questions[state.currentQuestion];
        },
        roundData: function roundData(state) {
            return state.data;
        },
        currentQuestion: function currentQuestion(state) {
            return state.currentQuestion;
        },
        questionCount: function questionCount(state) {
            return state.questionCount;
        },
        lastQuestion: function lastQuestion(state) {
            return state.currentQuestion >= state.questionCount - 1;
        },
        roundType: function roundType(state) {
            return state.gametype;
        },
        feedbackData: function feedbackData(state) {
            return state.feedbackData;
        }
    }
});

/***/ }),

/***/ "CdwQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--personalia",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"personalia-form"},[(_vm.stageData.show_teamcode == 'Yes')?_c('form',{staticStyle:{"position":"relative"}},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.stageData.teamcode_text)}}),_vm._v(" "),_c('div',{staticClass:"form-section"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.teamcode),expression:"teamcode"}],staticClass:"textfield",attrs:{"type":"text","placeholder":"Teamcode"},domProps:{"value":(_vm.teamcode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.teamcode=$event.target.value}}})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"header__container header__container-personalia"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.header)}},[_c('h2',[_vm._v("doe je mee?")])]),_vm._v(" "),_c('div',{staticClass:"subHeader",domProps:{"innerHTML":_vm._s(_vm.stageData.subheader)}}),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.stageData.text)}})]),_vm._v(" "),_c('form',{staticStyle:{"position":"relative"}},[(_vm.stageData.show_groups == 'Yes')?_c('div',{staticClass:"form-section"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticStyle:{"margin-bottom":"0"},attrs:{"placeholder":"Groep"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("\n\t\t\t\t\t\t\tGroep\n\t\t\t\t\t\t")]),_vm._v(" "),_vm._l((_vm.globalGroups),function(data,i){return _c('option',{key:i,domProps:{"value":data.value}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(data.name)+"\n\t\t\t\t\t\t")])})],2)]):_vm._e(),_vm._v(" "),(_vm.stageData.show_age == 'Yes')?_c('div',{staticClass:"form-section"},[(_vm.language == 'NL')?_c('p',[_vm._v("Leeftijdscategorie")]):(_vm.language == 'FR')?_c('p',[_vm._v("l'âge")]):_c('p',[_vm._v("Age")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.age),expression:"age"}],staticStyle:{"margin-bottom":"0"},attrs:{"placeholder":"Leeftijd"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.age=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"age_1"}},[_vm._v("\n\t\t\t\t\t\t\t< 20\n\t\t\t\t\t\t")]),_vm._v(" "),_c('option',{attrs:{"value":"age_2"}},[_vm._v("\n\t\t\t\t\t\t\t20-30\n\t\t\t\t\t\t")]),_vm._v(" "),_c('option',{attrs:{"value":"age_3"}},[_vm._v("\n\t\t\t\t\t\t\t31-40\n\t\t\t\t\t\t")]),_vm._v(" "),_c('option',{attrs:{"value":"age_4"}},[_vm._v("\n\t\t\t\t\t\t\t41-50\n\t\t\t\t\t\t")]),_vm._v(" "),_c('option',{attrs:{"value":"age_5"}},[_vm._v("\n\t\t\t\t\t\t\t51-60\n\t\t\t\t\t\t")]),_vm._v(" "),_c('option',{attrs:{"value":"age_6"}},[_vm._v("\n\t\t\t\t\t\t\t61+\n\t\t\t\t\t\t")])])]):_vm._e(),_vm._v(" "),(_vm.stageData.show_gender == 'Yes')?_c('div',{staticClass:"form-section"},[(_vm.language == 'NL')?_c('p',[_vm._v("ik ben een...")]):(_vm.language == 'FR')?_c('p',[_vm._v("je suis un...")]):_c('p',[_vm._v("I'm")]),_vm._v(" "),_c('div',{staticClass:"radio-border"},[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","value":"female"},domProps:{"checked":_vm._q(_vm.gender,"female")},on:{"change":function($event){_vm.gender="female"}}}),_vm._v(" "),(_vm.language == 'NL')?_c('span',[_vm._v("Vrouw")]):(_vm.language == 'FR')?_c('span',[_vm._v("femme")]):_c('span',[_vm._v("Female")])])]),_vm._v(" "),_c('div',{staticClass:"radio-border"},[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","value":"male"},domProps:{"checked":_vm._q(_vm.gender,"male")},on:{"change":function($event){_vm.gender="male"}}}),_vm._v(" "),(_vm.language == 'NL')?_c('span',[_vm._v("Man")]):(_vm.language == 'FR')?_c('span',[_vm._v("homme")]):_c('span',[_vm._v("Male")])])]),_vm._v(" "),_c('div',{staticClass:"radio-border"},[_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gender),expression:"gender"}],attrs:{"type":"radio","value":"other"},domProps:{"checked":_vm._q(_vm.gender,"other")},on:{"change":function($event){_vm.gender="other"}}}),_vm._v(" "),(_vm.language == 'NL')?_c('span',[_vm._v("Anders")]):(_vm.language == 'FR')?_c('span',[_vm._v("autrement")]):_c('span',[_vm._v("Other")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-section last"},[(_vm.language == 'NL')?_c('p',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("Jouw gegevens (optioneel)")]):(_vm.language == 'FR')?_c('p',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("Vos données (facultatif)")]):_c('p',{staticStyle:{"margin-bottom":"5px"}},[_vm._v("Your data (optional)")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.anonymous),expression:"anonymous"}],staticStyle:{"float":"left"},attrs:{"type":"checkbox","checked":"checked"},domProps:{"checked":Array.isArray(_vm.anonymous)?_vm._i(_vm.anonymous,null)>-1:(_vm.anonymous)},on:{"change":function($event){var $$a=_vm.anonymous,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.anonymous=$$a.concat([$$v]))}else{$$i>-1&&(_vm.anonymous=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.anonymous=$$c}}}}),_vm._v(" "),(_vm.language == 'NL')?_c('span',{staticStyle:{"float":"left","margin-left":"5px"}},[_vm._v("Ik speel anoniem")]):(_vm.language == 'FR')?_c('span',{staticStyle:{"float":"left","margin-left":"5px"}},[_vm._v("Je joue anonymement")]):_c('span',{staticStyle:{"float":"left","margin-left":"5px"}},[_vm._v("I'll stay anonymous")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"textfield namefield",attrs:{"type":"text","placeholder":_vm.placeHolderName},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"textfield emailfield",attrs:{"type":"text","placeholder":_vm.placeHolderEmail},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"infoHolder"},[(_vm.language == 'NL')?_c('div',{staticClass:"infoHolder__txtBalloon"},[_c('h3',[_vm._v("Belangrijk! Lees deze privacy informatie goed.")]),_vm._v(" "),_c('h4',[_vm._v("Jouw privacy")]),_vm._v(" "),_c('p',[_vm._v("Jij bepaalt zelf of jouw spelresultaat aan jouw persoon is gekoppeld.")]),_vm._v(" "),_c('h4',[_vm._v("Je speelt standaard anoniem.")]),_vm._v(" "),_c('p',[_vm._v("Het vinkje staat aan. Je kunt geen e-mailadres of naam achterlaten. Zodra je het spel verlaat kan jouw spelresultaat nooit meer aan jouw persoon gekoppeld worden. De data is geanonimiseerd.")]),_vm._v(" "),_c('h4',[_vm._v("Koppeling met je e-mailadres en naam")]),_vm._v(" "),_c('p',[_vm._v("Zet je het vinkje uit, dan kun je je naam en e-mailadres invullen. One Future Play zorgt voor beveiligde koppeling tussen jouw persoonsgegevens en je spelresultaat. Daarover ontvang je een e-mail.")]),_vm._v(" "),_c('p',[_vm._v("Jij bepaalt zelf wie deze koppeling mag bekijken. Alleen jij, je team of je werkgever.")]),_vm._v(" "),_vm._m(0,false,false)]):(_vm.language == 'FR')?_c('div',{staticClass:"infoHolder__txtBalloon"},[_c('h3',[_vm._v("Belangrijk! Lees deze privacy informatie goed.")]),_vm._v(" "),_c('h4',[_vm._v("Jouw privacy")]),_vm._v(" "),_c('p',[_vm._v("Jij bepaalt zelf of jouw spelresultaat aan jouw persoon is gekoppeld.")]),_vm._v(" "),_c('h4',[_vm._v("Je speelt standaard anoniem.")]),_vm._v(" "),_c('p',[_vm._v("Het vinkje staat aan. Je kunt geen e-mailadres of naam achterlaten. Zodra je het spel verlaat kan jouw spelresultaat nooit meer aan jouw persoon gekoppeld worden. De data is geanonimiseerd.")]),_vm._v(" "),_c('h4',[_vm._v("Koppeling met je e-mailadres en naam")]),_vm._v(" "),_c('p',[_vm._v("Zet je het vinkje uit, dan kun je je naam en e-mailadres invullen. One Future Play zorgt voor beveiligde koppeling tussen jouw persoonsgegevens en je spelresultaat. Daarover ontvang je een e-mail.")]),_vm._v(" "),_c('p',[_vm._v("Jij bepaalt zelf wie deze koppeling mag bekijken. Alleen jij, je team of je werkgever.")]),_vm._v(" "),_vm._m(1,false,false)]):_c('div',{staticClass:"infoHolder__txtBalloon"},[_c('h3',[_vm._v("Important! Read this privacy information carefully.")]),_vm._v(" "),_c('h4',[_vm._v("Jouw privacy")]),_vm._v(" "),_c('p',[_vm._v("Jij bepaalt zelf of jouw spelresultaat aan jouw persoon is gekoppeld.")]),_vm._v(" "),_c('h4',[_vm._v("Je speelt standaard anoniem.")]),_vm._v(" "),_c('p',[_vm._v("Het vinkje staat aan. Je kunt geen e-mailadres of naam achterlaten. Zodra je het spel verlaat kan jouw spelresultaat nooit meer aan jouw persoon gekoppeld worden. De data is geanonimiseerd.")]),_vm._v(" "),_c('h4',[_vm._v("Koppeling met je e-mailadres en naam")]),_vm._v(" "),_c('p',[_vm._v("Zet je het vinkje uit, dan kun je je naam en e-mailadres invullen. One Future Play zorgt voor beveiligde koppeling tussen jouw persoonsgegevens en je spelresultaat. Daarover ontvang je een e-mail.")]),_vm._v(" "),_c('p',[_vm._v("Jij bepaalt zelf wie deze koppeling mag bekijken. Alleen jij, je team of je werkgever.")]),_vm._v(" "),_vm._m(2,false,false)]),_vm._v(" "),_vm._m(3,false,false)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-btn-holder"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-btn-holder"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-btn-holder"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"infoHolder__info-btn"},[_c('span',[_vm._v("i")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DEP7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__const_base__ = __webpack_require__("PY/H");
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	props: ['header', 'subHeader', 'bodytext'],

	components: {},

	mounted: function mounted() {},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_0__const_base__["a" /* url */]
		};
	},

	methods: {},
	computed: {}

});

/***/ }),

/***/ "DNWK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("WJ8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1555d16e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Z71r");
function injectStyle (ssrContext) {
  __webpack_require__("agtp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1555d16e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DV0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("KfJq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebbfb80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Mjyq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ebbfb80_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DWO9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Lottie_vue__ = __webpack_require__("uQpZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_0__Lottie_vue__["a" /* default */]
	},

	props: ['onClick', 'header', 'text', 'visual'],

	data: function data() {
		return {};
	},
	mounted: function mounted() {},


	watch: {},

	computed: {},

	methods: {
		visualExists: function visualExists() {
			return this.visual != null;
		},
		visualIsJson: function visualIsJson() {
			if (this.visual == null) return false;
			var fileExtension = this.visual.substr(this.visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'json';
		}
	}

});

/***/ }),

/***/ "EJor":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cutscene-animation",style:({'opacity':_vm.opacity}),attrs:{"id":_vm.name}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EcAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("PD0Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002fbd2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("IV49");
function injectStyle (ssrContext) {
  __webpack_require__("5uXX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-002fbd2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_002fbd2b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EvVh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundIntro_vue__ = __webpack_require__("tf2C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d5dfc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundIntro_vue__ = __webpack_require__("5JZT");
function injectStyle (ssrContext) {
  __webpack_require__("SRch")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19d5dfc2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundIntro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19d5dfc2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundIntro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FYtz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Explanation_vue__ = __webpack_require__("0iGd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1038921b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Explanation_vue__ = __webpack_require__("vQ2g");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Explanation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1038921b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Explanation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FcjQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--dcpSdg block_dcp",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.header)}})]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.stageData.story)}}),_vm._v(" "),_c('div',{staticClass:"clusters"},_vm._l((_vm.sdgData.clusters),function(cluster,index){return _c('div',{staticClass:"sdg-cluster"},[_c('img',{attrs:{"src":_vm.baseUrl+'media/instances/33/SDGs/Inverted/INVERTED SDG goals_icons-individual-cmyk-'+_vm.sdgData.bestScoredSdgPerCluster[index]+'.svg'}}),_vm._v("\n\n\t\t\t\t"+_vm._s(_vm.typeLabels[index])+"\n\t\t\t")])}))]),_vm._v(" "),(_vm.visualExists)?_c('div',{staticClass:"centered",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.stageData.visual}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GIBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Iow/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c309fc20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("txUV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c309fc20_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GN6Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			apiUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["c" /* api_url */],
			language: __WEBPACK_IMPORTED_MODULE_3__const_base__["b" /* lang */],
			headerReady: true,
			visualReady: true,
			storyReady: true,
			showPopup: '',
			popupRound: 0,
			dcpText: '',
			teamDcpText: '',
			yesNoLabels: { No: 'Nee', Yes: 'Ja' },
			typeLabels: { Bewustzijn: 'Bewustzijn', Kennis: 'Kennis', Skills: 'Vaardigheid', Waarden: 'Waarden', SDG: 'SDG`s' },
			roundLabel: 'Ronde',
			questionLabel: 'Vraag',
			yourAnswerLabel: 'Jouw antwoord',
			correctAnswerLabel: 'Gewenste antwoord',
			nextLabel: 'Volgende',
			previousLabel: 'Vorige',
			sdgClusters: { economy: [8, 9, 10, 12], society: [1, 2, 3, 4, 5, 7, 11, 16], biosphere: [6, 13, 14, 15] }
		};
	},
	beforeMount: function beforeMount() {
		if (this.language == 'EN') {
			this.typeLabels = { Bewustzijn: 'Awareness', Kennis: 'Knowledge', Skills: 'Skills', Waarden: 'Values' }, this.yesNoLabels = { No: 'No', Yes: 'Yes' };
			this.roundLabel = 'Round';
			this.questionLabel = 'Question';
			this.nextLabel = 'Next';
			this.previousLabel = 'Previous';
			this.yourAnswerLabel = 'Your answer';
			this.correctAnswerLabel = 'Correct answer';
		}
	},
	mounted: function mounted() {

		this.showTransitorScore(true);
		this.initializeDCP();
		//this.saveAnswerLogs();


		// console.log('dcpData');
		// console.log(this.dcpData);
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["showNextButton", "hideNextButton", "setNextButtonAction", "toNextStage", "stopBlockTransition", "showTransitorScore", "saveAnswerLogs"]), {
		setPopup: function setPopup(label) {
			this.setPopupRound(0);
			this.showPopup = label;

			this.showTransitorScore(false);
		},
		setPopupRound: function setPopupRound(round) {
			this.popupRound = round;
			$('.one-time').slick('unslick');
			setTimeout(function () {
				$('.one-time').slick({
					dots: false,
					infinite: true,
					speed: 300,
					slidesToShow: 1,
					adaptiveHeight: true,
					arrows: true,
					nextArrow: $('.js-slick-next'),
					prevArrow: $('.js-slick-prev')
				});
			}, 10);
		},
		togglePopup: function togglePopup() {
			if (this.showPopup != '') {
				this.showPopup = '';
				setTimeout(function () {
					$('.one-time').slick({
						dots: true,
						infinite: true,
						speed: 300,
						slidesToShow: 1,
						adaptiveHeight: true,
						arrows: true,
						nextArrow: $('.js-slick-next'),
						prevArrow: $('.js-slick-prev')
					});
				}, 10);

				this.showTransitorScore(true);
			}
		},
		toDcpObject: function toDcpObject(data, dataType, renderer) {
			var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

			return {
				data: data,
				dataType: dataType,
				renderer: renderer,
				options: options
			};
		},
		renderer: function renderer(type, options) {
			return {
				type: type,
				options: options
			};
		},
		initializeDCP: function initializeDCP() {
			var _this = this;

			var WW = $('.finalization__content').width() * 0.8;
			var WH = WW + 60;

			//user DCP
			var player_el = document.getElementById('player');
			var player = bonsai.run(player_el, {
				url: this.baseUrl + 'js/dcp/dcp.js?12',
				height: WW + 60,
				width: WW,
				framerate: 50
			});

			//Group DCP
			var group_el = document.getElementById('group_dcp');
			var group = bonsai.run(group_el, {
				url: this.baseUrl + 'js/dcp/dcp.js?12',
				height: WW + 60,
				width: WW,
				framerate: 50
			});

			var data = this.dcpData;

			// console.log('dcpData');
			// console.log(data);

			//console.log(this.globalSettings.dcp.awareness.label);


			var scoresTotal = {},
			    scores = {};

			for (var property in data) {
				if (!scores.hasOwnProperty(property)) scores[property] = [];
				if (!scoresTotal.hasOwnProperty(property)) scoresTotal[property] = 0;
				if (data.hasOwnProperty(property)) {
					var obj = data[property];
					for (var i = 0; i < obj.rounds.length; i++) {
						var round = obj.rounds[i];

						// console.log('round');
						// console.log(round);

						scoresTotal[property] += round.score / obj.rounds.length;
						scores[property].push(round.score);
					}
				}
			}

			console.log('scores for pokeball');

			console.log(scores);

			var centerPiece = 'Waarden';

			if (typeof scores.SDG !== 'undefined') {

				//make average
				var avgWaarden = 0;

				for (var _i = 0; _i < scores.SDG.length; _i++) {
					avgWaarden += scores.SDG[_i];
				}

				scores.Waarden = [avgWaarden / scores.SDG.length];

				centerPiece = 'SDG';
			}

			var dcpObjectData = {
				data: [this.toDcpObject(scores.hasOwnProperty('Bewustzijn') ? scores.Bewustzijn : [], 'pie-chart', this.renderer('slice', {
					color: "#6894a0", //Color of data visualization background
					stroke: { // Can be removed for no stroke drawing
						color: "#fff", //color of stroke around value visualization
						width: 2 // width of stroke around value visualization
					}
				}), {
					name: 'Bewustzijn', //Part off the datastream we want to show
					display_name: this.globalSettings.dcp.awareness.label, //Label text
					color: "#8DCBDB" //Background color of pie-chart background
				}), this.toDcpObject(scores.hasOwnProperty('Kennis') ? scores.Kennis : [], 'pie-chart', this.renderer('point', {
					color: "#8d1d1d", //Color of data visualization background
					stroke: { // Can be removed for no stroke drawing
						color: "#fff", //color of stroke around value visualization
						width: 2 // width of stroke around value visualization
					}
				}), {
					name: 'Kennis', //Label text
					display_name: this.globalSettings.dcp.knowledge.label, //Label text
					color: "#bc3030" //Background color of pie-chart background
				}), this.toDcpObject(scores.hasOwnProperty('Skills') ? scores.Skills : [], 'pie-chart', this.renderer('slice', {
					color: "#629451", //Color of data visualization background
					stroke: { // Can be removed for no stroke drawing
						color: "#fff", //color of stroke around value visualization
						width: 2 // width of stroke around value visualization
					}
				}), {
					name: 'Skills', //Part off the datastream we want to show
					display_name: this.globalSettings.dcp.skills.label, //Label text
					color: "#9bc18e" //Background color of pie-chart background
				}),
				//----------------------------------------- can be stars
				this.toDcpObject(scores.hasOwnProperty('Waarden') ? scores.Waarden : [], 'center-piece', this.renderer('stars', {
					color: "#ff9933", // color of background star container
					minRadius: 20, // begin radius of star container
					radiusEdge: 5, // how much edge there will be at score of 100
					fontColor: "#fff",
					fontSize: 14,
					star: {
						color: "#fff", // star color
						size: 7, // star size
						dist: 8 // star distance from center
					},
					stroke: {
						color: "#ff9933", // color of stroke background star container
						width: 0 // width of stroke background star container
					}
				}), {
					name: centerPiece, //Part off the datastream we want to show
					display_name: this.globalSettings.dcp.values.label, //Label text
					color: "#ffbf80", //Background color of pie-chart background
					radius: 30, // radius of center-piece container
					stroke: { // Can be removed for no stroke drawing
						color: "#fff", // color of stroke background center-piece container
						width: 2 // width of stroke background center-piece container
					},
					label: {
						color: "#ff9933", //background color of name label
						width: 110, //width of name label in pixels
						height: 30, // height of name label in pixels
						fontColor: "#fff", //color of label
						fontSize: 14, //fontsize of label
						rounded: 10 //Roundness of background
					}
				})],
				options: {
					offset: -45, //angle offset of the pie-chart
					width: WW, //width of canvas
					height: WH, // height of canvas
					radius: WW / 2 - 20, //radius of pie
					animate: true,
					animation: {
						delay: 0, // initial delay of the animation
						slice: {
							delay: 15, //delay for each slice
							duration: 10, //duration of slice anim
							data: {
								initialDelay: 60, //inital delay of the data anim of slice
								delay: 15, //delay for each data value
								duration: 25 //duration of each data value
							}
						}
					},
					text: {
						family: "sans" //font family
					},
					label: {
						score: {
							radius: 14, //radius of score label container
							stroke: { // Can be removed for no stroke drawing
								color: "#fff", // color of stroke background center-piece container
								width: 2 // width of stroke background center-piece container
							},
							fontSize: 14, //size of text
							fontColor: "#ffffff" //color of text
						},
						name: {
							offset: 15, //how much the background comes outside the pie
							height: 30, //Height of background
							width: 100, //Width of background
							widthPerLetter: 8, //Width per letter (takes over from width if defined)
							fontSize: 14, //Size of text
							fontColor: "#fff" //Color of text
						}

					},
					stroke: {
						color: "#fff",
						width: 5
					}
				}
			};

			var self = this;
			player.on('message', function (data) {
				if (data == "ready") {
					player.sendMessage(dcpObjectData);
				} else {
					if (self.showPopup == '') {

						self.setPopupRound(0);
						self.showPopup = data;

						self.showTransitorScore(false);
					}
				}
			});

			// {
			// 			awarenessPointsTotal: scoresTotal.hasOwnProperty('Bewustzijn') ? scoresTotal.Bewustzijn : 0,
			// 			awarenessPoints: scores.hasOwnProperty('Bewustzijn') ? scores.Bewustzijn : [],
			// 			awarenessFeedback:"",
			// 			kennisPointsTotal: scoresTotal.hasOwnProperty('Kennis') ? scoresTotal.Kennis : 0,
			// 			kennisPoints: scores.hasOwnProperty('Kennis') ? scores.Kennis : [],
			// 			kennisFeedback: "",
			// 			skillPointsTotal: scoresTotal.hasOwnProperty('Skills') ? scoresTotal.Skills : 0,
			// 			skillPoints: scores.hasOwnProperty('Skills') ? scores.Skills : [0,0],
			// 			skillFeedback: "",
			// 			waardenPointsTotal: scoresTotal.hasOwnProperty('Waarden') ? scoresTotal.Waarden : 0,
			// 			waardenPoints: scores.hasOwnProperty('Waarden') ? scores.Waarden : [],
			// 			waardenFeedback: "",
			// 			mbti: self.mbtiProfile,
			// 			ww: WW,
			// 			wh: WH
			// 		}


			// console.log('userRole');
			// console.log(this.userRole);

			// console.log('mbtiProfile');
			// console.log(this.mbtiProfile.trueColorClassification[2]);


			//build dcp profile text
			var dcpTextObj = this.dcpProfileText;
			var parts = '';
			for (var key in dcpTextObj) {

				var myText = '';

				if (typeof dcpTextObj[key][0] !== 'undefined') {
					myText = dcpTextObj[key][0].text;
				}

				//loop over dcp part text to find the right one
				for (var _i2 = 0; _i2 < dcpTextObj[key].length; _i2++) {

					// console.log('scoresTotal');
					// console.log(scoresTotal[key]);

					if (scoresTotal[key] >= dcpTextObj[key][_i2].breakpoint) {
						myText = dcpTextObj[key][_i2].text;
					}
				}
				parts += myText + ' ';
			}

			this.dcpText = parts;

			// console.log('dcp profile text');
			// console.log(this.dcpText);

			var sendObj = {
				"user_id": this.userId,
				"instance_id": this.instanceId,
				"pointsjson": scores,
				"transitorScore": this.transitorScore,
				"role": this.userRole,
				"mbti": this.mbtiProfile,
				"challenges_session_token": this.challengeToken,
				"dcp_profile_text": this.dcpText
			};

			// console.log('challengeToken: '+this.challengeToken);

			if (this.challengeToken) {
				this.$socket.emit('finished challenge', sendObj);
			}

			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(this.apiUrl + '/api/v2/savescore', sendObj).then(function (response) {
				//console.log(response.status);
				//console.log("lol");
				//console.log(response.statusText);
				//console.log(response.body);


				var avgScores = response.body.points.dcp;
				var avgScoresTotal = response.body.points.avg;

				// console.log('group dcp data');
				// console.log(avgScores);

				var groupdcpObjectData = {
					data: [_this.toDcpObject(avgScores.hasOwnProperty('Bewustzijn') ? avgScores.Bewustzijn : [], 'pie-chart', _this.renderer('slice', {
						color: "#6894a0", //Color of data visualization background
						stroke: { // Can be removed for no stroke drawing
							color: "#fff", //color of stroke around value visualization
							width: 2 // width of stroke around value visualization
						}
					}), {
						name: "Bewustzijn", //Part text
						display_name: "Bewustzijn", //Label text
						color: "#8DCBDB" //Background color of pie-chart background
					}), _this.toDcpObject(avgScores.hasOwnProperty('Kennis') ? avgScores.Kennis : [], 'pie-chart', _this.renderer('point', {
						color: "#8d1d1d", //Color of data visualization background
						stroke: { // Can be removed for no stroke drawing
							color: "#fff", //color of stroke around value visualization
							width: 2 // width of stroke around value visualization
						}
					}), {
						name: "Kennis", //Part text
						display_name: "Kennis", //Label text
						color: "#bc3030" //Background color of pie-chart background
					}), _this.toDcpObject(avgScores.hasOwnProperty('Skills') ? avgScores.Skills : [], 'pie-chart', _this.renderer('slice', {
						color: "#629451", //Color of data visualization background
						stroke: { // Can be removed for no stroke drawing
							color: "#fff", //color of stroke around value visualization
							width: 2 // width of stroke around value visualization
						}
					}), {
						name: "Skills", //Part text
						display_name: "Vaardigheid", //Label text
						color: "#9bc18e" //Background color of pie-chart background
					}),
					//----------------------------------------- can be stars
					_this.toDcpObject(avgScores.hasOwnProperty('Waarden') ? avgScores.Waarden : [], 'center-piece', _this.renderer('stars', {
						color: "#ff9933", // color of background star container
						minRadius: 20, // begin radius of star container
						radiusEdge: 5, // how much edge there will be at score of 100
						fontColor: "#fff",
						fontSize: 14,
						star: {
							color: "#fff", // star color
							size: 7, // star size
							dist: 8 // star distance from center
						},
						stroke: {
							color: "#ff9933", // color of stroke background star container
							width: 0 // width of stroke background star container
						}
					}), {
						name: "Waarden", //Label text
						display_name: "Waarden", //Label text
						color: "#ffbf80", //Background color of pie-chart background
						radius: 30, // radius of center-piece container
						stroke: { // Can be removed for no stroke drawing
							color: "#fff", // color of stroke background center-piece container
							width: 2 // width of stroke background center-piece container
						},
						label: {
							color: "#ff9933", //background color of name label
							width: 110, //width of name label in pixels
							height: 30, // height of name label in pixels
							fontColor: "#fff", //color of label
							fontSize: 14, //fontsize of label
							rounded: 10 //Roundness of background
						}
					})],
					options: {
						offset: -45, //angle offset of the pie-chart
						width: WW, //width of canvas
						height: WH, // height of canvas
						radius: WW / 2 - 20, //radius of pie
						animate: true,
						animation: {
							delay: 0, // initial delay of the animation
							slice: {
								delay: 15, //delay for each slice
								duration: 10, //duration of slice anim
								data: {
									initialDelay: 60, //inital delay of the data anim of slice
									delay: 15, //delay for each data value
									duration: 25 //duration of each data value
								}
							}
						},
						text: {
							family: "sans" //font family
						},
						label: {
							score: {
								radius: 14, //radius of score label container
								stroke: { // Can be removed for no stroke drawing
									color: "#fff", // color of stroke background center-piece container
									width: 2 // width of stroke background center-piece container
								},
								fontSize: 14, //size of text
								fontColor: "#ffffff" //color of text
							},
							name: {
								offset: 15, //how much the background comes outside the pie
								height: 30, //Height of background
								width: 100, //Width of background
								widthPerLetter: 8, //Width per letter (takes over from width if defined)
								fontSize: 14, //Size of text
								fontColor: "#fff" //Color of text
							}

						},
						stroke: {
							color: "#fff",
							width: 5
						}
					}
				};

				group.sendMessage(groupdcpObjectData);

				// {
				// 	awarenessPointsTotal: avgScoresTotal.hasOwnProperty('Bewustzijn') ? avgScoresTotal.Bewustzijn : 0,
				// 	awarenessPoints: avgScores.hasOwnProperty('Bewustzijn') ? avgScores.Bewustzijn : [],
				// 	awarenessFeedback:"",
				// 	kennisPointsTotal: avgScoresTotal.hasOwnProperty('Kennis') ? avgScoresTotal.Kennis : 0,
				// 	kennisPoints: avgScores.hasOwnProperty('Kennis') ? avgScores.Kennis : [],
				// 	kennisFeedback: "",
				// 	skillPointsTotal: avgScoresTotal.hasOwnProperty('Skills') ? avgScoresTotal.Skills : 0,
				// 	skillPoints: avgScores.hasOwnProperty('Skills') ? avgScores.Skills : [0,0],
				// 	skillFeedback: "",
				// 	waardenPointsTotal: avgScoresTotal.hasOwnProperty('Waarden') ? avgScoresTotal.Waarden : 0,
				// 	waardenPoints: avgScores.hasOwnProperty('Waarden') ? avgScores.Waarden : [],
				// 	waardenFeedback: "",
				// 	ww: WW,
				// 	wh: WH
				// }


				var dcpTextObj = _this.dcpProfileText;
				// let parts = '';
				// for(var key in dcpTextObj) {

				// 	let myText = dcpTextObj[key][0].text;
				// 	//loop over dcp part text to find the right one
				// 	for (let i = 0; i < dcpTextObj[key].length; i++){


				// 		//console.log(scoresTotal[key]);

				// 		if(scoresTotal[key] >= dcpTextObj[key][i].breakpoint){
				// 			myText = dcpTextObj[key][i].text;
				// 		}
				// 	}
				// 	parts += myText+' ';
				// }

				// this.dcpText = parts;

				// console.log('dcp profile text');

				// console.log(this.dcpText);


				var teamParts = '';
				for (var key in dcpTextObj) {

					//console.log(key);

					var _myText = '';

					if (typeof dcpTextObj[key][0] !== 'undefined') {
						_myText = dcpTextObj[key][0].text;
					}

					//loop over dcp part text to find the right one
					for (var _i3 = 0; _i3 < dcpTextObj[key].length; _i3++) {

						// console.log(avgScoresTotal[key]);

						if (avgScoresTotal[key] >= dcpTextObj[key][_i3].breakpoint) {
							_myText = dcpTextObj[key][_i3].text;
						}
					}
					// console.log(myText);
					teamParts += _myText + ' ';
				}

				_this.teamDcpText = teamParts;
			}).catch(function (response) {
				//console.log("Error: ");
				//console.log(response);
			});
		},
		openTab: function openTab(cityName) {
			var i, tabcontent, tablinks;
			tabcontent = document.getElementsByClassName("tabcontent");
			for (i = 0; i < tabcontent.length; i++) {
				tabcontent[i].style.display = "none";
			}
			tablinks = document.getElementsByClassName("tab__links");
			for (i = 0; i < tablinks.length; i++) {
				tablinks[i].className = tablinks[i].className.replace(" active", "");
			}
			document.getElementById(cityName).style.display = "block";
			//evt.currentTarget.className += " active";
			$('.' + cityName).addClass('active');
		}
	}),

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		sdgData: function sdgData() {

			console.log('compute sdgData');

			var sdgObject = {};

			sdgObject.sdgCount = {};

			for (var i = 0; i < this.blocks.length; i++) {
				var block = this.blocks[i];

				if (block.settings == null || typeof block.settings.score === 'undefined') continue;else if (block.settings.score.use != "Yes") continue;

				for (var j = 0; j < block.data_structure.length; j++) {
					var stage = block.data_structure[j];
					if (stage.type != 'Rounds') continue;

					for (var k = 0; k < stage.data.rounds.length; k++) {

						var roundData = { questions: [] };
						var round = stage.data.rounds[k];

						console.log('round');
						console.log(round);

						if (round.questions.usescore != "Yes") continue;

						//combine all found sdg's to an array as key => count
						if (typeof round.sdgs !== 'undefined') {

							for (var l = 0; l < round.sdgs.length; l++) {

								var sdgIndex = round.sdgs[l];

								if (typeof sdgObject.sdgCount[sdgIndex] === 'undefined') {

									sdgObject.sdgCount[sdgIndex] = 1;
								} else {
									sdgObject.sdgCount[sdgIndex] += 1;
								}
							}
						}
					}
				}
			}

			//sdgClusters
			sdgObject.clusters = {};
			for (var property in this.sdgClusters) {
				if (this.sdgClusters.hasOwnProperty(property)) {

					var cluster = this.sdgClusters[property];
					var clusterCount = 0;

					for (var _j = 0; _j < cluster.length; _j++) {
						if (sdgObject.sdgCount[cluster[_j]] > 0) {
							clusterCount += sdgObject.sdgCount[cluster[_j]];
						}
					}

					sdgObject.clusters[property] = clusterCount;
				}
			};

			return sdgObject;
		},
		dcpData: function dcpData() {

			console.log('compute dcpData');

			var dcpData = {};
			for (var i = 0; i < this.blocks.length; i++) {
				var block = this.blocks[i];

				if (block.settings == null || typeof block.settings.score === 'undefined') continue;else if (block.settings.score.use != "Yes") continue;

				if (!dcpData.hasOwnProperty(block.settings.score.label)) {
					dcpData[block.settings.score.label] = { rounds: [] };
				}

				//label
				//displaylabel

				console.log(block.settings.score.label);

				var blockData = dcpData[block.settings.score.label];

				for (var j = 0; j < block.data_structure.length; j++) {
					var stage = block.data_structure[j];
					if (stage.type != 'Rounds') continue;
					for (var k = 0; k < stage.data.rounds.length; k++) {

						var roundData = { questions: [] };
						var round = stage.data.rounds[k];

						// console.log('round');
						// console.log(round);


						if (round.questions.usescore != "Yes") continue;

						roundData.score = round.score == undefined ? 0 : round.score;
						if (round.gametype == "worldquiz") roundData.answers = round.answers == undefined ? [] : [round.answers];else roundData.answers = round.answers == undefined ? [] : round.answers;
						roundData.correctAnswers = [];
						roundData.type = round.gametype;

						for (var l = 0; l < round.questions.questions.length; l++) {
							var question = round.questions.questions[l];
							var questionData = {};

							switch (round.gametype) {
								case "worldquiz":
									questionData.question = round.questions.intro_explanation;
									var answerHtml = '';

									for (var answerIndex = 0; answerIndex < question.items.length; answerIndex++) {

										answerHtml += '<div class="worldquiz-dcp-feedback-item">' + question.items[answerIndex].name + ': ' + question.items[answerIndex].amount * 10 + '%</div>';
									}

									roundData.correctAnswers.push(answerHtml);
									break;
								case "systeemdenken":
									questionData.question = question.questiontext;

									var answerHtmlLandmark = '';

									for (var _answerIndex = 0; _answerIndex < question.answers.length; _answerIndex++) {

										//console.log(question.items[question.answers[answerIndex].from-1].name + ' naar ' + question.items[question.answers[answerIndex].to-1].name);

										answerHtmlLandmark += '<div class="systeemdenken-dcp-feedback-item">Van ' + question.items[question.answers[_answerIndex].from - 1].name + ' naar ' + question.items[question.answers[_answerIndex].to - 1].name + '</div>';
									}

									roundData.correctAnswers.push(answerHtmlLandmark);
									break;
								case "systeemdenken_controlevragen":
									questionData.question = question.questiontext;
									roundData.correctAnswers.push(question.answers[question.correct_answer - 1].answer);
									break;

								case "matchingquiz":
									questionData.question = '';

									questionData.visual = question.visual;

									//console.log(question);

									roundData.correctAnswers.push(question.answers[question.correct_answer - 1].answer_text);

									break;
								case "simonsays":
									questionData.question = question.questiontext;

									var correctAnswersArray = question.correct_answers.split(',');

									var ssAnswerHtml = '<br>';
									for (var _answerIndex2 = 0; _answerIndex2 < correctAnswersArray.length; _answerIndex2++) {

										//console.log(question.answers[parseInt(correctAnswersArray[answerIndex])-1].label);

										if (typeof question.answers[parseInt(correctAnswersArray[_answerIndex2]) - 1] !== 'undefined') {

											ssAnswerHtml += question.answers[parseInt(correctAnswersArray[_answerIndex2]) - 1].label + '<br>';
										}
									}

									roundData.correctAnswers.push(ssAnswerHtml);

									break;
								case "swipequiz":

									questionData.question = question.caption;
									roundData.correctAnswers.push(this.yesNoLabels[question.answer]);
									break;
								case "abquiz":
									questionData.question = question.questiontext;
									roundData.correctAnswers.push(question.answers[question.correct_answer - 1].answer_text);
									//roundData.correctAnswers.push(question.correct_answer);
									break;
							}
							questionData.feedback = question.feedbacktext;
							roundData.questions.push(questionData);
						}

						if (typeof roundData.answers !== "undefined") {
							//build labels for user answers
							for (var _l = 0; _l < round.questions.questions.length; _l++) {
								var _question = round.questions.questions[_l];

								if (typeof roundData.answers[_l] !== "undefined") {

									switch (round.gametype) {
										case "worldquiz":
											var _answerHtml = '';
											for (var _answerIndex3 = 0; _answerIndex3 < roundData.answers[_l].length; _answerIndex3++) {
												_answerHtml += '<div class="worldquiz-dcp-feedback-item">' + _question.items[_answerIndex3].name + ': ' + roundData.answers[_l][_answerIndex3] * 10 + '%</div>';
											}
											roundData.answers[_l] = _answerHtml;
											break;

										case "systeemdenken":

											// console.log('systeemdenken');
											// console.log(roundData);

											var _answerHtmlLandmark = '';

											for (var _answerIndex4 = 0; _answerIndex4 < roundData.answers[_l].length; _answerIndex4++) {

												if (typeof roundData.answers[_l][_answerIndex4].from !== 'undefined') {
													_answerHtmlLandmark += '<div class="systeemdenken-dcp-feedback-item">Van ' + _question.items[roundData.answers[_l][_answerIndex4].from].name + ' naar ' + _question.items[roundData.answers[_l][_answerIndex4].to].name + '</div>';
												}
											}

											roundData.answers[_l] = _answerHtmlLandmark;
											break;
										case "systeemdenken_controlevragen":

											if (typeof _question.answers[roundData.answers[_l]] !== "undefined") {
												roundData.answers[_l] = _question.answers[roundData.answers[_l]].answer;
											}
											break;
										case "swipequiz":
											roundData.answers[_l] = this.yesNoLabels[roundData.answers[_l]];
											break;

										case "simonsays":

											var _ssAnswerHtml = '<br>';
											for (var _answerIndex5 = 0; _answerIndex5 < roundData.answers[_l].length; _answerIndex5++) {

												_ssAnswerHtml += _question.answers[roundData.answers[_l][_answerIndex5]].label + '<br>';
											}

											roundData.answers[_l] = _ssAnswerHtml;
											break;

										case "abquiz":

											if (typeof _question.answers[roundData.answers[_l] - 1] !== "undefined") {
												roundData.answers[_l] = _question.answers[roundData.answers[_l] - 1].answer_text;
											}
											break;
										case "matchingquiz":

											if (typeof _question.answers[roundData.answers[_l]] !== "undefined") {
												roundData.answers[_l] = _question.answers[roundData.answers[_l]].answer_text;
											}
											break;
									}
								}
							}
						}

						blockData.rounds.push(roundData);
					}
				}
			}
			return dcpData;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["globalSettings", "stageData", "lastStage", "blocks", "lastBlock", "transitorScore", "answerLogs", "instanceId", "userId", "userRole", "mbtiProfile", "challengeToken", "dcpProfileText"]), {

		backgroundImage: function backgroundImage() {
			if (typeof this.stageData.background === 'undefined') {
				return 'none';
			}
			return 'url(' + this.baseUrl + this.stageData.background + ')';
		}
	})
});

/***/ }),

/***/ "Gp+1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['image', 'percentage'],

	data: function data() {
		return {
			usedPercentage: 0
		};
	},
	mounted: function mounted() {
		this.usedPercentage = this.percentage;
	},


	watch: {
		percentage: function percentage(val) {
			this.usedPercentage = val;
			$(".timer__filler").css("width", val + "%");
		}
	},

	computed: {
		style: function style() {

			var percentage = this.usedPercentage + "%";
			return { width: percentage };
		}
	},

	methods: {}

});

/***/ }),

/***/ "HGTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Overlay_vue__ = __webpack_require__("zUoG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExplanationPopup_vue__ = __webpack_require__("Zp/M");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Score: __WEBPACK_IMPORTED_MODULE_1__Score_vue__["a" /* default */],
		Overlay: __WEBPACK_IMPORTED_MODULE_2__Overlay_vue__["a" /* default */],
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_5__ExplanationPopup_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			score: 0,
			answers: [],
			loggedAnswers: [],
			correctAnswers: [],
			question: true,
			time: 0,
			displayTime: 0,
			timeCounter: 0,
			timeInterval: .1,
			intervalEvent: -1,
			timerActive: false,
			explanationPopupActive: false,
			additionalHTML: ""
		};
	},
	beforeMount: function beforeMount() {
		this.clear();
		this.buildInfoAddonHTML();
	},
	mounted: function mounted() {
		this.showTransitorScore(true);
		this.time = +this.questionData.time;
		this.timeCounter = this.time;

		this.timerActive = false;
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		questionCount: function questionCount() {
			return this.roundData.questions.questions.length;
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}

	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(["lastQuestion", "currentBlock", "currentStage", "currentRound", "currentQuestion", "roundCount", "stageData", "roundCompleted", "scores", "questionData", "stageCount", "roundScore", "roundData"])),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		buildInfoAddonHTML: function buildInfoAddonHTML() {
			this.additionalHTML = this.roundData.questions.rules;
		},
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},
		startTimer: function startTimer() {
			var _this = this;

			if (this.intervalEvent != -1) window.clearInterval(this.intervalEvent);
			this.timeCounter = this.time;

			this.intervalEvent = window.setInterval(function () {
				_this.timeCounter -= _this.timeInterval;

				_this.displayTime = parseInt(_this.timeCounter, 10);

				if (_this.timeCounter <= 0) {
					_this.time = 0;
					_this.timeCounter = 0;
					_this.displayTime = 0;
					_this.stopTimer();
					_this.completeQuestion();
				}
			}, this.timeInterval * 1000);
		},
		stopTimer: function stopTimer() {
			window.clearInterval(this.intervalEvent);
			this.intervalEvent = -1;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["completeRound", "toNextQuestion", "addRoundScore", "setRoundScore", 'hideNextButton', 'showNextButton', 'setNextButtonAction', "increaseTransitorScore", "showTransitorScore", "logAnswers"]), {
		hideOverlay: function hideOverlay() {
			this.question = false;
			if (this.answers.length > 0) {
				this.showNextButton();
			}

			if (this.time > 0 && !this.timerActive) {
				this.timerActive = true;
				this.startTimer();
			}
		},
		showOverlay: function showOverlay() {
			var _this2 = this;

			if (this.answers.length > 0) {
				this.hideNextButton().then(function () {
					setTimeout(function () {
						_this2.question = true;
					}, 500);
				});
			} else {
				this.question = true;
			}
		},
		onAnswer: function onAnswer(index) {
			var _this3 = this;

			var arrIndex = this.answers.indexOf(index);
			if (arrIndex >= 0) {
				this.answers.splice(arrIndex, 1);

				if (this.answers.length == 0) {
					this.hideNextButton();
				}
			} else {
				this.answers.push(index);
				this.setNextButtonAction(this.completeQuestion).then(function () {
					_this3.showNextButton();
				});
			}
		},
		completeQuestion: function completeQuestion() {
			this.stopTimer();

			this.loggedAnswers.push(this.answers);

			//check answers with correct answers
			this.correctAnswers = this.questionData.correct_answers.split(",");

			console.log(this.correctAnswers);
			console.log(this.answers);

			//loop over all correct answers and check if we have them in the answers
			var correctSelections = 0;
			for (var i = this.correctAnswers.length - 1; i >= 0; i--) {

				console.log('check:');
				console.log(Number(this.correctAnswers[i]) - 1);

				var isInArray = this.answers.indexOf(Number(this.correctAnswers[i]) - 1);

				console.log('isInArray: ' + isInArray);

				if (isInArray != -1) {
					correctSelections++;
				}
			};

			if (correctSelections > 0) {
				this.increaseTransitorScore(correctSelections * 10);
			}

			console.log('result:');

			console.log('correctSelections: ' + correctSelections);
			console.log('correctAnswers: ' + this.correctAnswers.length);
			console.log('answers: ' + this.answers.length);

			if (correctSelections == this.correctAnswers.length && this.answers.length == this.correctAnswers.length) {
				console.log('YEAH');
				this.score++;
			}

			if (this.lastQuestion) {
				this.finishRound();
			} else {
				this.clear();

				this.toNextQuestion();

				this.time = +this.questionData.time;
				this.timeCounter = this.time;

				this.timerActive = false;
			}
		},
		finishRound: function finishRound() {
			var _this4 = this;

			this.stopTimer();

			console.log('Simon Says finished');
			console.log(this.loggedAnswers);

			this.setRoundScore(this.score / this.questionCount * 100).then(function () {
				_this4.logAnswers(_this4.loggedAnswers).then(function () {
					_this4.completeRound();
				});
			});
		},
		clear: function clear() {
			this.stopTimer();
			this.question = true;
			this.answers = [];
			this.correctAnswers = [];
		}
	})

});

/***/ }),

/***/ "HTXY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hp9d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transitor-container",class:{ active: _vm.transitorShown }},[_c('div',{staticClass:"transitor__base"},[_vm._v(_vm._s(_vm.transitorScore))]),_vm._v(" "),_c('Lottie',{ref:"animation",staticClass:"transitor__animation",attrs:{"animationpath":_vm.baseUrl + _vm.transitorAnimation,"audiopath":_vm.baseUrl + _vm.transitorSoundFX,"name":_vm.id,"loop":"false","autoplay":"false","ratio":"meet"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HvA9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("aRDL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716c685a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("2bwm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_716c685a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I0rr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IE+t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mbti-feedback stage",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.feedback.header)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.feedback.subheader)+"\n\t\t")])]),_vm._v(" "),_c('div',{staticClass:"panel small",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"text",style:('color: '+_vm.trueColors[_vm.trueColorsClassificationResult][1])},[_c('span',{staticClass:"truecolors-label"},[_vm._v(_vm._s(_vm.trueColors[_vm.trueColorsClassificationResult][2]))]),_vm._v(" "),_c('span',{staticClass:"color-indicator",style:('background-color: '+_vm.trueColors[_vm.trueColorsClassificationResult][1])})])]),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.feedback.feedbacktext)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IV49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro stage--cutsceneIntro",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.stageData.header)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v(_vm._s(_vm.stageData.subheader))]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.stageData.story)+"\n\t\t")])]),_vm._v(" "),(_vm.visualExists && _vm.visualIsJson)?_c('Lottie',{staticStyle:{"margin":"auto","position":"relative"},attrs:{"animationpath":_vm.baseUrl + _vm.stageData.visual,"audiopath":_vm.baseUrl + _vm.stageData.soundtrack,"name":"explenation-animation","loop":"false","ratio":"slice","autoplay":"true"}}):_vm._e(),_vm._v(" "),(_vm.visualExists && _vm.visualIsVideo)?_c('div',{staticClass:"media_player"},[_c('div',{staticClass:"video_holder"},[(_vm.captionExists)?_c('div',{staticClass:"cutscene_nameHolder hide"},[_c('div',{staticClass:"nameHolder__collum caption"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.stageData.caption)}})]),_vm._v(" "),_c('div',{staticClass:"nameHolder__collum subcaption"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.stageData.subcaption)}})])]):_vm._e(),_vm._v(" "),_c('video',{attrs:{"preload":"metadata","id":"cutscene_video","crossorigin":"anonymous","autoplay":""}},[_c('source',{attrs:{"src":_vm.baseUrl + _vm.stageData.visual,"type":"video/mp4"}}),_vm._v(" "),(_vm.hasSubtitle)?_c('track',{attrs:{"kind":"subtitles","srclang":"nl","src":_vm.baseUrl + _vm.stageData.subtitle,"label":"Nederlands","MIME-type":"text/plain","default":""}}):_vm._e(),_vm._v("\n\n\t\t      Your browser does not support HTML5 video.\n\t\t    ")]),_vm._v(" "),(_vm.hasSubtitle)?_c('div',{staticClass:"subtitles"}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"video-controlls"},[_c('div',{attrs:{"id":"play-btn"},on:{"click":function($event){_vm.togglePlay()}}},[_c('i',{staticClass:"fa fa-play"})]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false)])]):(_vm.visualExists)?_c('div',{staticClass:"centered",staticStyle:{"position":"absolute"}},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.stageData.visual}})]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mu-btn"}},[_c('i',{staticClass:"fa fa-volume-up"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"custom-seekbar"}},[_c('span')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IYfU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bodymovin__ = __webpack_require__("Iwrh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bodymovin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bodymovin__);


var AnimationManager = {
	install: function install(Vue, options) {
		var animations = {};

		Vue.loadAnimation = function (name, url, element, ratio, successCallback) {
			var animation = __WEBPACK_IMPORTED_MODULE_0_bodymovin___default.a.loadAnimation({
				container: element,
				renderer: 'svg',
				autoplay: false,
				path: url,
				rendererSettings: {
					progressiveLoad: true,
					preserveAspectRatio: 'xMidYMid ' + ratio
				}
			});

			animation.addEventListener('DOMLoaded', function () {
				animations[name] = animation;
				if (successCallback != undefined) successCallback();
			});

			//animation.play();
			//console.log(animation);
		};

		Vue.unloadAnimation = function (name) {
			var animation = animations[name];
			if (animation == null || animation == undefined) return;
			animation.destroy();
			delete animations[name];
		};

		Vue.getAnimation = function (name, settings) {
			var animation = animations[name];
			if (animation == null || animation == undefined) {
				console.log("AnimationManager doesnt contain a animation called: " + name);
				return null;
			}
			if (settings != undefined && settings != null) {
				animation.loop = settings.loop || false;
			} else {
				animation.loop = false;
			}
			return animation;
		};

		Vue.playAnimation = function (name, settings) {
			var animation = animations[name];
			if (animation == null || animation == undefined) {
				console.log("AnimationManager doesnt contain a animation called: " + name);
				return null;
			}

			if (settings != undefined && settings != null) {
				animation.loop = settings.loop || false;
			} else {
				animation.loop = false;
			}

			if (!animation.isPaused) {
				animation.goToAndPlay(0, true);
			} else animation.play();

			return animation;
		};
	}
};

/* harmony default export */ __webpack_exports__["a"] = (AnimationManager);

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return vuexStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_Vuex__ = __webpack_require__("uUlv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_game__ = __webpack_require__("yI0o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_block__ = __webpack_require__("yIM4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_stage__ = __webpack_require__("uYIM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_round__ = __webpack_require__("CKXS");








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_0_Vuex__["a" /* default */]);
var vuexStore = new __WEBPACK_IMPORTED_MODULE_0_Vuex__["a" /* default */].Store({
	modules: {
		game: __WEBPACK_IMPORTED_MODULE_2__modules_game__["a" /* default */],
		block: __WEBPACK_IMPORTED_MODULE_3__modules_block__["a" /* default */],
		stage: __WEBPACK_IMPORTED_MODULE_4__modules_stage__["a" /* default */],
		round: __WEBPACK_IMPORTED_MODULE_5__modules_round__["a" /* default */]
	}
});

/***/ }),

/***/ "Ij7x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("sHyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f74bc9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("MlJe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f74bc9c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Iow/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_vue__ = __webpack_require__("/gwQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__ = __webpack_require__("Zp/M");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Score: __WEBPACK_IMPORTED_MODULE_2__Score_vue__["a" /* default */],
		AnswerButton: __WEBPACK_IMPORTED_MODULE_3__Button_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_4__const_base__["a" /* url */],
			score: 0,
			answers: [],
			explanationPopupActive: false
		};
	},
	mounted: function mounted() {
		this.score = 0;
		this.showTransitorScore(true);
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(["lastQuestion", "currentBlock", "blocks", "currentStage", "currentRound", "currentQuestion", "roundCount", "stageData", "roundCompleted", "scores", "questionData", "stageCount", "roundScore", "roundData"]), {

		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		},

		finalScore: function finalScore() {
			var finalScore = 0;
			var scores = 0;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.scores[this.currentBlock][this.currentStage - 1]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var score = _step.value;

					scores++;
					finalScore += score;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			finalScore /= scores;
			return finalScore;
		}
	}),

	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["completeRound", "toNextQuestion", "setRoundScore", "increaseTransitorScore", "showTransitorScore", "logAnswers", "setFeedbackData"]), {
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
		},
		onQuestionAnswer: function onQuestionAnswer(e) {
			var _this = this;

			//let correctAnswer = +e == this.questionData.correct_answer;
			var questionCount = this.roundData.questions.length;

			this.answers.push(e);

			console.log('answer: ' + e);

			if (this.lastQuestion) {
				// let score = (this.score/questionCount)*100;
				var score = 0;

				this.setRoundScore(score).then(function () {
					_this.logAnswers(_this.answers).then(function () {
						_this.setFeedbackData({
							answers: _this.answers
						}).then(function () {
							_this.completeRound();
						});
					});
				});
			} else {
				this.toNextQuestion();
			}
		}
	})

});

/***/ }),

/***/ "J/Do":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("KaWz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c31bc7e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("b3zN");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c31bc7e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JaHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_vue__ = __webpack_require__("kzJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__ = __webpack_require__("Zp/M");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Score: __WEBPACK_IMPORTED_MODULE_2__Score_vue__["a" /* default */],
		AnswerButton: __WEBPACK_IMPORTED_MODULE_3__Button_vue__["a" /* default */],
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_4__const_base__["a" /* url */],
			answerCount: -1,
			answers: [],
			explanationPopupActive: false,
			additionalHTML: ""
		};
	},
	beforeMount: function beforeMount() {
		var _this = this;

		this.buildInfoAddonHTML();

		this.roundData.questions.questions.forEach(function (question) {
			if (_this.answerCount == -1) _this.answerCount = question.answers.length;else if (_this.answerCount != question.answers.length) console.log("DATA of matching quiz incorrect");
			_this.answers.push({ answer: -1, question: -1 });
		});
	},
	mounted: function mounted() {
		this.showTransitorScore(true);
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(["lastQuestion", "currentBlock", "currentStage", "currentRound", "currentQuestion", "roundCount", "stageData", "roundCompleted", "scores", "questionData", "stageCount", "roundScore", "roundData"]), {

		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		},

		finalScore: function finalScore() {
			var finalScore = 0;
			var scores = 0;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.scores[this.currentBlock][this.currentStage - 1]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var score = _step.value;

					scores++;
					finalScore += score;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			finalScore /= scores;
			return finalScore;
		}
	}),

	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["completeRound", "toNextQuestion", "toPreviousQuestion", "setRoundScore", "logAnswers", "logSdgs", "increaseTransitorScore", "showTransitorScore", 'setNextButtonAction', 'showNextButton', 'hideNextButton']), {
		buildInfoAddonHTML: function buildInfoAddonHTML() {
			this.additionalHTML = this.roundData.questions.rules;
		},
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},
		onPanStart: function onPanStart(e) {
			var img = this.$el.querySelector('.shadow-box');
			img.style.boxShadow = "0px 0px 5px #ee4357";
		},
		onPan: function onPan(e) {

			console.log(this.currentQuestion);

			var img = this.$el.querySelector('.shadow-box');
			var horizontal = e.deltaX;
			if (this.currentQuestion == 0 && horizontal < 0) horizontal = 0;else if (this.lastQuestion && horizontal > 0) horizontal = 0;
			img.style.transform = "translate(" + horizontal + "px,0px)";
		},
		onPanEnd: function onPanEnd(e) {
			var img = this.$el.querySelector('.shadow-box');
			img.style.transform = "translate(0px,0px)";

			img.style.boxShadow = "0px 0px 5px #ccc";

			if (Math.abs(e.deltaX) > 50) {
				if (e.deltaX < 0) {
					if (this.currentQuestion == 0) return;
					this.previous();
				} else {
					if (this.lastQuestion) return;
					this.next();
				}
			}
		},
		previous: function previous() {
			this.toPreviousQuestion();
		},
		next: function next() {
			this.toNextQuestion();
		},
		completeMinigame: function completeMinigame() {
			var _this2 = this;

			var score = 0;
			var logAnswers = [];
			var mappedSdgs = [];

			this.answers.forEach(function (answerObj) {
				if (+_this2.roundData.questions.questions[answerObj.question].correct_answer - 1 == answerObj.answer) {

					if (typeof _this2.roundData.questions.questions[answerObj.question].answers[answerObj.answer].sdg_mapping !== 'undefined') {

						console.log('sdgs mapping:');
						// console.log(answerObj.answer);
						// console.log(this.roundData.questions.questions[answerObj.question].answers[answerObj.answer].sdg_mapping);

						//check if it's a single entry or comma seperated
						var sdgMappingObject = _this2.roundData.questions.questions[answerObj.question].answers[answerObj.answer].sdg_mapping.split(",");

						console.log(sdgMappingObject);

						mappedSdgs[answerObj.question] = sdgMappingObject;
					}

					score++;
				}

				logAnswers[answerObj.question] = answerObj.answer;
			});

			this.increaseTransitorScore(parseInt(this.roundData.questions.transitor_multiplier) * score);

			this.setRoundScore(score / this.roundData.questions.questions.length * 100).then(function () {
				_this2.logAnswers(logAnswers).then(function () {
					_this2.logSdgs(mappedSdgs).then(function () {
						_this2.completeRound();
					});
				});
			});
		},
		onQuestionAnswer: function onQuestionAnswer(e) {
			var _this3 = this;

			var answered = false;
			if (this.answers[+e].question == this.currentQuestion) {
				//console.log("Already set");
				this.answers[+e].answer = -1;
				this.answers[+e].question = -1;
				answered = true;
			} else {
				for (var i = 0; i < this.answers.length; i++) {
					if (this.answers[i].question == this.currentQuestion) {
						//console.log("q["+i+"] is set to -1");
						this.answers[i].answer = -1;
						this.answers[i].question = -1;
					}
				}
				this.answers[+e].answer = +e;
				this.answers[+e].question = this.currentQuestion;
			}
			this.answers = this.answers.slice();

			// console.log(this.answers[+e].question);
			// console.log(this.answers[+e].answer);


			// console.log(this.currentQuestion+ ": " );
			// console.log(this.roundData.questions.questions[this.currentQuestion].correct_answer);
			// console.log('------------');

			var showButton = true;
			this.answers.forEach(function (answer) {
				if (answer.answer == -1) showButton = false;
			});

			if (showButton) {
				this.setNextButtonAction(this.completeMinigame).then(function () {
					setTimeout(function () {
						_this3.showNextButton();
					});
				});
			} else {
				this.hideNextButton();
			}

			var toNextAllowed = true;
			if (!this.lastQuestion) {
				for (var _i = 0; _i < this.answers.length; _i++) {
					if (this.answers[_i].question == this.currentQuestion + 1) {
						toNextAllowed = false;
					}
				}
			}

			if (!this.lastQuestion && !answered && toNextAllowed) this.next();
			//console.log("");
		}
	})

});

/***/ }),

/***/ "K/2v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "K/7s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("mcUU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71c283ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("SLky");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71c283ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KaWz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button_vue__ = __webpack_require__("Ij7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__ = __webpack_require__("Zp/M");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Score: __WEBPACK_IMPORTED_MODULE_2__Score_vue__["a" /* default */],
		AnswerButton: __WEBPACK_IMPORTED_MODULE_3__Button_vue__["a" /* default */],
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_4__const_base__["a" /* url */],
			score: 0,
			answers: [],
			mappedSdgs: [],
			explanationPopupActive: false,
			additionalHTML: ""
		};
	},
	beforeMount: function beforeMount() {
		this.buildInfoAddonHTML();
	},
	mounted: function mounted() {
		this.score = 0;
		this.showTransitorScore(true);
	},


	computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(["lastQuestion", "currentBlock", "blocks", "currentStage", "currentRound", "currentQuestion", "roundCount", "stageData", "roundCompleted", "scores", "questionData", "stageCount", "roundScore", "roundData"]), {

		backgroundImage: function backgroundImage() {
			console.log('bg: ' + this.roundData.questions.question_background);
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		},

		finalScore: function finalScore() {
			var finalScore = 0;
			var scores = 0;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.scores[this.currentBlock][this.currentStage - 1]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var score = _step.value;

					scores++;
					finalScore += score;
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			finalScore /= scores;
			return finalScore;
		}
	}),

	methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["completeRound", "toNextQuestion", "setRoundScore", "increaseTransitorScore", "showTransitorScore", "logAnswers", "logSdgs"]), {
		buildInfoAddonHTML: function buildInfoAddonHTML() {
			this.additionalHTML = this.roundData.questions.rules;
		},
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
		},
		onQuestionAnswer: function onQuestionAnswer(e) {
			var _this = this;

			var correctAnswer = +e == this.questionData.correct_answer;
			var questionCount = this.roundData.questions.questions.length;

			this.answers.push(e);

			console.log('answer: ' + e);
			console.log('correctAnswer: ' + correctAnswer);

			//sdg count
			//store the sdg's mapped to this question
			if (typeof this.questionData.answers[e - 1].sdg_mapping !== 'undefined') {

				console.log('sdgs mapping:');

				//check if it's a single entry or comma seperated
				var sdgMappingObject = this.questionData.answers[e - 1].sdg_mapping.split(",");

				console.log(sdgMappingObject);

				for (var i = 0; i < sdgMappingObject.length; i++) {
					this.mappedSdgs.push(sdgMappingObject[i]);
				};
			}

			if (correctAnswer) {
				this.score++;
				this.increaseTransitorScore(+this.roundData.questions.transitor_multiplier);
			} else {
				//this.score += 0.5
				this.increaseTransitorScore(+this.roundData.questions.transitor_multiplier / 2);
			}

			console.log('score: ' + this.score);

			if (this.lastQuestion) {
				var score = this.score / questionCount * 100;

				this.setRoundScore(score).then(function () {
					_this.logAnswers(_this.answers).then(function () {
						_this.logSdgs(_this.mappedSdgs).then(function () {
							_this.completeRound();
						});
					});
				});
			} else {
				this.toNextQuestion();
			}
		}
	})

});

/***/ }),

/***/ "Ke9v":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "KfJq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderBlock_vue__ = __webpack_require__("qmlP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Timer_vue__ = __webpack_require__("ZqlF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SwipeImage_vue__ = __webpack_require__("WGjt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Question_vue__ = __webpack_require__("wIkJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_velocity_animate__ = __webpack_require__("9qgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ExplanationPopup_vue__ = __webpack_require__("Zp/M");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		HeaderBlock: __WEBPACK_IMPORTED_MODULE_1__HeaderBlock_vue__["a" /* default */],
		Timer: __WEBPACK_IMPORTED_MODULE_2__Timer_vue__["a" /* default */],
		Score: __WEBPACK_IMPORTED_MODULE_3__Score_vue__["a" /* default */],
		Question: __WEBPACK_IMPORTED_MODULE_5__Question_vue__["a" /* default */],
		SwipeImage: __WEBPACK_IMPORTED_MODULE_4__SwipeImage_vue__["a" /* default */],
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_9__ExplanationPopup_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_6__const_base__["a" /* url */],
			time: 600,
			timeCounter: 600,
			timeInterval: .1,
			intervalEvent: -1,
			score: 0,
			answers: [],
			mappedSdgs: [],
			explanationPopupActive: false,
			additionalHTML: "",
			state: "ready", //ready, question , feedback
			use_feedback_state: true,
			room_id: false
		};
	},
	beforeMount: function beforeMount() {
		this.buildInfoAddonHTML();

		var self = this;

		this.$socket.on('joined_update', function (data) {

			console.log('joined');
			console.log(data);

			self.room_id = data.data.id;
		});

		this.$socket.on('goto_first_question', function (data) {
			console.log(data);

			self.state = "question";
		});

		this.$socket.on('goto_next_question', function (data) {
			console.log(data);

			if (self.lastQuestion) self.finishRound();else self.toNextQuestion();
			self.state = "question";

			self.time = +self.roundData.questions.time;
			self.timeCounter = self.time;
			if (self.time > 0) {
				self.startTimer();
			}
		});
	},
	mounted: function mounted() {
		this.showTransitorScore(true);
		this.time = +this.roundData.questions.time;
		this.timeCounter = this.time;
		if (this.time > 0) {
			this.startTimer();
		}

		// console.log('roundData');
		// console.log(this.roundData.questions);

		var data = { 'instance_id': this.instanceId, 'client_id': this.userId, 'teamcode': this.teamCode };
		this.$socket.emit('join_instance', data);
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* mapGetters */])(["lastQuestion", "questionData", "roundData", "instanceId", "userId", "teamCode"]), {
		questionCount: function questionCount() {
			return this.roundData.questions.questions.length;
		},
		timerPercentage: function timerPercentage() {
			return this.timeCounter / this.time * 100;
		},


		backgroundImage: function backgroundImage() {

			if (typeof this.roundData.questions.question_background === 'undefined' || this.roundData.questions.question_background === null) {
				return 'none';
			}

			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}

	}),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		buildInfoAddonHTML: function buildInfoAddonHTML() {
			this.additionalHTML = this.roundData.questions.rules;
		},
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},
		startTimer: function startTimer() {
			var _this = this;

			if (this.intervalEvent != -1) window.clearInterval(this.intervalEvent);
			this.timeCounter = this.time;

			this.intervalEvent = window.setInterval(function () {
				_this.timeCounter -= _this.timeInterval;
				if (_this.timeCounter <= 0) {
					_this.timeCounter = 0;
					_this.stopTimer();
					_this.finishRound();
				}
			}, this.timeInterval * 1000);
		},
		stopTimer: function stopTimer() {
			window.clearInterval(this.intervalEvent);
			this.intervalEvent = -1;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_vuex__["b" /* mapActions */])(["completeRound", "toNextQuestion", "setRoundScore", "increaseTransitorScore", "showTransitorScore", "logAnswers", "logSdgs"]), {
		finishRound: function finishRound() {
			var _this2 = this;

			this.stopTimer();

			console.log('finishRound');
			console.log(this.score / this.questionCount * 100);

			console.log('answers:');
			console.log(this.answers);

			this.setRoundScore(this.score / this.questionCount * 100).then(function () {
				_this2.logAnswers(_this2.answers).then(function () {
					_this2.logSdgs(_this2.mappedSdgs).then(function () {
						_this2.completeRound();
					});
				});
			});
		},
		onQuestionAnswer: function onQuestionAnswer(e) {
			this.answers.push(e);
			if (e == this.questionData.answer) {

				//store the sdg's mapped to this question
				if (typeof this.questionData.sdg_mapping !== 'undefined') {

					console.log('sdgs mapping:');

					//check if it's a single entry or comma seperated
					var sdgMappingObject = this.questionData.sdg_mapping.split(",");

					console.log(sdgMappingObject);

					for (var i = 0; i < sdgMappingObject.length; i++) {
						this.mappedSdgs.push(sdgMappingObject[i]);
					};
				}

				var transitors = 1;
				if (this.score > 9) {
					transitors = 6;
				}

				this.increaseTransitorScore(parseInt(this.roundData.questions.transitor_multiplier) * transitors);
				this.score++;
			}

			console.log('score: ' + this.score);

			if (this.use_feedback_state) {

				this.stopTimer();

				this.state = "feedback";
				//log users state to node server
				// let self = this;
				// window.setTimeout(function(){
				// 	if(self.lastQuestion) self.finishRound();
				// 	else self.toNextQuestion();
				// 	self.state = "question";
				// }, 4000);

				var data = { 'instance_id': this.instanceId, 'room_id': this.room_id, 'client_id': this.userId, 'answer': e };
				this.$socket.emit('set_answer', data);
			} else {

				if (this.lastQuestion) this.finishRound();else this.toNextQuestion();
			}
		}
	})

});

/***/ }),

/***/ "Ko49":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--impactcalculator",class:'round_'+_vm.currentRound,style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.questionData.header)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',[_vm._v(_vm._s(_vm.questionData.questiontext))])]),_vm._v(" "),_c('div',{staticClass:"info",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.questionData.info)+"\n\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('div',{staticClass:"card card__impactcalculator"},[_c('div',{staticClass:"info info_2",staticStyle:{"position":"relative","display":"none"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.questionData.info)+"\n\t\t\t")]),_vm._v(" "),_c('RoundSlider',{attrs:{"sliderValue":_vm.sliderValue,"maxValue":+_vm.questionData.maxvalue,"stepSize":+_vm.questionData.stepsize,"identifier":1,"visual":_vm.baseUrl + _vm.questionData.visual},on:{"round-slide":_vm.slideChange}}),_vm._v(" "),_c('div',{staticClass:"counter_container"},[_c('p',{staticClass:"counter_explanation"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.info)+"\n\t\t\t\t")]),_vm._v(" "),_c('ul',{staticClass:"counter_parent"},_vm._l((_vm.displayValues),function(display){return _c('li',{staticClass:"couter__item"},[_vm._v(_vm._s(display))])})),_vm._v(" "),_c('div',{staticClass:"counter_text"},[_c('div',{staticClass:"counter_text__textHolder"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.comment)+"\n\t\t\t\t\t")])])])],1),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L1zI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Le6Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider__container"},[_c('div',{staticClass:"visual"},[_c('img',{attrs:{"src":_vm.visual}})]),_vm._v(" "),_c('div',{staticClass:"slider",attrs:{"id":_vm.addIdentifier}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LiO2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("B/ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445bdde2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("3juA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445bdde2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LqcC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['onClick', 'text'],

	data: function data() {
		return {};
	},
	mounted: function mounted() {},


	watch: {},

	computed: {},

	methods: {}

});

/***/ }),

/***/ "M0X4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['onClick', 'text'],

	data: function data() {
		return {};
	},
	mounted: function mounted() {},


	watch: {},

	computed: {},

	methods: {}

});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcafd2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("I0rr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adcafd2c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Mjyq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state === 'ready')?_c('div',{staticClass:"stage stage--swipequiz-waiting",style:({ 'background-image': _vm.backgroundImage })},[_vm._m(0,false,false)]):(_vm.state === 'question')?_c('div',{staticClass:"swipequiz stage stage--swipequiz",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"swipequiz__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('HeaderBlock',{attrs:{"header":_vm.questionData.header,"subHeader":_vm.roundData.questions.subheader,"bodytext":_vm.questionData.questiontext}}),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('Timer',{key:"timer",attrs:{"percentage":_vm.timerPercentage}}),_vm._v(" "),(_vm.questionData != null)?_c('SwipeImage',{attrs:{"image":_vm.baseUrl + _vm.questionData.visual,"dead-zone":"50","header":_vm.questionData.subheader,"questiontext":_vm.questionData.caption,"cardbg":_vm.baseUrl + _vm.roundData.questions.swipe_card_bg},on:{"onanswer":_vm.onQuestionAnswer}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"swipequiz__btn-container"},[_c('div',{staticClass:"input-holder input-holder__three-btn-circle",on:{"click":function($event){_vm.onQuestionAnswer('No')}}},[_vm._m(1,false,false)]),_vm._v(" "),_c('div',{staticClass:"input-holder input-holder__three-btn-circle",on:{"click":function($event){_vm.onQuestionAnswer('Dont know')}}},[_vm._m(2,false,false)]),_vm._v(" "),_c('div',{staticClass:"input-holder input-holder__three-btn-circle",on:{"click":function($event){_vm.onQuestionAnswer('Yes')}}},[_vm._m(3,false,false)])])],1)]),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"additionalHTML":_vm.additionalHTML,"on-click":_vm.hideExplanationPopup}}):_vm._e()],1):(_vm.state === 'feedback')?_c('div',{staticClass:"stage stage--swipequiz-feedback",style:({ 'background-image': _vm.backgroundImage })},[_vm._v("\n\n\tFeedback screen\n\n")]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipequiz__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container shadow-box"},[_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}}),_vm._v(" "),_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\tIdle screen\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\teven geduld\n\t\t\t\t")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-circle btn-circle-wrong"},[_c('i',{staticClass:"fa fa-times",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-circle btn-circle-questionmark"},[_c('i',{staticClass:"fa fa-question",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-circle btn-circle-good"},[_c('i',{staticClass:"fa fa-check",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MlJe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ab-quiz__button btn btn-progres ",on:{"click":_vm.onClick}},[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mwbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dcp_vue__ = __webpack_require__("GN6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0217e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dcp_vue__ = __webpack_require__("P45J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dcp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b0217e2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dcp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N95X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-quiz__button btn btn-progres ",on:{"click":_vm.onClick}},[_c('div',{staticClass:"btn__content"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_socket_io__ = __webpack_require__("hMcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_socket_io__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__("ORbq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_touch__ = __webpack_require__("I0MY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_AudioManager__ = __webpack_require__("OWMe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_AnimationManager__ = __webpack_require__("IYfU");






// Vue.use(VueSocketio, 'http://195.169.146.42:8085');

// Vue.use(VueSocketio, 'http://195.169.146.42:8086');
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_socket_io___default.a, 'http://localhost:8086');

//require('./assets/css/bundle.min.css');

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);

//Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_touch___default.a);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7__plugins_AudioManager__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8__plugins_AnimationManager__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
			el: '#app',
			store: __WEBPACK_IMPORTED_MODULE_3__store_index__["a" /* vuexStore */],
			router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
			render: function render(h) {
						return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
			},
			sockets: {
						connect: function connect() {
									console.log('socket connected');
						},
						customEmit: function customEmit(val) {
									console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)');
						}
			}
});

/***/ }),

/***/ "O2i0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__ = __webpack_require__("uQpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_tut_tinder_json__ = __webpack_require__("+4kz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_tut_tinder_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_tut_tinder_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__["a" /* default */]
	},

	beforeMount: function beforeMount() {
		this.findCorrectFeedback();
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(_this.lastRound ? _this.toNextStage : _this.toNextRound).then(function () {
				_this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": true });
			});
		}, 500);
	},
	data: function data() {
		return {
			selectedFeedbackIndex: -1,
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			animationData: __WEBPACK_IMPORTED_MODULE_2__assets_tut_tinder_json__
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		findCorrectFeedback: function findCorrectFeedback() {
			if (this.roundData.questions == null || this.roundData.questions.feedback == null) return;
			var index = 0;
			for (var i = 0; i < this.roundData.questions.feedback.length; i++) {
				var fb = this.roundData.questions.feedback[i];
				if (+fb.score <= this.score && +fb.score >= +this.roundData.questions.feedback[index].score) {
					index = i;
				}
			}
			this.selectedFeedbackIndex = index;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["increaseTransitorScore", 'setNextButtonAction', 'toNextStage', 'toNextRound', 'showNextButton'])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		feedback: function feedback() {
			console.log('FEEDBACK:');
			console.log(this.roundData.questions.feedback[this.selectedFeedbackIndex]);
			return this.selectedFeedbackIndex >= 0 ? this.roundData.questions.feedback[this.selectedFeedbackIndex] : { header: "Undefined header", subheader: "Undefined subheader", feedbacktext: "Undefined text", visual: "undefined" };
		},
		score: function score() {
			console.log('SCORE:');
			console.log(this.roundData.score);
			return this.roundData.score;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(['currentBlock', 'currentStage', 'currentRound', 'roundData', 'lastRound']), {

		backgroundImage: function backgroundImage() {

			if (typeof this.roundData.questions.feedback_background === 'undefined') {
				return 'none';
			}

			return 'url(' + this.baseUrl + this.roundData.questions.feedback_background + ')';
		}
	})

});

/***/ }),

/***/ "OWMe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_howler__ = __webpack_require__("k9Ku");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_howler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_howler__);


var AudioManager = {
	install: function install(Vue, options) {
		var sounds = {};

		Vue.loadAudio = function (name, url, successCallback, failCallback) {
			var sound = new Howl({
				src: [url],
				buffer: false,
				autoplay: false,
				//html5: true,
				onloaderror: function onloaderror(e) {
					if (failCallback != undefined) failCallback(e);
				},
				onload: function onload() {
					sounds[name] = sound;
					if (successCallback != undefined) successCallback();
				}
			});
		};

		Vue.unloadAudio = function (name) {
			var sound = sounds[name];
			if (sound == null || sound == undefined) return;
			if (sound.playing()) sound.stop();
			delete sounds[name];
		};

		Vue.getAudio = function (name, settings) {
			var sound = sounds[name];
			if (sound == null || sound == undefined) {
				console.log("Audiomanager doesnt contain a sound called: " + name);
				return null;
			}

			if (settings != undefined && settings != null) {
				sound.volume(settings.volume || 1);
				sound.loop(settings.loop || false);
			} else {
				sound.volume(1);
				sound.loop(false);
			}

			return sound;
		};

		Vue.playAudio = function (name, settings) {
			var sound = sounds[name];
			if (sound == null || sound == undefined) {
				console.log("Audiomanager doesnt contain a sound called: " + name);
				return null;
			}

			if (settings != undefined && settings != null) {
				sound.volume(settings.volume || 1);
				sound.loop(settings.loop || false);
			} else {
				sound.volume(1);
				sound.loop(false);
			}

			if (sound.playing()) sound.seek(0);else sound.play();
			return sound;
		};

		Vue.stopAll = function () {
			for (var sound in sounds) {
				if (Object.prototype.hasOwnProperty.call(sounds, sound)) {
					if (sound == null || sound == undefined) {
						continue;
					}
					if (sound.playing) sound.stop();
				}
			}
		};
	}
};

/* harmony default export */ __webpack_exports__["a"] = (AudioManager);

/***/ }),

/***/ "P45J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--dcpIntro block_dcp",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.header)}}),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.story)}})]),_vm._v(" "),_c('div',{staticClass:"finalization"},[_c('div',{staticClass:"finalization__tab"},[_c('button',{staticClass:"tab__links Persoonlijk active",on:{"click":function($event){_vm.openTab('Persoonlijk')}}},[_vm._v(_vm._s(_vm.stageData.your_score_tab))]),_vm._v(" "),_c('button',{staticClass:"tab__links Vergelijk",on:{"click":function($event){_vm.openTab('Vergelijk')}}},[_vm._v(_vm._s(_vm.stageData.average_tab))])]),_vm._v(" "),_c('div',{staticClass:"finalization__content active"},[_c('div',{staticClass:"tabcontent show",attrs:{"id":"Persoonlijk"}},[_c('div',{staticStyle:{"margin":"auto","position":"relative","width":"80%","height":"360px"},attrs:{"id":"player"}}),_vm._v(" "),_c('div',{staticClass:"answers"},[_c('p',[_vm._v(_vm._s(_vm.stageData.show_results_header))]),_vm._v(" "),_vm._l((_vm.dcpData),function(data,index){return _c('div',{staticClass:"view-questions-link",class:'view-questions--'+index,on:{"click":function($event){_vm.setPopup(index)}}},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.typeLabels[index])+"\n\t\t\t\t\t\t")])})],2),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.dcpText)}})]),_vm._v(" "),_c('div',{staticClass:"tabcontent",attrs:{"id":"Vergelijk"}},[_c('div',{staticStyle:{"margin":"auto","position":"relative","width":"80%","height":"360px"},attrs:{"id":"group_dcp"}}),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.teamDcpText)}})]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.challengeToken)?_c('div',{staticClass:"return-link-holder"},[_vm._m(0,false,false)]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.dcpData),function(data,index){return (index == _vm.showPopup)?_c('div',{staticClass:"card card-dcp-popup card-dcp-popup--Kennis active",class:'card-dcp-popup--'+index},[_c('div',{staticClass:"dcp-feedback-container",staticStyle:{"height":"auto"}},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"dcp-feedback-icon",attrs:{"src":_vm.baseUrl + '/media/gem_utrecht/Algemeen/dcp_feedback_icon_Kennis.svg'}}),_vm._v(" "+_vm._s(_vm.typeLabels[index])+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"pagingInfo",staticStyle:{"text-align":"right","margin-right":"10px"},on:{"click":function($event){_vm.togglePopup()}}},[_vm._v("\n\t\t\t\t\t\tX\n\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticStyle:{"height":"auto","margin-bottom":"20px"}},_vm._l((data.rounds),function(round, index){return _c('div',{staticClass:"btn btn-round",on:{"click":function (){_vm.setPopupRound(index)}}},[_vm._v(_vm._s(_vm.roundLabel)+" "+_vm._s(index+1))])})),_vm._v(" "),_c('div',{staticClass:"dcpQuestions"},[_c('div',{staticClass:"one-time",staticStyle:{"height":"100%"}},_vm._l((data.rounds[_vm.popupRound].questions),function(question,index){return _c('div',{staticClass:"question"},[_c('div',{staticClass:"bubbel"},[_c('p',[_c('b',[_vm._v(_vm._s(_vm.questionLabel)+" "+_vm._s(index+1))])]),_vm._v(" "),(typeof question.question !=='undefined')?_c('p',{domProps:{"innerHTML":_vm._s(question.question)}}):_vm._e(),_vm._v(" "),(typeof question.visual !=='undefined')?_c('div',[_c('img',{attrs:{"src":_vm.baseUrl + question.visual}})]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.yourAnswerLabel)+": "),_c('span',{domProps:{"innerHTML":_vm._s(data.rounds[_vm.popupRound].answers[index])}})])]),_vm._v(" "),_c('div',{staticClass:"bubbel"},[_c('p',[_vm._v(_vm._s(_vm.correctAnswerLabel)+": "),_c('span',{domProps:{"innerHTML":_vm._s(data.rounds[_vm.popupRound].correctAnswers[index])}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')]),_vm._v(" "),(typeof question.feedback !== 'undefined')?_c('div',{staticClass:"bubbel"},[_c('p',[_vm._v(_vm._s(question.feedback))])]):_vm._e()])})),_vm._v(" "),_c('button',{staticClass:"slick-prev slick-arrow js-slick-prev",attrs:{"aria-label":"Vorige","type":"button"}},[_vm._v(_vm._s(_vm.previousLabel))]),_vm._v(" "),_c('button',{staticClass:"slick-next slick-arrow js-slick-next",attrs:{"aria-label":"Volgende","type":"button"}},[_vm._v(_vm._s(_vm.nextLabel))])])]):_vm._e()})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"http://onefutureplay.com/my-challenges"}},[_c('div',{staticClass:"btn btn-progres btn-challenge-return-link"},[_vm._v("Naar challenges")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PD0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__ = __webpack_require__("uQpZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__["a" /* default */]
	},

	data: function data() {
		return {
			headerReady: true,
			visualReady: true,
			storyReady: true,
			deviceHeight: 0,
			videoHeight: 0,
			offSet: 0,
			video: false,
			isPlaying: false,
			captionVisible: false

		};
	},
	mounted: function mounted() {
		var _this = this;

		this.showTransitorScore(false);

		if (this.visualIsVideo) {

			console.log('video');

			this.setNextButtonAction(this.stopBlockTransition);

			var self = this;
			this.video = document.getElementById("cutscene_video");
			this.video.onplaying = function () {
				self.isPlaying = true;
			};
			this.video.onpause = function () {
				self.isPlaying = false;
			};
			this.video.onended = function () {
				self.showNextButton();
				self.isPlaying = false;
				self.hideText();
			};

			if (this.hasSubtitle) {
				this.video.addEventListener('loadedmetadata', this.videoMetaLoaded);
			}

			this.video.ontimeupdate = function () {
				var percentage = self.video.currentTime / self.video.duration * 100;
				$("#custom-seekbar span").css("width", percentage + "%");

				if (percentage < 10 && percentage > 3 && !self.captionVisible) {
					$(".cutscene_nameHolder").removeClass('hide');
					self.captionVisible = true;
				} else if (percentage < 3 && !self.captionVisible) {
					$(".cutscene_nameHolder").addClass('hide');
					self.captionVisible = false;
				}

				if (percentage > 20 && self.captionVisible) {
					$(".cutscene_nameHolder").addClass('hide');
					self.captionVisible = false;
				}
			};

			$("#custom-seekbar").on("click", function (e) {
				var offset = $(this).offset();
				var left = e.pageX - offset.left;
				var totalWidth = $("#custom-seekbar").width();
				var percentage = left / totalWidth;
				var vidTime = self.video.duration * percentage;
				self.video.currentTime = vidTime;
			});
		} else if (this.lastBlock) {

			console.log('is lastBlock');
		} else if (this.lastStage) {

			console.log('NO video');

			this.setNextButtonAction(this.stopBlockTransition).then(function () {
				_this.showNextButton();
			});
		} else {
			this.setNextButtonAction(this.toNextStage).then(function () {
				_this.showNextButton();
			});
		}

		$('#cutscene_video').prop('muted', false);

		$('#mu-btn').click(function () {
			$('#mu-btn').find('i').toggleClass('fa-volume-up fa-volume-off');
			if ($('#cutscene_video').prop('muted')) {
				$('#cutscene_video').prop('muted', false);
			} else {
				$('#cutscene_video').prop('muted', true);
			}
		});
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["showNextButton", "setNextButtonAction", "toNextStage", "stopBlockTransition", "showTransitorScore"]), {
		togglePlay: function togglePlay() {
			$('#play-btn').find('i').toggleClass('fa-play fa-pause');
			console.log(this.isPlaying);
			console.log(this.video);
			if (this.isPlaying) {
				this.video.pause();
			} else {
				this.video.play();
			}
		},
		replaceText: function replaceText(text) {
			$('.subtitles').html(text);
		},
		showText: function showText() {
			$('.subtitles').addClass('show');
		},
		hideText: function hideText() {
			$('.subtitles').removeClass('show');
		},
		cueEnter: function cueEnter(e) {
			console.log('entering cue part');

			this.replaceText(e.currentTarget.text);
			this.showText();
		},
		cueExit: function cueExit() {
			//this.hideText();
		},
		videoMetaLoaded: function videoMetaLoaded(e) {

			this.tracks = this.video.textTracks[0];

			this.cues = this.tracks.cues;

			// console.log('videoMetaLoaded! Known cues:');
			// console.log(this.cues);

			// console.log('videoMetaLoaded! Known textTracks:');
			// console.log(this.video.textTracks[0]);


			//   	var total = this.video.textTracks[0].cues.length;

			//   	console.log('total:');
			// console.log(total);


			//       for (var i in this.cues) {
			//         	if (i < total) {
			// 		var cue = this.cues[i];
			// 		cue.onenter = this.cueEnter;
			// 		cue.onexit = this.cueExit;
			// 	}
			//       }

			this.tracks.mode = 'hidden';

			var self = this;
			this.video.textTracks[0].oncuechange = function () {

				//console.log(this.activeCues[0].text);

				if (typeof this.activeCues[0] !== 'undefined') {
					self.replaceText(this.activeCues[0].text);
					self.showText();
				} else {
					self.hideText();
				}
			};
		}
	}),

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		baseUrl: function baseUrl() {
			return __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */];
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.stageData.background + ')';
		}

	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(["stageData", "lastStage", "lastBlock"]), {
		visualExists: function visualExists() {
			return this.stageData != null && this.stageData.visual != null;
		},
		visualIsJson: function visualIsJson() {
			if (this.stageData == null || this.stageData.visual == null) return false;
			var fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'json';
		},
		visualIsVideo: function visualIsVideo() {
			if (this.stageData == null || this.stageData.visual == null) return false;
			var fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'mp4';
		},
		captionExists: function captionExists() {
			return this.stageData != null && this.stageData.caption != null;
		},
		hasSubtitle: function hasSubtitle() {
			return this.stageData != null && this.stageData.subtitle != null;
		}
	})
});

/***/ }),

/***/ "PY/H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return api_url; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return dev_env; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return lang; });
// export const url = "http://localhost:8000/";
// export const url = "http://staging.onefutureplay.com/";//Staging
// export const url = "http://utregseduurzaamheidsspelen.nl/";//Live
//export const url = "https://desterksteschakels.nl/impact/";//Live
//export const url = "https://desterksteschakels.nl/";//Live
// export const url = "https://rwscirculair.nl/";//Live
//export const url = "http://onefutureplay.com/";//Live
// export const url = "http://demo.onefutureplay.com/";//Live
//export const url = "http://roelofskompas.nl/";//Live
var url = "http://impact.babetteporcelijn.com/"; //Live
// export const url = "http://stedinplay.net/";
// export const url = "http://speelermeeruit.nl/";
// export const url = "https://playrail.nl/";
// export const url = "https://aplay.nl/";
// export const url = "https://brenghetsamen.nl/";
//export const url = "";//Local

// export const api_url = "http://localhost:8000/";
// export const api_url = "http://staging.onefutureplay.com/";//Staging
// export const api_url = "http://utregseduurzaamheidsspelen.nl/";//Live
//export const api_url = "https://desterksteschakels.nl/";//Live
// export const api_url = "https://rwscirculair.nl/";//Live
//export const api_url = "http://onefutureplay.com/";//Live
// export const api_url = "http://demo.onefutureplay.com/";//Live
//export const api_url = "http://roelofskompas.com/";//Live
var api_url = "http://impact.babetteporcelijn.com/"; //Live
// export const api_url = "http://stedinplay.net/";
// export const api_url = "http://speelermeeruit.nl/";
// export const api_url = "https://playrail.nl/";
// export const api_url = "https://aplay.nl/";
// export const api_url = "https://brenghetsamen.nl/";

var dev_env = "production";
// export const dev_env = "local";

// export const lang = "NL";
// export const lang = "EN";
var lang = "FR";

/***/ }),

/***/ "Pz+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__ = __webpack_require__("uQpZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__["a" /* default */]
	},
	props: [],

	beforeMount: function beforeMount() {

		if (typeof this.stageData.slides === 'undefined') {
			this.stageData.slides = [];
		}
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(_this.toNextStage).then(function () {
				_this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": false });
			});
		}, 500);

		this.showTransitorScore(false);

		this.setSlider();
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */]
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['showNextButton', 'setNextButtonAction', 'toNextStage', "showTransitorScore"]), {
		setSlider: function setSlider() {
			setTimeout(function () {
				$('.slider').slick({
					dots: true,
					infinite: true,
					speed: 300,
					slidesToShow: 1,
					adaptiveHeight: false,
					arrows: false
				});
			}, 10);
		}
	}),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['stageData']), {
		visualExists: function visualExists() {
			return this.stageData != null && this.stageData.visual != null;
		},
		visualIsJson: function visualIsJson() {
			if (this.stageData == null || this.stageData.visual == null) return false;
			var fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'json';
		},


		backgroundImage: function backgroundImage() {

			console.log(this.stageData.background);

			if (typeof this.stageData.background === 'undefined') {
				return 'none';
			}

			return 'url(' + this.baseUrl + this.stageData.background + ')';
		}
	})

});

/***/ }),

/***/ "Q+yt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dcp_Sdg_vue__ = __webpack_require__("3xXr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dcp_Dcp_vue__ = __webpack_require__("Mwbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Sdg: __WEBPACK_IMPORTED_MODULE_1__dcp_Sdg_vue__["a" /* default */],
		Dcp: __WEBPACK_IMPORTED_MODULE_2__dcp_Dcp_vue__["a" /* default */]
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["roundState", "blockType", "stageType", "roundCompleted", "roundExplained", "roundType"])),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])([]))

});

/***/ }),

/***/ "QF+a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DcpBlock_vue__ = __webpack_require__("Q+yt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f64342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DcpBlock_vue__ = __webpack_require__("us9v");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DcpBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f64342_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DcpBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QG5F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Score_vue__ = __webpack_require__("c52X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543710c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Score_vue__ = __webpack_require__("YVsT");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Score_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543710c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Score_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QhFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundSlider_vue__ = __webpack_require__("6J6/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b746e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundSlider_vue__ = __webpack_require__("Le6Q");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RoundSlider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75b746e3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RoundSlider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QmSG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export backend */
var backend = {
	url: "http://www.ludimo.nl"
};

/***/ }),

/***/ "RCas":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("Ziio");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b990a2ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("d/BW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b990a2ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RkXe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"multi-quiz__button btn btn-progres",class:{'answered' : _vm.answer.answer != -1 , 'answered-current' : _vm.answer.question == _vm.question},on:{"click":_vm.onClick}},[_c('div',{staticClass:"checkboxHolder"}),_vm._v(" "),_c('div',{staticClass:"btn__content"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RuP7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transitors_vue__ = __webpack_require__("eU6F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39bc9728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transitors_vue__ = __webpack_require__("Hp9d");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transitors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39bc9728_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transitors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ryrf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ContentBlock_vue__ = __webpack_require__("AK7e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__("QmSG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		teamcode: {
			type: String,
			required: false
		},
		resp_id: {
			type: String,
			required: false
		},
		challenge_token: {
			type: String,
			required: false
		}
	},

	components: {
		ContentBlock: __WEBPACK_IMPORTED_MODULE_1__ContentBlock_vue__["a" /* default */]
	},

	data: function data() {
		return {
			infoText: "Loading",
			browserNotAllowed: false,
			isIOS: false,
			isWindowsMobile: false,
			deviceWidth: '100%',
			deviceHeight: ''
		};
	},
	beforeMount: function beforeMount() {

		if ($(window).width() <= 460) {
			this.deviceWidth = $(window).width() + 'px';
			this.deviceHeight = $(window).height() + 'px';
		}
	},


	created: function created() {
		this.isIOS = this.iOS();
		//console.log('is iOS: '+this.iOS());


		this.isWindowsMobile = this.WindowsMobile();
		//console.log('is isWindowsMobile: '+this.isWindowsMobile);

		var isOldBrowser = this.isOldBrowser();

		console.log(isOldBrowser);

		if (isOldBrowser === 'isOldBrowser') {
			this.browserNotAllowed = true;
		} else {
			this.loadData();
		}
	},

	mounted: function mounted() {

		//this.toggleFullScreen();
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['gameLoaded'])),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['loadGameData', 'loadAudio', 'toNextRound', 'setTeamCode', 'setChallengeToken']), {

		toggleFullScreen: function toggleFullScreen() {
			var doc = window.document;
			var docEl = doc.documentElement;

			var requestFullScreen = docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
			var cancelFullScreen = doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

			if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
				requestFullScreen.call(docEl);
			} else {
				cancelFullScreen.call(doc);
			}
		},

		loadData: function loadData() {
			var _this = this;

			this.loadGameData(this.teamcode).then(function () {

				// console.log('challengeToken: '+this.challenge_token);

				_this.setChallengeToken(_this.challenge_token);
			}).catch(function (error) {
				_this.infoText = "Connection error";
			});
		},

		iOS: function iOS() {

			var iDevices = ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'];

			if (!!navigator.platform) {
				while (iDevices.length) {
					if (navigator.platform === iDevices.pop()) {
						return 'iOS';
					}
				}
			}

			if (navigator.userAgent.match(/iPhone/i)) {
				return 'iOS';
			}

			return false;
		},
		WindowsMobile: function WindowsMobile() {

			if (navigator.userAgent.match(/IEMobile/i)) {
				return 'isWindowsMobile';
			}
			return false;
		},
		isOldBrowser: function isOldBrowser() {

			return false;

			var iDevices = [/Android 3/i, /iPhone OS 7_/i, /IEMobile/i];
			///iPhone OS 8_/i,

			console.log(navigator.userAgent);

			if (!!navigator.userAgent) {

				for (var i = 0; i < iDevices.length; i++) {

					if (navigator.userAgent.match(iDevices[i])) {
						return 'isOldBrowser';
					}
				};
			}

			return false;
		}
	})

});

/***/ }),

/***/ "SLky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"teamrole-feedback stage",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.questions.feedback[0].subheader)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.questions.feedback[0].header)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text text-top",staticStyle:{"position":"relative"}},[_vm._v(_vm._s(_vm.roundData.questions.feedback[0].feedbacktext))])]),_vm._v(" "),_c('div',{staticClass:"explanation mainTitle",staticStyle:{"position":"relative"}}),_vm._v(" "),_c('div',{staticClass:"teamrole__button not-active"},[_c('div',{staticClass:"visual"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[_vm.feedbackData.answer].visual}})]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.questionData.answers[_vm.feedbackData.answer].title))]),_c('br'),_vm._v(_vm._s(_vm.questionData.answers[_vm.feedbackData.answer].answer_text))])]),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.questionData.answers[_vm.feedbackData.answer].info_header))]),_vm._v("\n\t\t\t"+_vm._s(_vm.questionData.answers[_vm.feedbackData.answer].info_text)+"\n\n\t\t")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SRch":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SkWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot__ = __webpack_require__("KmDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__ = __webpack_require__("Zp/M");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Score: __WEBPACK_IMPORTED_MODULE_3__Score_vue__["a" /* default */],
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_4__const_base__["a" /* url */],
			explanationPopupActive: false,
			usedPositions: [],
			positions: [[{ x: 50, y: 10 }, { x: 50, y: 95 }], [{ x: 50, y: 5 }, { x: 15, y: 70 }, { x: 85, y: 70 }], [{ x: 50, y: 10 }, { x: 90, y: 50 }, { x: 50, y: 90 }, { x: 10, y: 50 }], [{ x: 50, y: 10 }, { x: 230, y: 100 }, { x: 185, y: 210 }, { x: 55, y: 210 }, { x: 10, y: 100 }], [{ x: 70, y: 10 }, { x: 90, y: 50 }, { x: 70, y: 90 }, { x: 30, y: 90 }, { x: 10, y: 50 }, { x: 30, y: 10 }]],
			answers: [],
			answersArray: [],
			arrows: [],
			from: -1,
			deleting: false,
			increase: false,
			increaseCount: 0,
			decreaseCount: 0,
			score: 0,
			state: "question", //controle , question , feedback
			feedbackText: "",
			additionalHTML: ""
		};
	},
	beforeMount: function beforeMount() {
		this.clear();
		this.buildInfoAddonHTML();

		//this.setTransitorSound('/media/gem_utrecht/transitors/punten.mp4');
	},
	mounted: function mounted() {
		this.showTransitorScore(true);
	},


	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(["lastQuestion", "currentBlock", "currentStage", "currentRound", "currentQuestion", "roundCount", "stageData", "roundCompleted", "scores", "questionData", "stageCount", "roundScore", "roundData"]), {
		items: function items() {
			return this.questionData.items;
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.question_background + ')';
		}
	}),

	watch: {
		currentQuestion: function currentQuestion(val) {
			this.clear();
		}
	},

	methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["setTransitorSound", "showTransitorScore", "increaseTransitorScore", "completeRound", "toNextQuestion", "addRoundScore", "logAnswers", "setRoundScore", "hideNextButton", "showNextButton", "setNextButtonAction"]), {
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},
		buildInfoAddonHTML: function buildInfoAddonHTML() {

			this.additionalHTML = '<div class="info">' + this.questionData.info + '</div>';

			this.additionalHTML += '<div class="item_info">';

			for (var i = 0; i < this.questionData.items.length; i++) {

				this.additionalHTML += '<div class="item">';
				this.additionalHTML += '<div class="item-header">' + this.questionData.items[i].name + '</div>';
				this.additionalHTML += '<div class="item-text">' + this.questionData.items[i].info + '</div>';
				this.additionalHTML += '</div>';
			}
			this.additionalHTML += '</div>';
		},
		toggleIncrease: function toggleIncrease() {
			this.increase = !this.increase;
		},
		onClickItem: function onClickItem(event, index) {
			var _this = this;

			if (this.deleting) {
				this.removeArrow(this.from, index);
				this.deleting = false;
				this.from = -1;
			} else {
				if (this.from == -1) {
					this.from = index;
				} else if (this.from == index) {
					this.from = -1;
				} else {
					var tempFrom = this.from;
					this.from = -1;

					if (this.drawArrow(tempFrom, index, this.increase)) {
						if (this.increase) this.increaseCount--;else this.decreaseCount--;
						this.answers.push({
							from: tempFrom,
							to: index,
							type: this.increase ? "increase" : "decrease"
						});

						if (this.increaseCount == 0 && this.decreaseCount == 0) {
							this.setNextButtonAction(function () {
								_this.showFeedback();
							}).then(function () {
								_this.showNextButton();
							});
							// this.setNextButtonAction(()=>{this.completeQuestion();}).then(()=>{
							// 	this.showNextButton();
							// });
						}
					}
				}
			}
		},
		showFeedback: function showFeedback() {
			var _this2 = this;

			this.answersArray.push(this.answers);
			var correctAnswers = this.questionData.answers;
			var correct = 0;

			console.log("correct answers before loop:");
			console.log(correct);

			for (var i = 0; i < this.answers.length; i++) {
				var answer = this.answers[i];

				for (var j = 0; j < correctAnswers.length; j++) {
					var correctAnswer = correctAnswers[j];

					var from = answer.from == +correctAnswer.from - 1;
					var to = answer.to == +correctAnswer.to - 1;
					var type = answer.type == "decrease" && correctAnswer.increase == "False" || answer.type == "increase" && correctAnswer.increase == "True";

					if (from && to && type) {
						correct++;
					}
				}
			}

			console.log("correct answers:");
			console.log(correct);

			if (correct == correctAnswers.length) {
				console.log("is example");
				console.log(this.questionData.example);

				if (this.questionData.example !== "True") {
					this.score++;
					this.increaseTransitorScore(+this.roundData.transitor_multiplier);
				}

				this.feedbackText = this.questionData.question_feedback.correct;
			} else {
				this.feedbackText = this.questionData.question_feedback.incorrect;
			}

			this.state = "feedback";

			setTimeout(function () {
				_this2.setNextButtonAction(function () {
					_this2.completeQuestion();
				}).then(function () {
					_this2.showNextButton();
					console.log("showing nextBTN");
				});
			}, 500);

			console.log("showing feedback");

			this.answers = [];
		},
		completeQuestion: function completeQuestion() {
			var _this3 = this;

			this.state = "question";
			if (this.lastQuestion) {
				this.setRoundScore(this.score / this.roundData.questions.length * 100).then(function () {

					console.log('storing system skills answers');
					console.log(_this3.answersArray);

					_this3.logAnswers(_this3.answersArray).then(function () {
						_this3.completeRound();
					});
				});
			} else this.toNextQuestion();
		},
		clear: function clear() {
			this.increaseCount = 0;
			this.decreaseCount = 0;
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.questionData.answers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var answer = _step.value;

					if (answer.increase === "True") {
						this.increaseCount++;
					} else {
						this.decreaseCount++;
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			if (this.decreaseCount > this.increaseCount) {
				this.increase = false;
			} else {
				this.increase = true;
			}

			this.from = -1;
			this.deleting = false;
			this.usedPositions = this.positions[this.items.length - 2];
			this.removeArrows();
			this.hideNextButton();
		},
		onPressItem: function onPressItem(event, index) {
			if (this.from == index && this.deleting == true) {
				this.from = -1;
				this.deleting = false;
			} else {
				this.from = index;
				this.deleting = true;
			}
		},
		removeArrow: function removeArrow(from, to) {
			var canvas = $("#" + "canvas_" + from + "_" + to);

			if (canvas.length) {
				var type = canvas.attr("datatype");
				for (var i = 0; i < this.answers.length; i++) {
					var answer = this.answers[i];
					if (answer.from === from && answer.to === to && type === answer.type) {
						if (type === "increase") this.increaseCount++;
						if (type === "decrease") this.decreaseCount++;
						this.answers.splice(i, 1);
						i--;
					}
				}
				canvas.remove();
				this.hideNextButton();
			}
		},
		removeArrows: function removeArrows() {
			var _iteratorNormalCompletion2 = true;
			var _didIteratorError2 = false;
			var _iteratorError2 = undefined;

			try {
				for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.arrows), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
					var arrow = _step2.value;

					if (arrow != null) {
						arrow.remove();
					}
				}
			} catch (err) {
				_didIteratorError2 = true;
				_iteratorError2 = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion2 && _iterator2.return) {
						_iterator2.return();
					}
				} finally {
					if (_didIteratorError2) {
						throw _iteratorError2;
					}
				}
			}

			this.arrows = [];
		},
		drawArrow: function drawArrow(from, to, increase) {
			if (increase && this.increaseCount == 0) return false;else if (!increase && this.decreaseCount == 0) return false;

			this.removeArrow(from, to);

			var id = "canvas_" + from + "_" + to;
			var w = parseInt($(".canvas-container").width());
			var h = parseInt($(".canvas-container").height());

			var arrowColor = increase ? "#ee4357" : "#48ddff";
			$("<canvas>").attr({
				id: id,
				width: w,
				height: h,
				class: "arrow-canvas",
				datatype: increase ? "increase" : "decrease"
			}).appendTo(".canvas-container");

			console.log(id);

			var canvas = $("#" + id);
			this.arrows.push(canvas);
			var context = canvas[0].getContext("2d");

			var items = $(".systeem-ui").find(".systeem-item");

			var startPos = this.usedPositions[from];
			var endPos = this.usedPositions[to];

			items.each(function (i) {
				if (i === from) startPos = $(this).position();
				if (i === to) endPos = $(this).position();
			});

			this.drawArrowContext(context, startPos.left, startPos.top, endPos.left, endPos.top, arrowColor);
			return true;
		},
		drawArrowContext: function drawArrowContext(ctx, fromx, fromy, tox, toy, color) {
			var headlen = 5;
			var angle = Math.atan2(toy - fromy, tox - fromx);
			//starting path of the arrow from the start square to the end square and drawing the stroke

			var distance = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot___default()(tox - fromx, toy - fromy);
			var degrees = this.calculateAngle(fromx, fromy, tox, toy);

			var fromPos = this.translateCoords(tox, toy, degrees - 180, distance - 35);
			var toPos = this.translateCoords(fromx, fromy, degrees, distance - 40);

			fromPos = this.translateCoords(fromPos.x, fromPos.y, degrees + 90, 6);
			toPos = this.translateCoords(toPos.x, toPos.y, degrees + 90, 6);

			var arrowPointLeft = {
				x: toPos.x - headlen * 2 * Math.cos(angle - Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle - Math.PI / 7)
			};

			var arrowPointRight = {
				x: toPos.x - headlen * 2 * Math.cos(angle + Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle + Math.PI / 7)
			};

			var tip = {
				x: toPos.x,
				y: toPos.y
			};

			ctx.beginPath();
			ctx.moveTo(fromPos.x, fromPos.y);
			ctx.lineTo(toPos.x, toPos.y);
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();

			//starting a new path from the head of the arrow to one of the sides of the point
			ctx.beginPath();
			ctx.moveTo(toPos.x, toPos.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);
			ctx.lineTo(arrowPointRight.x, arrowPointRight.y);
			ctx.lineTo(tip.x, tip.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);

			//draws the paths created above
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();
			ctx.fillStyle = color;
			ctx.fill();
		},
		calculateAngle: function calculateAngle(cx, cy, ex, ey) {
			var dy = ey - cy;
			var dx = ex - cx;
			var theta = Math.atan2(dy, dx); // range (-PI, PI]
			theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
			if (theta < 0) theta = 360 + theta; // range [0, 360)
			return theta;
		},
		translateCoords: function translateCoords(xCoord, yCoord, angle, length) {
			length = typeof length !== "undefined" ? length : 10;
			angle = angle * Math.PI / 180; // if you're using degrees instead of radians
			return {
				x: length * Math.cos(angle) + xCoord,
				y: length * Math.sin(angle) + yCoord
			};
		}
	})
});

/***/ }),

/***/ "Spgx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TBnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__("tU1g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a489087a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__("iGyP");
function injectStyle (ssrContext) {
  __webpack_require__("L1zI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a489087a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a489087a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TXff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--intro__block",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"stage__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container shadow-box"},[_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.subheader)}}),_vm._v(" "),_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.header)}}),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.story)}})]),_vm._v(" "),(_vm.visualExists && _vm.visualIsJson)?_c('Lottie',{staticStyle:{"margin":"auto","position":"relative"},attrs:{"animationpath":_vm.baseUrl + _vm.stageData.visual,"name":"intro-animation","loop":"true","ratio":"meet","autoplay":"true"}}):(_vm.visualExists)?_c('div',{staticClass:"centered",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.stageData.visual}})]):_vm._e(),_vm._v(" "),(_vm.stageData.slides.length > 0)?_c('div',{staticClass:"slider"},_vm._l((_vm.stageData.slides),function(slide,index){return _c('div',{staticClass:"slide"},[_c('div',{staticClass:"title",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(slide.title)}}),_vm._v(" "),_c('div',{staticClass:"slide-text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(slide.text)}}),_vm._v(" "),(typeof slide.visual !== 'undefined')?_c('img',{attrs:{"src":_vm.baseUrl + slide.visual}}):_vm._e()])})):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TpA2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("cTe4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6f06854_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("ay5c");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c6f06854_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UPRX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cutscene_Index_vue__ = __webpack_require__("EcAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DcpBlock_vue__ = __webpack_require__("QF+a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__intro_Index_vue__ = __webpack_require__("TpA2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__personalia_Index_vue__ = __webpack_require__("3ftg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Preloader_vue__ = __webpack_require__("juKD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Minigame_vue__ = __webpack_require__("kUzV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transitors_vue__ = __webpack_require__("RuP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_velocity_animate__ = __webpack_require__("9qgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__const_base__ = __webpack_require__("PY/H");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



//import Dcp from './dcp/Index.vue';













/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Minigame: __WEBPACK_IMPORTED_MODULE_6__Minigame_vue__["a" /* default */],
		Intro: __WEBPACK_IMPORTED_MODULE_3__intro_Index_vue__["a" /* default */],
		DcpBlock: __WEBPACK_IMPORTED_MODULE_2__DcpBlock_vue__["a" /* default */],
		Cutscene: __WEBPACK_IMPORTED_MODULE_1__cutscene_Index_vue__["a" /* default */],
		Transitors: __WEBPACK_IMPORTED_MODULE_7__Transitors_vue__["a" /* default */],
		Preloader: __WEBPACK_IMPORTED_MODULE_5__Preloader_vue__["a" /* default */],
		Personalia: __WEBPACK_IMPORTED_MODULE_4__personalia_Index_vue__["a" /* default */]
	},

	data: function data() {
		return {
			show: false,
			options: {
				dropzoneSelector: 'ul',
				draggableSelector: 'li',
				excludeOlderBrowsers: true,
				multipleDropzonesItemsDraggingEnabled: true,
				onDrop: function onDrop(event) {},
				onDragstart: function onDragstart(event) {},
				onDragend: function onDragend(event) {}
			}
		};
	},
	mounted: function mounted() {
		this.startBlockTransition();
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		baseUrl: function baseUrl() {
			return __WEBPACK_IMPORTED_MODULE_10__const_base__["a" /* url */];
		},
		nextButtonLabel: function nextButtonLabel() {

			if (__WEBPACK_IMPORTED_MODULE_10__const_base__["b" /* lang */] == 'FR') {
				return 'continuer';
			} else if (__WEBPACK_IMPORTED_MODULE_10__const_base__["b" /* lang */] == 'EN') {
				return 'next';
			}

			return 'verder';
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* mapGetters */])(["gameLoaded", "blockTransitioning", "blockType", "blockSettings", 'currentBlock', "lastBlock", "lastStage", "lastRound", "nextButtonShown", "stageType", "nextButtonAction", "nextButtonClass", "soundtrackPlaying", "sounds", "roundState"])),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["startBlockTransition", "stopBlockTransition", "toNextBlock", "toNextStage", "toNextRound", "hideNextButton", "setNextButtonAction", "setRoundState"]), {
		beforeEnter: function beforeEnter(el) {

			var xPos = 0;
			var opacity = 1;

			var transition = "Fade";
			if (this.blockSettings != null && this.blockSettings.transition != null) {
				transition = this.blockSettings.transition.in;
			}

			switch (transition) {
				case "Left":
					xPos = -460;
					break;
				case "Right":
					xPos = 460;
					break;
				case "Fade":
					opacity = 0;
					break;
				default:
					opacity = 0;
					break;
			}

			el.style.transform = "translateX(" + xPos + "px)";
			el.style.opacity = opacity;
			__WEBPACK_IMPORTED_MODULE_8_velocity_animate___default()(el, {
				translateX: xPos
			}, {
				duration: 0
			});
		},
		enter: function enter(el, done) {
			__WEBPACK_IMPORTED_MODULE_8_velocity_animate___default()(el, {
				translateX: 0,
				opacity: 1
			}, {
				duration: 500,
				easing: [0.39, 0.67, 0.04, 0.98],
				complete: function complete() {
					done();
				}
			});
		},
		beforeLeave: function beforeLeave(el) {
			el.style.opacity = 1;
		},
		leave: function leave(el, done) {
			var xPos = 0;
			var opacity = 1;
			var transition = "Fade";
			if (this.blockSettings != null && this.blockSettings.transition != null) {
				transition = this.blockSettings.transition.out;
			}

			switch (transition) {
				case "Left":
					xPos = -460;
					break;
				case "Right":
					xPos = 460;
					break;
				case "Fade":
					opacity = 0;
					break;
				default:
					opacity = 0;
					break;
			}

			__WEBPACK_IMPORTED_MODULE_8_velocity_animate___default()(el, {
				translateX: xPos,
				opacity: opacity
			}, {
				duration: 500,
				easing: [0.39, 0.67, 0.04, 0.98],
				complete: function complete() {
					done();
				}
			});
		},
		transitionOutReady: function transitionOutReady(e) {
			var _this = this;

			if (this.lastBlock) {} else {
				this.toNextBlock().then(function () {
					_this.startBlockTransition();
				});
			}
		},
		nextAction: function nextAction() {
			var _this2 = this;

			this.nextButtonAction();
			this.setNextButtonAction(null).then(function () {
				_this2.hideNextButton();
			});
		},
		next: function next() {
			if (!this.blockTransitioning) return;
			this.hideNextButton();

			if (this.stageType == "Rounds") {
				if (this.roundState == "intro") {
					this.setRoundState("explanation");
				} else if (this.roundState == "explanation") {
					this.setRoundState("round");
				} else if (this.roundState == "round") {
					this.setRoundState("feedback");
				} else {
					this.toNextStage();
				}
			} else if (this.lastStage) {
				if (this.lastRound) {
					this.stopBlockTransition();
				} else {
					this.toNextRound();
				}
			} else {
				if (this.lastRound) {
					this.toNextStage();
				} else {
					this.toNextRound();
				}
			}
		}
	})

});

/***/ }),

/***/ "UpZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Lottie_vue__ = __webpack_require__("uQpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['earths', 'wholeEarths', 'partlyEarth'],

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_2__Lottie_vue__["a" /* default */]
	},

	beforeMount: function beforeMount() {
		this.setFeedback();
	},
	mounted: function mounted() {
		var _this = this;

		var wholeEarths = Math.floor(this.totalsEarths);
		var partlyEarth = this.totalsEarths - wholeEarths;

		for (var i = 0; i < wholeEarths; i++) {
			$('.earths_visual').append('<img class="first-earth" src="' + this.baseUrl + this.roundData.questions.visual_earth_you + '">');
		};

		if (partlyEarth > 0.1) {
			$('.earths_visual').append('<img class="first-earth" src="' + this.baseUrl + this.roundData.questions.visual_half_earth_you + '">');
		}

		var wholeEarthsAvg = Math.floor(this.totalsEarthsAvg);
		var partlyEarthAvg = this.totalsEarthsAvg - wholeEarthsAvg;

		for (var i = 0; i < wholeEarthsAvg; i++) {
			$('.earths_visual_avg').append('<img class="first-earth" src="' + this.baseUrl + this.roundData.questions.visual_earth_average + '">');
		};

		if (partlyEarthAvg > 0.1) {
			$('.earths_visual_avg').append('<img class="first-earth" src="' + this.baseUrl + this.roundData.questions.visual_half_earth_average + '">');
		}

		var sendObj = {
			"user_id": this.userId,
			"instance_id": this.instanceId,
			"totalearths": this.totalsEarths,
			"earthsPerGroup": this.earthsPerGroup,
			"challenges_session_token": this.challengeToken
		};

		console.log('challengeToken: ' + this.challengeToken);

		if (this.challengeToken) {
			this.$socket.emit('finished impactchallenge', sendObj);
		}

		__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(this.apiUrl + 'api/v2/savesimpact', sendObj).then(function (response) {
			//console.log(response.status);
			//console.log("lol");
			//console.log(response.statusText);
			//console.log(response.body);
		}).catch(function (response) {
			//console.log("Error: ");
			//console.log(response);
		});

		if (this.challengeToken) {
			this.hideNextButton();
		} else {

			setTimeout(function () {
				_this.setNextButtonAction(_this.lastRound ? _this.toNextStage : _this.toNextRound).then(function () {
					_this.showNextButton();
				});
			}, 500);
		}
	},
	data: function data() {
		return {
			language: __WEBPACK_IMPORTED_MODULE_3__const_base__["b" /* lang */],
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			apiUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["c" /* api_url */],
			feedbackArray: [],
			averagesArray: [],
			pointsArray: [],
			earthsArray: [],
			userPoints: [],
			earthsPerItem: [],
			totalsPointDivider: 0,
			totalsEarths: 0,
			treeCompensation: 0,
			earthsPerGroup: [],
			earthsPerGroupAvg: [],
			totalPointsAvg: 832,
			totalsEarthsAvg: 3.6,
			ratios: [],
			highest_value: 0,
			labels: ["Spullen", "Vlees", "Zuivel & eieren", "Plantaardig, vis & drinken", "Auto", "Vliegen", "Openbaar Vervoer", "Wonen", "Badkamer"],
			text_parts: { 'jij': 'Jij', 'country': 'NL' }
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["setNextButtonAction", "showNextButton", "hideNextButton", "toNextStage", "toNextRound", "setUserImpact"]), {
		setWidth: function setWidth(value) {
			return "width: " + value + "%";
		},
		setLabels: function setLabels() {

			if (__WEBPACK_IMPORTED_MODULE_3__const_base__["b" /* lang */] == 'FR') {
				this.labels = ["Objets", "Viande", "Produits laitiers & Oeufs", "Aliments d'origine végétale", "Voiture", "L’avion", "Transports en commun", "Chez vous", "Douche"];

				this.text_parts = { 'jij': 'Vous', 'country': 'FR' };

				this.totalPointsAvg = 954;
				this.totalsEarthsAvg = 3.0;
			}
		},
		calculatedAveragesArray: function calculatedAveragesArray() {

			//loop over the questions and push each value to the array

			for (var i = 0; i < this.roundData.questions.questions.length; i++) {

				this.averagesArray.push(parseFloat(this.roundData.questions.questions[i].average));
			}

			console.log('calculatedAveragesArray');
			console.log(this.averagesArray);
		},
		calculatedPointsArray: function calculatedPointsArray() {

			//loop over the questions and push each value to the array

			for (var i = 0; i < this.roundData.questions.questions.length; i++) {

				this.pointsArray.push(parseFloat(this.roundData.questions.questions[i].points));
			}
		},
		calculatedEarthsArray: function calculatedEarthsArray() {

			//loop over the questions and push each value to the array

			for (var i = 0; i < this.roundData.questions.questions.length; i++) {

				this.earthsArray.push(parseFloat(this.roundData.questions.questions[i].earths));
			}
		},
		setFeedback: function setFeedback() {

			this.setLabels();

			this.calculatedAveragesArray();

			this.calculatedPointsArray();

			this.calculatedEarthsArray();

			for (var i = 0; i < this.feedbackData.userAnswers.length; i++) {

				var users_points = 0;
				var users_earths = 0;
				if (this.feedbackData.userAnswers[i] > 0) {

					var pointsDivider = this.averagesArray[i] / this.feedbackData.userAnswers[i];

					users_points = this.pointsArray[i] / pointsDivider;
					users_earths = this.earthsArray[i] / pointsDivider;
				}

				this.userPoints.push(users_points);
				this.earthsPerItem.push(users_earths);
			}

			var total = this.userPoints.reduce(function (previousValue, currentValue) {
				return currentValue + previousValue;
			});

			this.treeCompensation = 0;

			if (total > 0) {
				this.totalsPointDivider = this.totalPointsAvg / total;
				this.totalsEarths = this.totalsEarthsAvg / this.totalsPointDivider;
				this.treeCompensation = Math.round(this.totalsEarths / this.totalsEarthsAvg * 1946);
			} else {
				this.totalsPointDivider = 0;
				this.totalsEarths = 0;
			}

			this.totalsEarths = parseFloat(Math.round(this.totalsEarths * 100) / 100).toFixed(2);

			var group_0 = parseFloat(this.earthsPerItem[0] + this.earthsPerItem[1]).toFixed(2);
			var group_1 = parseFloat(this.earthsPerItem[2]).toFixed(2);
			var group_2 = parseFloat(this.earthsPerItem[3] + this.earthsPerItem[4] + this.earthsPerItem[5]).toFixed(2);
			var group_3 = parseFloat(this.earthsPerItem[6]).toFixed(2);
			var group_4 = parseFloat(this.earthsPerItem[7]).toFixed(2);
			var group_5 = parseFloat(this.earthsPerItem[8]).toFixed(2);
			var group_6 = parseFloat(this.earthsPerItem[9]).toFixed(2);
			var group_7 = parseFloat(this.earthsPerItem[10]).toFixed(2);
			var group_8 = parseFloat(this.earthsPerItem[11]).toFixed(2);

			this.earthsPerGroup = [group_0, group_1, group_2, group_3, group_4, group_5, group_6, group_7, group_8];
			console.log('earthsPerGroup: ' + this.earthsPerGroup);

			var group_0_avg = parseFloat(this.earthsArray[0] + this.earthsArray[1]).toFixed(2);
			var group_1_avg = parseFloat(this.earthsArray[2]).toFixed(2);
			var group_2_avg = parseFloat(this.earthsArray[3] + this.earthsArray[4] + this.earthsArray[5]).toFixed(2);
			var group_3_avg = parseFloat(this.earthsArray[6]).toFixed(2);
			var group_4_avg = parseFloat(this.earthsArray[7]).toFixed(2);
			var group_5_avg = parseFloat(this.earthsArray[8]).toFixed(2);
			var group_6_avg = parseFloat(this.earthsArray[9]).toFixed(2);
			var group_7_avg = parseFloat(this.earthsArray[10]).toFixed(2);
			var group_8_avg = parseFloat(this.earthsArray[11]).toFixed(2);

			this.earthsPerGroupAvg = [group_0_avg, group_1_avg, group_2_avg, group_3_avg, group_4_avg, group_5_avg, group_6_avg, group_7_avg, group_8_avg];
			console.log('earthsPerGroupAvg: ' + this.earthsPerGroupAvg);

			// this.ratios = [];

			// const ratio_group_0 = ( group_0 / (group_0+group_0_avg) ) *100;
			// const ratio_group_0_avg = ( group_0_avg / (group_0+group_0_avg) ) *100;
			// this.ratios.push([ratio_group_0, ratio_group_0_avg, this.labels[0]]);


			// const ratio_group_1 = ( group_1 / (group_1+group_1_avg) ) *100;
			// const ratio_group_1_avg = ( group_1_avg / (group_1+group_1_avg) ) *100;
			// this.ratios.push([ratio_group_1, ratio_group_1_avg, this.labels[1]]);


			// const ratio_group_2 = ( group_2 / (group_2+group_2_avg) ) *100;
			// const ratio_group_2_avg = ( group_2_avg / (group_2+group_2_avg) ) *100;
			// this.ratios.push([ratio_group_2, ratio_group_2_avg, this.labels[2]]);


			// const ratio_group_3 = ( group_3 / (group_3+group_3_avg) ) *100;
			// const ratio_group_3_avg = ( group_3_avg / (group_3+group_3_avg) ) *100;
			// this.ratios.push([ratio_group_3, ratio_group_3_avg, this.labels[3]]);


			//new method

			this.highest_value = 0;

			for (var _i = 0; _i < this.earthsPerGroup.length; _i++) {

				if (parseFloat(this.earthsPerGroup[_i]) > this.highest_value) {
					this.highest_value = this.earthsPerGroup[_i];

					console.log(_i + ' of user now has highest value: ' + this.highest_value);
				}
			}

			for (var _i2 = 0; _i2 < this.earthsPerGroupAvg.length; _i2++) {

				if (parseFloat(this.earthsPerGroupAvg[_i2]) > this.highest_value) {
					this.highest_value = this.earthsPerGroupAvg[_i2];

					console.log(_i2 + ' of avg now has highest value: ' + this.highest_value);
				}
			}

			this.ratios = [];

			var ratio_group_0 = this.earthsPerGroup[0] / this.highest_value * 100;
			var ratio_group_0_avg = this.earthsPerGroupAvg[0] / this.highest_value * 100;
			this.ratios.push([ratio_group_0, ratio_group_0_avg, this.labels[0]]);

			var ratio_group_1 = this.earthsPerGroup[1] / this.highest_value * 100;
			var ratio_group_1_avg = this.earthsPerGroupAvg[1] / this.highest_value * 100;
			this.ratios.push([ratio_group_1, ratio_group_1_avg, this.labels[1]]);

			var ratio_group_2 = this.earthsPerGroup[2] / this.highest_value * 100;
			var ratio_group_2_avg = this.earthsPerGroupAvg[2] / this.highest_value * 100;
			this.ratios.push([ratio_group_2, ratio_group_2_avg, this.labels[2]]);

			var ratio_group_3 = this.earthsPerGroup[3] / this.highest_value * 100;
			var ratio_group_3_avg = this.earthsPerGroupAvg[3] / this.highest_value * 100;
			this.ratios.push([ratio_group_3, ratio_group_3_avg, this.labels[3]]);

			var ratio_group_4 = this.earthsPerGroup[4] / this.highest_value * 100;
			var ratio_group_4_avg = this.earthsPerGroupAvg[4] / this.highest_value * 100;
			this.ratios.push([ratio_group_4, ratio_group_4_avg, this.labels[4]]);

			var ratio_group_5 = this.earthsPerGroup[5] / this.highest_value * 100;
			var ratio_group_5_avg = this.earthsPerGroupAvg[5] / this.highest_value * 100;
			this.ratios.push([ratio_group_5, ratio_group_5_avg, this.labels[5]]);

			var ratio_group_6 = this.earthsPerGroup[6] / this.highest_value * 100;
			var ratio_group_6_avg = this.earthsPerGroupAvg[6] / this.highest_value * 100;
			this.ratios.push([ratio_group_6, ratio_group_6_avg, this.labels[6]]);

			var ratio_group_7 = this.earthsPerGroup[7] / this.highest_value * 100;
			var ratio_group_7_avg = this.earthsPerGroupAvg[7] / this.highest_value * 100;
			this.ratios.push([ratio_group_7, ratio_group_7_avg, this.labels[7]]);

			var ratio_group_8 = this.earthsPerGroup[8] / this.highest_value * 100;
			var ratio_group_8_avg = this.earthsPerGroupAvg[8] / this.highest_value * 100;
			this.ratios.push([ratio_group_8, ratio_group_8_avg, this.labels[8]]);

			//console.log(this.ratios);


			console.log('setUserImpact: ' + this.totalsEarths);
			this.setUserImpact(this.totalsEarths);
		}
	}),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(["questionData", "feedbackData", "lastRound", "instanceId", "userId", 'roundData', "challengeToken"]), {

		backgroundImage: function backgroundImage() {

			if (typeof this.roundData.questions.question_background === 'undefined' || this.roundData.questions.question_background === null) {
				return 'none';
			}

			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}

	})

});

/***/ }),

/***/ "V/eJ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgd2lkdGg9IjE1cHgiIGhlaWdodD0iMjBweCIgdmlld0JveD0iMCAwIDE1IDIwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OS4yICg1MTE2MCkgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+R3JvdXAgNTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJTeXN0ZWVtLW1vZHVsZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIzOC4wMDAwMDAsIC01NDAuMDAwMDAwKSIgc3Ryb2tlPSIjRUU0MzU3IiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjQwLjAwMDAwMCwgNTQyLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTIiIHBvaW50cz0iMCA3IDYgMSAxMiA3Ij48L3BvbHlsaW5lPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTYsMC41IEw2LDE3LjUiIGlkPSJQYXRoLTQiPjwvcGF0aD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),

/***/ "Vp8e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("M0X4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a776c01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("N95X");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a776c01_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WGiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("JaHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b82324d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("rnhp");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b82324d_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WGjt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwipeImage_vue__ = __webpack_require__("tCaD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df627c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwipeImage_vue__ = __webpack_require__("ntFc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SwipeImage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df627c66_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SwipeImage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WJ8w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot__ = __webpack_require__("KmDb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__ = __webpack_require__("Zp/M");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Score: __WEBPACK_IMPORTED_MODULE_3__Score_vue__["a" /* default */],
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_6__ExplanationPopup_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_4__const_base__["a" /* url */],
			explanationPopupActive: false,
			usedPositions: [],
			positions: [[{ x: 50, y: 10 }, { x: 50, y: 95 }], [{ x: 50, y: 10 }, { x: 80, y: 75 }, { x: 20, y: 75 }], [{ x: 50, y: 10 }, { x: 90, y: 50 }, { x: 50, y: 90 }, { x: 10, y: 50 }], [{ x: 50, y: 10 }, { x: 230, y: 100 }, { x: 185, y: 210 }, { x: 55, y: 210 }, { x: 10, y: 100 }], [{ x: 70, y: 10 }, { x: 90, y: 50 }, { x: 70, y: 90 }, { x: 30, y: 90 }, { x: 10, y: 50 }, { x: 30, y: 10 }]],
			arrows: [],
			score: 0,
			answers: [],
			state: "question",
			feedbackText: "",
			additionalHTML: ""
		};
	},
	beforeMount: function beforeMount() {
		this.clear();
		this.buildInfoAddonHTML();
	},


	computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(["lastQuestion", "currentQuestion", "questionData", "roundData", "questionCount"]), {
		items: function items() {
			if (typeof this.questionData.items === "undefined") {
				this.questionData.items = [];
			}
			return this.questionData.items;
		}
	}),

	watch: {
		currentQuestion: function currentQuestion(val) {
			this.clear();
		}
	},

	mounted: function mounted() {
		this.showTransitorScore(true);

		console.log(this.items.length);
		if (this.items.length) {
			this.drawArrowCanvas();
		}
	},


	methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(["showTransitorScore", "increaseTransitorScore", "completeRound", "toNextQuestion", "setRoundScore", "logAnswers", "hideNextButton", "showNextButton", "setNextButtonAction"]), {
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},
		buildInfoAddonHTML: function buildInfoAddonHTML() {

			// this.additionalHTML = '<div class="info">'+this.questionData.info+'</div>';

			// this.additionalHTML += '<div class="item_info">';

			// for (let i = 0; i < this.questionData.answers.length; i++) {

			// 	this.additionalHTML += '<div class="item">';
			// 	this.additionalHTML += '<div class="item-header">'+this.questionData.answers[i].answer+'</div>';
			// 	this.additionalHTML += '<div class="item-text">'+this.questionData.answers[i].info+'</div>';
			// 	this.additionalHTML += '</div>';

			// }
			// this.additionalHTML += '</div>';


			this.additionalHTML = this.roundData.rules;
		},
		drawArrowCanvas: function drawArrowCanvas() {
			var _this = this;

			if (this.items.length < 1) {
				return false;
			}

			var itemSpeed = 0;
			var arrowSpeed = 0;
			var positions = this.positions[this.items.length - 2];
			this.usedPositions = [];

			var _loop = function _loop(i) {
				setTimeout(function () {
					_this.usedPositions.push(positions[i]);
				}, i * itemSpeed);
				//this.usedPositions = this.positions[this.items.length-2];
			};

			for (var i = 0; i < positions.length; i++) {
				_loop(i);
			}

			var _loop2 = function _loop2(i) {
				setTimeout(function () {
					var arrow = _this.questionData.arrows[i];
					_this.drawArrow(+arrow.from, +arrow.to, arrow.increase === "True");
				}, i * arrowSpeed + _this.items.length * itemSpeed);
			};

			for (var i = 0; i < this.questionData.arrows.length; i++) {
				_loop2(i);
			}
		},
		onAnswer: function onAnswer(index) {
			var _this2 = this;

			this.answers.push(index);
			if (index == +this.questionData.correct_answer - 1) {
				this.feedbackText = this.questionData.question_feedback.correct;
				this.increaseTransitorScore(+this.roundData.transitor_multiplier);
				this.score++;
			} else {
				this.feedbackText = this.questionData.question_feedback.incorrect;
			}

			this.setRoundScore(this.score / this.questionCount * 100).then(function () {
				_this2.logAnswers(_this2.answers).then(function () {
					_this2.clear();
					_this2.toFeedback();
				});
			});
		},
		toFeedback: function toFeedback() {
			var _this3 = this;

			this.state = "feedback";

			setTimeout(function () {
				_this3.setNextButtonAction(function () {
					if (_this3.lastQuestion) {
						_this3.completeRound();
					} else {
						_this3.toNextQuestion().then(function () {
							_this3.state = "question";
							_this3.buildInfoAddonHTML();
							_this3.drawArrowCanvas();
						});
					}
				}).then(function () {
					_this3.showNextButton();
				});
			}, 500);
		},
		onClickItem: function onClickItem(event, index) {
			var _this4 = this;

			if (this.deleting) {
				this.removeArrow(this.from, index);
				this.deleting = false;
				this.from = -1;
			} else {
				if (this.from == -1) {
					this.from = index;
				} else if (this.from == index) {
					this.from = -1;
				} else {
					var tempFrom = this.from;
					this.from = -1;

					if (this.drawArrow(tempFrom, index, this.increase)) {
						if (this.increase) this.increaseCount--;else this.decreaseCount--;
						this.answers.push({
							from: tempFrom,
							to: index,
							type: this.increase ? "increase" : "decrease"
						});

						if (this.increaseCount == 0 && this.decreaseCount == 0) {
							this.setNextButtonAction(this.completeQuestion).then(function () {
								_this4.showNextButton();
							});
						}
					}
				}
			}
		},
		completeQuestion: function completeQuestion() {
			var _this5 = this;

			this.increaseTransitorScore(10).then(function () {
				if (_this5.lastQuestion) _this5.completeRound();else _this5.toNextQuestion();
			});
		},
		clear: function clear() {
			this.removeArrows();
		},
		removeArrows: function removeArrows() {
			var _iteratorNormalCompletion = true;
			var _didIteratorError = false;
			var _iteratorError = undefined;

			try {
				for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.arrows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
					var arrow = _step.value;

					if (arrow != null) {
						arrow.remove();
					}
				}
			} catch (err) {
				_didIteratorError = true;
				_iteratorError = err;
			} finally {
				try {
					if (!_iteratorNormalCompletion && _iterator.return) {
						_iterator.return();
					}
				} finally {
					if (_didIteratorError) {
						throw _iteratorError;
					}
				}
			}

			this.arrows = [];
		},
		drawArrow: function drawArrow(from, to, increase) {
			var id = "canvas_" + from + "_" + to;
			var w = parseInt($(".canvas-container").width());
			var h = parseInt($(".canvas-container").height());

			var arrowColor = increase ? "#e76740" : "#3abbd6";
			$("<canvas>").attr({
				id: id,
				width: w,
				height: h,
				class: "arrow-canvas",
				datatype: increase ? "increase" : "decrease"
			}).appendTo(".canvas-container");

			var canvas = $("#" + id);
			this.arrows.push(canvas);
			var context = canvas[0].getContext("2d");

			var items = $(".systeem-ui").find(".systeem-item");

			var startPos = this.usedPositions[from];
			var endPos = this.usedPositions[to];

			items.each(function (i) {
				if (i === from) startPos = $(this).position();
				if (i === to) endPos = $(this).position();
			});

			this.drawArrowContext(context, startPos.left, startPos.top, endPos.left, endPos.top, arrowColor);
			return true;
		},
		drawArrowContext: function drawArrowContext(ctx, fromx, fromy, tox, toy, color) {
			var headlen = 5;
			var angle = Math.atan2(toy - fromy, tox - fromx);
			//starting path of the arrow from the start square to the end square and drawing the stroke

			var distance = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_hypot___default()(tox - fromx, toy - fromy);
			var degrees = this.calculateAngle(fromx, fromy, tox, toy);

			var fromPos = this.translateCoords(tox, toy, degrees - 180, distance - 35);
			var toPos = this.translateCoords(fromx, fromy, degrees, distance - 40);

			fromPos = this.translateCoords(fromPos.x, fromPos.y, degrees + 90, 6);
			toPos = this.translateCoords(toPos.x, toPos.y, degrees + 90, 6);

			//console.log(fromPos);

			var arrowPointLeft = {
				x: toPos.x - headlen * 2 * Math.cos(angle - Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle - Math.PI / 7)
			};

			var arrowPointRight = {
				x: toPos.x - headlen * 2 * Math.cos(angle + Math.PI / 7),
				y: toPos.y - headlen * 2 * Math.sin(angle + Math.PI / 7)
			};

			var tip = {
				x: toPos.x,
				y: toPos.y
			};

			ctx.beginPath();
			ctx.moveTo(fromPos.x, fromPos.y);
			ctx.lineTo(toPos.x, toPos.y);
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();

			//starting a new path from the head of the arrow to one of the sides of the point
			ctx.beginPath();
			ctx.moveTo(toPos.x, toPos.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);
			ctx.lineTo(arrowPointRight.x, arrowPointRight.y);
			ctx.lineTo(tip.x, tip.y);
			ctx.lineTo(arrowPointLeft.x, arrowPointLeft.y);

			//draws the paths created above
			ctx.strokeStyle = color;
			ctx.lineWidth = 4;
			ctx.stroke();
			ctx.fillStyle = color;
			ctx.fill();
		},
		calculateAngle: function calculateAngle(cx, cy, ex, ey) {
			var dy = ey - cy;
			var dx = ex - cx;
			var theta = Math.atan2(dy, dx); // range (-PI, PI]
			theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
			if (theta < 0) theta = 360 + theta; // range [0, 360)
			return theta;
		},
		translateCoords: function translateCoords(xCoord, yCoord, angle, length) {
			length = typeof length !== "undefined" ? length : 10;
			angle = angle * Math.PI / 180; // if you're using degrees instead of radians
			return {
				x: length * Math.cos(angle) + xCoord,
				y: length * Math.sin(angle) + yCoord
			};
		}
	})
});

/***/ }),

/***/ "WlNb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__ = __webpack_require__("uQpZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__["a" /* default */]
	},

	props: ['onClick', 'additionalHTML'],

	mounted: function mounted() {},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_1__const_base__["a" /* url */]
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(['setNextButtonAction', 'showNextButton', 'setRoundState', 'setRoundExplained'])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['roundData', "stageData"]), {
		fullHTML: function fullHTML() {
			var html = this.roundData.questions.explanation;

			if (typeof this.additionalHTML !== 'undefined') {
				if (this.additionalHTML !== '') {
					html += '<div class="additional-html">';
					html += this.additionalHTML;
					html += '</div>';
				}
			}

			return html;
		},
		visualExists: function visualExists() {
			return this.roundData != null && this.roundData.questions.visual != null;
		},
		visualIsJson: function visualIsJson() {
			if (this.roundData == null || this.roundData.questions.visual == null) return false;
			var fileExtension = this.roundData.questions.visual.substr(this.roundData.questions.visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'json';
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.explanation_background + ')';
		}
	})

});

/***/ }),

/***/ "XM2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("vxI4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_517e8dd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("IE+t");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_517e8dd0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YVsT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},[_c('div',{staticClass:"score__bar"},[_c('div',{staticClass:"score__filler",style:(_vm.style)}),_vm._v(" "),_c('p',{staticClass:"score__text"},[_vm._v(_vm._s(Math.round(_vm.usedPercentage))+" / 100")])]),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Root__ = __webpack_require__("tBSM");




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		name: 'Root',
		component: __WEBPACK_IMPORTED_MODULE_2__components_Root__["a" /* default */],
		props: function props(route) {
			return {
				teamcode: route.query.teamcode,
				resp_id: route.query.resp_id,
				challenge_token: route.query.challenge_token
			};
		}
	}]
}));

/***/ }),

/***/ "Yh8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage score-screen",class:_vm.blocks[_vm.currentBlock].settings.score.template,style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"background-overlay score-screen__background-overlay"},[_c('div',{staticClass:"content-container"},[_c('HeaderBlock',{attrs:{"header":_vm.stageData.header,"subHeader":_vm.stageData.subheader,"bodytext":_vm.stageData.feedback}}),_vm._v(" "),(_vm.visualExists)?_c('div',{staticClass:"centered",staticStyle:{"position":"relative"}},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.stageData.visual}})]):_vm._e(),_vm._v(" "),(_vm.blocks[_vm.currentBlock].settings.score.template == 'Bars')?_c('div',{staticClass:"totem"},[_vm._l((_vm.totem.visuals),function(score,index){return _c('div',{staticClass:"totemRow",class:_vm.totem.types[_vm.totem.visuals.length-1-index]+' row_'+index},[(_vm.totem.types[_vm.totem.types.length-1-index]!=='SDG')?_c('div',{staticClass:"totemRow__item"},[_c('div',{staticClass:"totemRow__item--holder"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.totem.visuals[_vm.totem.visuals.length-1-index]}})])]):_vm._e(),_vm._v(" "),(_vm.totem.types[_vm.totem.types.length-1-index]!=='SDG')?_c('div',{staticClass:"totemRow__item-text"},[(_vm.totem.scores[_vm.totem.visuals.length-1-index] >= 0)?_c('div',{staticClass:"positioner"},[_c('h5',[_vm._v(_vm._s(_vm.totem.labels[_vm.totem.visuals.length-1-index]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.totem.scores[_vm.totem.visuals.length-1-index])+"/100")]),_vm._v(" "),_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar__length",style:({ 'width': _vm.totem.scores[_vm.totem.visuals.length-1-index] + '%' })})])]):_c('div',{staticClass:"positioner disabled"},[_c('h5',[_vm._v(_vm._s(_vm.totem.labels[_vm.totem.visuals.length-1-index]))])])]):_vm._e(),_vm._v(" "),(_vm.totem.types[_vm.totem.types.length-1-index]==='SDG')?_c('div',{staticClass:"totemRow__item"},[_c('div',{staticClass:"totemRow__item--holder"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.totem.visuals[_vm.totem.visuals.length-1-index]}})])]):_vm._e(),_vm._v(" "),(_vm.totem.types[_vm.totem.types.length-1-index]==='SDG')?_c('div',{staticClass:"totemRow__item-text"},[(_vm.totem.sdgs[_vm.totem.visuals.length-1-index].sdgCount.length == 0)?_c('div',{staticClass:"positioner disabled"},[_c('h5',[_vm._v(_vm._s(_vm.totem.labels[_vm.totem.visuals.length-1-index]))])]):_c('div',{staticClass:"positioner"},[_c('h5',[_vm._v(_vm._s(_vm.totem.labels[_vm.totem.visuals.length-1-index])+" : "+_vm._s(_vm.typeLabels[_vm.totem.sdgs[_vm.totem.visuals.length-1-index].bestCluster]))])])]):_vm._e()])}),_vm._v(" "),(_vm.userImpact)?_c('div',{staticClass:"totemRow totemRow-impactScore"},[_c('div',{staticClass:"earthHoder earths_visual"})]):_vm._e()],2):(_vm.blocks[_vm.currentBlock].settings.score.template == 'Dashboard')?_c('div',{staticClass:"totem"},[_c('div',{staticClass:"totemContainer"},[_vm._l((_vm.totem.visuals),function(score,index){return _c('div',{staticClass:"totemItem"},[_c('div',{staticClass:"totemItem__item"},[_c('div',{staticClass:"totemItem__item--holder"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.totem.visuals[_vm.totem.visuals.length-1-index]}})])])])}),_vm._v(" "),_vm._l((_vm.totem.visuals),function(score,index){return _c('div',{staticClass:"totemLabel",class:'pos_'+index},[_c('div',{staticClass:"totemLabel__item-text"},[(_vm.totem.scores[_vm.totem.visuals.length-1-index] >= 0)?_c('div',{staticClass:"positioner"},[_c('p',[_vm._v(_vm._s(_vm.totem.labels[_vm.totem.visuals.length-1-index])+": "+_vm._s(_vm.totem.scores[_vm.totem.visuals.length-1-index])+"%")])]):_vm._e()])])})],2),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.stageData.feedback)+"\n\t\t\t\t")]),_vm._v(" "),(_vm.userImpact)?_c('div',{staticClass:"totemRow totemRow-impactScore"},[_c('div',{staticClass:"earthHoder earths_visual"})]):_vm._e()]):(_vm.blocks[_vm.currentBlock].settings.score.template == 'Ladder')?_c('div',{staticClass:"totem"},[_vm._l((_vm.totem.visuals),function(score,index){return _c('div',{staticClass:"totemRow"},[_c('div',{staticClass:"totemRow__item"},[_c('div',{staticClass:"totemRow__item--holder"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.totem.visuals[_vm.totem.visuals.length-1-index]}})])]),_vm._v(" "),_c('div',{staticClass:"totemRow__item-text",class:'pos_'+index},[(_vm.totem.scores[_vm.totem.visuals.length-1-index] >= 0)?_c('div',{staticClass:"positioner"},[_c('h5',[_vm._v(_vm._s(_vm.totem.labels[_vm.totem.visuals.length-1-index]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.totem.scores[_vm.totem.visuals.length-1-index])+"%")])]):_vm._e()])])}),_vm._v(" "),(_vm.userImpact)?_c('div',{staticClass:"totemRow totemRow-impactScore"},[_c('div',{staticClass:"earthHoder earths_visual"})]):_vm._e()],2):_c('div',{staticClass:"totem"},[_vm._l((_vm.totem.visuals),function(score,index){return _c('div',{staticClass:"totemRow"},[_c('div',{staticClass:"totemRow__item"},[_c('div',{staticClass:"totemRow__item--holder"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.totem.visuals[_vm.totem.visuals.length-1-index]}})])]),_vm._v(" "),_c('div',{staticClass:"totemRow__item-text",class:'pos_'+index},[(_vm.totem.scores[_vm.totem.visuals.length-1-index] >= 0)?_c('div',{staticClass:"positioner"},[_c('h5',[_vm._v(_vm._s(_vm.totem.labels[_vm.totem.visuals.length-1-index]))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.totem.scores[_vm.totem.visuals.length-1-index])+"/100")])]):_vm._e()])])}),_vm._v(" "),(_vm.userImpact)?_c('div',{staticClass:"totemRow totemRow-impactScore"},[_c('div',{staticClass:"earthHoder earths_visual"})]):_vm._e()],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z71r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state == 'question')?_c('div',{staticClass:"stage stage--systeemdenken-controle"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.header)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.subheader)+"\n\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('div',{staticClass:"systeem-container shadow-box shadow-box-systeemdenken"},[(_vm.questionData.visual !== undefined && _vm.questionData.visual !== null && _vm.questionData.visual !== '')?_c('img',{staticClass:"systeem__image",attrs:{"src":_vm.baseUrl + _vm.questionData.visual}}):_c('div',{staticClass:"systeem"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"systeem-ui"},_vm._l((_vm.items),function(item,index){return (_vm.usedPositions.length > index)?_c('div',{key:index,staticClass:"systeem-item",style:({left:_vm.usedPositions[index].x+'%',top:_vm.usedPositions[index].y+'%'})},[(item.icon !== undefined && item.icon !== null)?_c('img',{staticClass:"systeem-item-icon",attrs:{"src":item.icon}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item__content"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t")])]):_vm._e()}))])]),_vm._v(" "),_c('div',{staticClass:"question_text",staticStyle:{"position":"relative","margin-top":"30px","text-align":"center"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.questionData.questiontext)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"systeem-controls"},_vm._l((_vm.questionData.answers),function(answer,index){return _c('div',{key:index,staticClass:"btn btn-progres systeemdenken_multiquiz__button",staticStyle:{"margin-top":"10px"},attrs:{"index":index},on:{"click":function (){_vm.onAnswer(index);}}},[_vm._v("\n\t\t\t\t"+_vm._s(answer.answer)+"\n\t\t\t")])})),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"additionalHTML":_vm.additionalHTML,"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)]):_c('div',{staticClass:"stage stage--systeemdenken-controle-feedback"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header"},[_vm._v("\n\t\t\t"+_vm._s(_vm.roundData.header)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader"},[_vm._v("\n\t\t\t"+_vm._s(_vm.roundData.subheader)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n\t\t\t"+_vm._s(_vm.feedbackText)+"\n\t\t")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"systeem-canvas"},[_c('div',{staticClass:"canvas-container"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ziio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__ = __webpack_require__("uQpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__["a" /* default */]
	},

	beforeMount: function beforeMount() {
		this.findCorrectFeedback();
		this.setFeedback();
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(_this.lastRound ? _this.toNextStage : _this.toNextRound).then(function () {
				_this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": true });
			});
		}, 500);

		this.increaseTransitorScore(this.feedbackData.transitors);
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */],
			selectedFeedbackIndex: -1,
			feedbackArray: []
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["setNextButtonAction", "showNextButton", "toNextStage", "toNextRound", "increaseTransitorScore"]), {
		findCorrectFeedback: function findCorrectFeedback() {

			console.log(this.feedbackData.totalScores * 10);

			if (this.roundData == null || this.roundData.questions.feedback == null) return;
			var index = 0;
			for (var i = 0; i < this.roundData.questions.feedback.length; i++) {
				var fb = this.roundData.questions.feedback[i];
				if (+fb.score <= this.feedbackData.totalScores * 10 && +fb.score >= +this.roundData.questions.feedback[index].score) {
					index = i;
				}
			}
			this.selectedFeedbackIndex = index;
		},
		setFeedback: function setFeedback() {
			for (var i = 0; i < this.questionData.items.length; i++) {
				var item = this.questionData.items[i];
				var _text = "";
				if (this.feedbackData.currentScores[i] > +this.feedbackData.correctScores[i]) _text = item.text_high;else if (this.feedbackData.currentScores[i] < +this.feedbackData.correctScores[i]) _text = item.text_low;else _text = item.text_correct;

				var percentage = Math.floor(this.feedbackData.correctScores[i] / this.questionData.total_items * 100);

				var _text = _text.replace("[%]", percentage + "%");
				this.feedbackArray.push(_text);
			}
		}
	}),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["questionData", "feedbackData", "lastRound", 'roundData']), {
		feedback: function feedback() {
			return this.selectedFeedbackIndex >= 0 ? this.roundData.questions.feedback[this.selectedFeedbackIndex] : { header: "Undefined header", subheader: "Undefined subheader", feedbacktext: "Undefined text", visual: "undefined" };
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}
	})

});

/***/ }),

/***/ "Zilf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zp/M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExplanationPopup_vue__ = __webpack_require__("WlNb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f5acf3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExplanationPopup_vue__ = __webpack_require__("wIOi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExplanationPopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f5acf3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExplanationPopup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZqlF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__ = __webpack_require__("Gp+1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3a5ff9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__ = __webpack_require__("leLd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c3a5ff9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a9mt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("UpZu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034e6886_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("xVd5");
function injectStyle (ssrContext) {
  __webpack_require__("aeUS")
  __webpack_require__("xYNo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-034e6886"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_034e6886_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aCIB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__ = __webpack_require__("Pz+2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfbefe12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__ = __webpack_require__("TXff");
function injectStyle (ssrContext) {
  __webpack_require__("HTXY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dfbefe12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Intro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dfbefe12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Intro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aMez":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state === 'question')?_c('div',{staticClass:"stage stage--systeemdenken",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.header)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.subheader)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.questionData.questiontext)+"\n\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('div',{staticClass:"systeem-container shadow-box shadow-box-systeemdenken card card-system"},[_c('div',{staticClass:"reset-button",on:{"click":_vm.clear}},[_c('i',{staticClass:"fa fa-repeat",staticStyle:{"line-height":"40px","color":"#fff","font-size":"24px"}})]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"systeem"},[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"systeem-ui"},_vm._l((_vm.items),function(item,index){return _c('v-touch',{key:index,on:{"tap":function (e) {_vm.onClickItem(e,index)},"press":function (e) {_vm.onPressItem(e,index)}}},[_c('div',{staticClass:"systeem-item",class:{
								'active' : _vm.from==index,
								'deleting' : _vm.deleting==true && _vm.from==index,
							},style:({
								left:_vm.usedPositions[index].x+'%',
								top:_vm.usedPositions[index].y+'%',
								'box-shadow': item.icon !== undefined && item.icon !== null ? '0 0 0px rgba(0,0,0,0.05)' : '0 0 5px #ccc',
							})},[(item.icon !== undefined && item.icon !== null)?_c('img',{staticClass:"systeem-item-icon-img",class:{'active' : _vm.from==index, 'deleting' : _vm.deleting==true && _vm.from==index},attrs:{"src":_vm.baseUrl + item.icon}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item__content",class:{'text-offset' : item.icon !== undefined && item.icon !== null}},[_vm._v("\n\t\t\t\t\t\t\t\t"+_vm._s(item.name)+"\n\t\t\t\t\t\t\t")])])])}))])]),_vm._v(" "),_c('div',{staticClass:"systeem-controls"},[_c('div',{staticStyle:{"text-align":"center"}},[_c('table',[_c('tr',[_c('td',{staticStyle:{"width":"30%","text-align":"right"}},[_c('span',{staticStyle:{"color":"#48ddff","font-weight":"bold"}},[_vm._v(_vm._s(_vm.decreaseCount))])]),_vm._v(" "),_c('td',{staticStyle:{"width":"30px","text-align":"center"}},[_c('span',{staticClass:"arrow-icon__container",on:{"click":function (){_vm.increase = false;}}},[_c('img',{staticClass:"icon",staticStyle:{"width":"14px","height":"20px"},attrs:{"src":__webpack_require__("9KaW")}})])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_c('label',{staticClass:"switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.increase),expression:"increase"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.increase)?_vm._i(_vm.increase,null)>-1:(_vm.increase)},on:{"change":function($event){var $$a=_vm.increase,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.increase=$$a.concat([$$v]))}else{$$i>-1&&(_vm.increase=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.increase=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])]),_vm._v(" "),_c('td',{staticStyle:{"width":"30px","text-align":"center"}},[_c('span',{staticClass:"arrow-icon__container",on:{"click":function (){_vm.increase = true;}}},[_c('img',{staticClass:"icon",staticStyle:{"width":"14px","height":"20px"},attrs:{"src":__webpack_require__("V/eJ")}})])]),_vm._v(" "),_c('td',{staticStyle:{"width":"30%","text-align":"left"}},[_c('span',{staticStyle:{"color":"#ee4357","font-weight":"bold"}},[_vm._v(_vm._s(_vm.increaseCount))])])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block","width":"auto"}})])]),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"additionalHTML":_vm.additionalHTML,"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)]):(_vm.state === 'feedback')?_c('div',{staticClass:"stage stage--systeemdenken-feedback"},[_c('div',{staticClass:"header__container flex flexColumn"},[_c('div',{staticClass:"header order-1",staticStyle:{"position":"relative","text-align":"center"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.roundData.header)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"text order-2",staticStyle:{"position":"relative","margin-top":"30px"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.feedbackText)+"\n\t\t")])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"world-button"},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("lerZ")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"systeem-canvas"},[_c('div',{staticClass:"canvas-container"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aRDL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Score_vue__ = __webpack_require__("QG5F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button_vue__ = __webpack_require__("Vp8e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Score: __WEBPACK_IMPORTED_MODULE_1__Score_vue__["a" /* default */],
		AnswerButton: __WEBPACK_IMPORTED_MODULE_2__Button_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */],
			score: 0,
			answers: []
		};
	},
	mounted: function mounted() {
		this.score = 0;
		this.showTransitorScore(true);
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapGetters */])(["lastQuestion", "questionData", "roundData", "questionCount"]), {

		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}

	}),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["completeRound", "toNextQuestion", "setRoundScore", "logAnswers", "increaseTransitorScore", "showTransitorScore"]), {
		onQuestionAnswer: function onQuestionAnswer(e) {
			var _this = this;

			var correctAnswer = +this.questionData.correct_answer;
			correctAnswer--;

			this.answers.push(e);
			if (e == correctAnswer) {
				this.increaseTransitorScore(+this.roundData.transitor_multiplier);
				this.score++;
			}

			if (this.lastQuestion) {
				this.setRoundScore(this.score / this.questionCount * 100).then(function () {
					_this.logAnswers(_this.answers).then(function () {
						_this.completeRound();
					});
				});
			} else {
				this.toNextQuestion();
			}
		}
	})

});

/***/ }),

/***/ "aeUS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "agtp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ay5c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--intro",class:'block'+_vm.currentBlock,style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"stage--intro__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container header__container-intro"},[(_vm.isAnimation)?_c('div',{staticClass:"animated-header",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"animated-header-part1"},[_vm._v(_vm._s(_vm.textAnimationParts[0]))]),_vm._v(" "),_c('div',{staticClass:"animated-header-part2",class:_vm.isShown},[_vm._v(_vm._s(_vm.textAnimationParts[1]))]),_vm._v(" "),_c('div',{staticClass:"animated-header-part3"},[_vm._v(_vm._s(_vm.textAnimationParts[2]))])]):_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.header)}}),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative","text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.stageData.subheader)}}),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.stageData.story)}})]),_vm._v(" "),_c('div',{staticClass:"visual-container"},[(_vm.visualExists && _vm.visualIsJson)?_c('Lottie',{staticStyle:{"margin":"auto","position":"absolute"},attrs:{"animationpath":_vm.baseUrl + _vm.stageData.visual,"audiopath":false,"name":"intro-animation","loop":"true","ratio":"slice","autoplay":"true"}}):(_vm.visualExists)?_c('div',{staticClass:"centered centered-fluid",style:(_vm.opacity_style_base)},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.stageData.visual}})]):_vm._e(),_vm._v(" "),(_vm.visualExists && _vm.visualIsJson && _vm.visualOverlayExists)?_c('Lottie',{staticStyle:{"margin":"auto","position":"absolute"},attrs:{"animationpath":_vm.baseUrl + _vm.stageData.visual_overlay,"audiopath":false,"name":"intro-animation-overlay","loop":"true","ratio":"slice","autoplay":"true","opacity":_vm.opacity}}):(_vm.visualExists && _vm.visualOverlayExists)?_c('div',{staticClass:"centered centered-fluid overlay",style:(_vm.opacity_style)},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.stageData.visual_overlay}})]):_vm._e()],1),_vm._v(" "),(_vm.isAnimation)?_c('div',{staticClass:"slider-holder"},[_vm._v("\n\t\t\t\t0 \n\t\t\t\t"),_vm._m(0,false,false),_vm._v("\n\t\t\t\t 100\n\t\t\t\t"),_c('div',{staticClass:"slider-hint",class:_vm.understood},[_vm._v("Sleep!")])]):_vm._e(),_vm._v(" "),(_vm.showVerifyEmail && !_vm.emailVerificationCompleted)?_c('div',{staticClass:"popup email-verification",style:({ 'background-image': _vm.verficiationBackgroundImage })},[(!_vm.tokenRequested)?_c('div',{staticClass:"form-section"},[_c('div',{staticClass:"header__container header__container-verification"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.globalSettings.verification.header)}}),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative","text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.globalSettings.verification.subheader)}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.globalSettings.verification.text)}}),_vm._v(" "),_c('div',{staticClass:"input_container"},[_vm._m(1,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"textfield",attrs:{"type":"text","placeholder":"E-mail"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"feedback"},[_vm._v(_vm._s(_vm.verification_feedback))])])]):_vm._e(),_vm._v(" "),(_vm.tokenRequested)?_c('div',{staticClass:"form-section"},[_c('div',{staticClass:"header__container header__container-verification"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.globalSettings.verification.header)}}),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative","text-align":"center"},domProps:{"innerHTML":_vm._s(_vm.globalSettings.verification.subheader)}})]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.globalSettings.verification.token_text)}}),_vm._v(" "),_c('div',{staticClass:"input_container"},[_vm._m(2,false,false),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.usertoken),expression:"usertoken"}],staticClass:"textfield",attrs:{"type":"text","placeholder":"Token"},domProps:{"value":(_vm.usertoken)},on:{"input":function($event){if($event.target.composing){ return; }_vm.usertoken=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"feedback"},[_vm._v(_vm._s(_vm.token_feedback))])])]):_vm._e()]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-interface"},[_c('div',{staticClass:"slider"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input_icon"},[_c('img',{attrs:{"src":"http://stereointellect.org/media/instances/32/envelop.svg","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input_icon"},[_c('img',{attrs:{"src":"http://stereointellect.org/media/instances/32/key.svg","alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b3zN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--introAbquiz",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"introAbquiz__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.header)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v(_vm._s(_vm.questionData.subheader))]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"question-header"},[_vm._v(_vm._s(_vm.questionData.questionheader))]),_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.questiontext)+"\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),(_vm.questionData != null)?_c('div',{staticClass:"centered"},[(_vm.roundData.questions.abtemplate == 'goatsheep')?_c('div',{staticClass:"card card-valueQuiz"},[_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"gW-btn-answer gW-answer-text",on:{"click":function () {_vm.onQuestionAnswer('1')}}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[0].visual}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[0].answer_text)}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"header"},[_vm._v("Antwoord A")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[0].answer_text)}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer-divider"}),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"gW-btn-answer gW-answer-text",on:{"click":function () {_vm.onQuestionAnswer('2')}}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[1].visual}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[1].answer_text)}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"header"},[_vm._v("Antwoord b")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[1].answer_text)}})])])])]),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"gW-btn-answer",on:{"click":function () {_vm.onQuestionAnswer('1')}}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[0].visual,"alt":""}})])]),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"gW-btn-answer",on:{"click":function () {_vm.onQuestionAnswer('2')}}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[1].visual,"alt":""}})])])]):_c('div',{staticClass:"card card-valueQuiz"},[_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"shadow-box",on:{"click":function () {_vm.onQuestionAnswer('1')}}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[0].visual,"alt":""}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[0].answer_text)}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"header"},[_vm._v("Antwoord A")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[0].answer_text)}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer-divider"}),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"shadow-box",on:{"click":function () {_vm.onQuestionAnswer('2')}}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[1].visual,"alt":""}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[1].answer_text)}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"header"},[_vm._v("Antwoord b")]),_vm._v(" "),_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[1].answer_text)}})])])])]),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"btn-answer",on:{"click":function () {_vm.onQuestionAnswer('1')}}},[_vm._v("\n\t\t\t\t\t\t\tA\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"btn-answer",on:{"click":function () {_vm.onQuestionAnswer('2')}}},[_vm._v("\n\t\t\t\t\t\t\tB\n\t\t\t\t\t\t")])])])]):_vm._e()])]),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"additionalHTML":_vm.additionalHTML,"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c52X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: ["percentage"],

    data: function data() {
        return {
            usedPercentage: 0
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.usedPercentage = 0;

        var p = this.percentage;
        setTimeout(function () {
            _this.usedPercentage = p;
        }, 200);
    },


    watch: {
        percentage: function percentage(val) {
            this.usedPercentage = val;
        }
    },

    computed: {
        style: function style() {
            var percentage = this.usedPercentage + "%";
            var offset = 100 - this.usedPercentage + "%";
            return { width: percentage };
        }
    },

    methods: {}
});

/***/ }),

/***/ "cTe4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Lottie_vue__ = __webpack_require__("uQpZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_4__Lottie_vue__["a" /* default */]
	},

	data: function data() {
		return {
			apiUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["c" /* api_url */],
			headerReady: true,
			visualReady: true,
			storyReady: true,
			opacity_style_base: 'opacity: 1',
			opacity: 0,
			opacity_style: 'opacity: 0',
			isShown: 'hide',
			audiopath: 'media/instance_2/Nordwin_transitor.mp3',
			name: 'introaudio',
			understood: 'no',
			is_animation: false,
			textAnimationParts: [],
			verifyEmail: 'Off',
			showVerifyEmail: false,
			tokenRequested: false,
			email: '',
			usertoken: '',
			hash: false,
			verification_feedback: '',
			token_feedback: ''
		};
	},
	beforeDestroy: function beforeDestroy() {
		__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].unloadAudio(this.name);
	},
	beforeMount: function beforeMount() {

		this.textAnimation();

		if (typeof this.globalSettings.verification.mode !== 'undefined') {
			this.verifyEmail = this.globalSettings.verification.mode;
			if (this.verifyEmail === 'On') {
				console.log('verification?');
				console.log(this.globalSettings.verification.mode);
				this.showVerifyEmail = true;
			}
		}
	},
	mounted: function mounted() {
		var _this = this;

		this.initAudio();

		var self = this;
		$('.slider').slider({
			slide: function slide(event, ui) {

				console.log(self.understood);
				if (self.understood == 'no') {
					self.understood = 'hide';
				}

				self.opacity = ui.value / 100;

				self.opacity_style = 'opacity: ' + self.opacity;
				self.opacity_style_base = 'opacity: ' + (1 - self.opacity);

				if (ui.value > 99) {
					console.log(ui.value);
					self.play();
					self.isShown = 'show';
					self.showNextButton();
				} else {
					self.isShown = 'hide';
				}
			}
		});

		this.showTransitorScore(false);

		if (this.lastStage) {

			console.log('last stage');

			if (this.verifyEmail === 'On' && this.emailVerificationCompleted !== true) {
				console.log('set verification action');
				this.setNextButtonAction(this.requestToken).then(function () {
					_this.showNextButton();
				});
			} else if (this.isAnimation) {

				this.setNextButtonAction(this.stopBlockTransition);
			} else {

				this.setNextButtonAction(this.stopBlockTransition).then(function () {
					_this.showNextButton();
				});
			}
		} else if (this.verifyEmail === 'On' && this.emailVerificationCompleted !== true) {
			console.log('set verification action');
			this.setNextButtonAction(this.requestToken).then(function () {
				_this.showNextButton();
			});
		} else {
			this.setNextButtonAction(this.toNextStage).then(function () {
				_this.showNextButton();
			});
		}
	},


	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["hideNextButton", "showNextButton", "setNextButtonAction", "toNextStage", "stopBlockTransition", "showTransitorScore", "loadAudio", "setEmailVerificationCompleted"]), {
		requestToken: function requestToken() {
			var _this2 = this;

			this.hideNextButton();

			var sendObj = {
				"instance_id": this.instanceId,
				"email": this.email
			};

			//console.log("sendObj");
			//console.log(sendObj);

			this.verification_feedback = '';

			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(this.apiUrl + 'api/v2/requesttoken', sendObj).then(function (response) {
				console.log(response.status);
				console.log(response.statusText);
				console.log(response.body);

				if (response.body.result === 'success') {

					_this2.tokenRequested = true;
					_this2.hash = response.body.hash;

					console.log(_this2.hash);

					setTimeout(function () {
						_this2.setNextButtonAction(_this2.verifyToken).then(function () {
							_this2.showNextButton();
						});
					}, 500);
				} else {

					//console.log('invalid email!');

					//globalSettings.verification.text
					_this2.verification_feedback = _this2.globalSettings.verification.forbidden_text;

					_this2.setNextButtonAction(_this2.requestToken).then(function () {
						_this2.showNextButton();
					});
				}
			}).catch(function (response) {
				//console.log("Error: ");
				//console.log(response);
			});
		},
		verifyToken: function verifyToken() {
			var _this3 = this;

			this.hideNextButton();

			var sendObj = {
				"instance_id": this.instanceId,
				"hash": this.hash,
				"user_token": this.usertoken
			};

			this.token_feedback = '';

			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.post(this.apiUrl + 'api/v2/checktoken', sendObj).then(function (response) {
				console.log(response.status);
				console.log(response.statusText);
				console.log(response.body);

				if (response.body.result === 'success') {

					_this3.verifyEmail = "Completed";
					_this3.showVerifyEmail = false;

					_this3.setEmailVerificationCompleted();

					setTimeout(function () {
						if (_this3.visualOverlayExists) {

							_this3.setNextButtonAction(_this3.stopBlockTransition);
						} else {

							_this3.setNextButtonAction(_this3.stopBlockTransition).then(function () {
								_this3.showNextButton();
							});
						}
					}, 500);
				} else {

					console.log('invalid token!');

					//invalid_text
					_this3.token_feedback = _this3.globalSettings.verification.invalid_text;

					_this3.setNextButtonAction(_this3.verifyToken).then(function () {
						_this3.showNextButton();
					});
				}
			}).catch(function (response) {
				//console.log("Error: ");
				//console.log(response);
			});
		},
		play: function play() {
			if (this.sound != null) {
				console.log('playaudio');
				this.sound.play();
			}
		},
		initAudio: function initAudio() {
			var _this4 = this;

			__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].loadAudio(this.name, this.baseUrl + this.audiopath, function () {
				_this4.sound = _this4.getAudio();
				//this.sound.play();
			}, function () {
				console.log("Failed to load audio: " + _this4.baseUrl + _this4.audiopath);
			});
		},
		playAudio: function playAudio() {
			return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].playAudio(this.name, { loop: this.loop == "true" });
		},
		getAudio: function getAudio() {
			return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].getAudio(this.name, { loop: this.loop == "false" });
		},
		textAnimation: function textAnimation() {

			if (this.stageData.header !== null) {

				var splitterPos = this.stageData.header.indexOf('[');

				if (splitterPos === false) {

					return false;
				}

				var part1 = this.stageData.header.slice(0, splitterPos - 1);

				var remainingString = this.stageData.header.slice(splitterPos + 1);
				var splitterPos2 = remainingString.indexOf(']');

				var part2 = remainingString.slice(0, splitterPos2);
				var part3 = remainingString.slice(splitterPos2 + 2);

				this.textAnimationParts = [part1, part2, part3];
				console.log(this.textAnimationParts);
			}
		}
	}),

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		baseUrl: function baseUrl() {
			return __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */];
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(["stageData", "lastStage", "blocks", "scores", 'currentBlock', "lastBlock", "globalSettings", "instanceId", "emailVerificationCompleted"]), {
		visualExists: function visualExists() {
			return this.stageData != null && this.stageData.visual != null;
		},
		visualIsJson: function visualIsJson() {
			if (this.stageData == null || this.stageData.visual == null) return false;
			var fileExtension = this.stageData.visual.substr(this.stageData.visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'json';
		},
		visualOverlayExists: function visualOverlayExists() {
			return this.stageData != null && this.stageData.visual_overlay != null;
		},
		isAnimation: function isAnimation() {

			return this.stageData.is_animation === 'Yes';
		},


		backgroundImage: function backgroundImage() {

			if (typeof this.stageData.background === 'undefined') {
				return 'none';
			}

			return 'url(' + this.baseUrl + this.stageData.background + ')';
		},

		verficiationBackgroundImage: function verficiationBackgroundImage() {

			if (typeof this.globalSettings.verification.background === 'undefined') {
				return 'none';
			}

			return 'url(' + this.baseUrl + this.globalSettings.verification.background + ')';
		}

	})
});

/***/ }),

/***/ "cuXJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Totem_vue__ = __webpack_require__("mq1x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0519d9ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Totem_vue__ = __webpack_require__("Yh8m");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Totem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0519d9ec_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Totem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d/BW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"world-quiz-feedback stage",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"world-quiz-feedback__background-overlay background-overlay"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.feedback.header)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.feedback.subheader)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text text-top",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.feedback.feedbacktext)+"\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"explanation mainTitle",staticStyle:{"position":"relative"}}),_vm._v(" "),_c('div',{staticClass:"panel",staticStyle:{"position":"relative"}},[_c('table',{staticClass:"inventory"},_vm._l((_vm.feedbackData.names),function(name,i){return _c('tr',[_c('td',{staticClass:"icon-cell"},[_c('div',{staticClass:"draggable-holder",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"draggable ui-draggable ui-draggable-handle",attrs:{"id":"Industrie"}},[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.items[i].visual}}),_vm._v(" "),_c('div',{staticClass:"feedback__icon__text"},[_vm._v(_vm._s(Math.round((_vm.feedbackData.correctScores[i]/_vm.feedbackData.totalScores)*100))+"%")])])])])]),_vm._v(" "),_c('td',{staticClass:"feedback__name"},[_c('b',[_vm._v(_vm._s(_vm.feedbackData.names[i].replace(/_/g," "))+" (Jij had "+_vm._s(Math.round((_vm.feedbackData.currentScores[i]/_vm.feedbackData.totalScores)*100))+"%)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.feedbackArray[i]))])])])}))]),_vm._v(" "),_c('div',{staticClass:"text text-bottom",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.questions.feedback[0].feedbacktext)+"\n\t\t\t")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eR96":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExplanationPopup_vue__ = __webpack_require__("Zp/M");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({

	props: [],

	components: {
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_5__ExplanationPopup_vue__["a" /* default */]
	},

	beforeMount: function beforeMount() {

		if (this.questionData.type == "Netherland") {
			this.positions.list = this.positions_nl.list;
		}

		if (this.questionData.type == "Haarlemmermeer") {
			this.positions.list = this.positions_Haarlemmermeer.list;
		}

		this.positions.list = this.positions.list.splice(0, this.question.total_items);
		this.maxItem = this.question.max_per_item;
		this.maxCount = this.question.total_items;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.itemArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var item = _step.value;


				var newName = item.name.replace(/ /g, "_");

				newName = newName.replace("/", "_");

				newName = newName.replace("_&_", "_");

				newName = newName.replace("<", "_");

				var showName = item.name == "Onbruikbare grond" ? "Onbruikbaar" : item.name;

				this.showNames.push(showName);
				this.names.push(newName);
				this.correctCount.push(item.amount);
				this.currentCount.push(0);
				this.visuals.push(item.visual);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator.return) {
					_iterator.return();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	},
	mounted: function mounted() {
		var component = this;

		$(".draggable").draggable({
			containment: '.main-frame',
			helper: 'clone',
			start: function start() {
				return component.startDragging();
			},
			stop: function stop(ev, ui) {
				return component.stopDragging(ev, ui);
			}
		});

		$(".visual-items").droppable({
			out: function out(ev, ui) {
				return component.moveOutDropZone(ev, ui);
			},
			over: function over(ev, ui) {
				return component.moveOverDropZone(ev, ui);
			},
			drop: function drop(ev, ui) {
				component.dropInDropZone(ev, ui, $(this));
			}

		});

		this.showTransitorScore(true);
	},
	data: function data() {
		return {
			mouseInDropZone: false,
			baseUrl: __WEBPACK_IMPORTED_MODULE_4__const_base__["a" /* url */],
			explanationPopupActive: false,
			draggedItems: 0,
			totalCount: '0%',
			showNames: [],
			names: [],
			correctCount: [],
			currentCount: [],
			transitorPoints: 0,
			maxItem: 0,
			maxCount: 0,
			visuals: [],
			positions: {
				list: [{ "left": 2, "top": 10, "r": 316 }, { "left": 30, "top": 65, "r": 0 }, { "left": 60, "top": 25, "r": 0 }, { "left": 86, "top": 38, "r": 0 }, { "left": 20, "top": 20, "r": 0 }, { "left": 25, "top": 40, "r": 0 }, { "left": 70, "top": 36, "r": 0 }, { "left": 42, "top": 54, "r": 0 }, { "left": 46, "top": 8, "r": 0 }, { "left": 5, "top": 46, "r": 0 }, { "left": 82, "top": 75, "r": 0 }, { "left": 28, "top": 57, "r": 0 }, { "left": 26, "top": 0, "r": 0 }, { "left": 82, "top": 57, "r": 0 }, { "left": 22, "top": 16, "r": -43 }, { "left": 69, "top": 5, "r": 0 }, { "left": 52, "top": 27, "r": 0 }, { "left": 33, "top": 38, "r": 0 }, { "left": 78, "top": 20, "r": 0 }, { "left": 80, "top": 50, "r": 0 }],
				used: []
			},
			positions_nl: {
				list: [{ "left": 58, "top": 7, "r": 0 }, { "left": 30, "top": 60, "r": 0 }, { "left": 60, "top": 25, "r": 0 }, { "left": 52, "top": 38, "r": 0 }, { "left": 30, "top": 20, "r": 0 }, { "left": 25, "top": 40, "r": 0 }, { "left": 70, "top": 36, "r": 0 }, { "left": 42, "top": 54, "r": 0 }, { "left": 74, "top": 9, "r": 0 }, { "left": 60, "top": 80, "r": 0 }, { "left": 82, "top": 75, "r": 0 }, { "left": 28, "top": 57, "r": 0 }, { "left": 26, "top": 0, "r": 0 }, { "left": 82, "top": 57, "r": 0 }, { "left": 22, "top": 16, "r": 0 }, { "left": 69, "top": 5, "r": 0 }, { "left": 52, "top": 27, "r": 0 }, { "left": 33, "top": 38, "r": 0 }, { "left": 78, "top": 20, "r": 0 }, { "left": 80, "top": 50, "r": 0 }],
				used: []
			},
			positions_Haarlemmermeer: {
				list: [{ "left": 65, "top": 7, "r": 0 }, { "left": 23, "top": 76, "r": 0 }, { "left": 60, "top": 25, "r": 0 }, { "left": 43, "top": 30, "r": 0 }, { "left": 65, "top": 60, "r": 0 }, { "left": 25, "top": 40, "r": 0 }, { "left": 70, "top": 36, "r": 0 }, { "left": 42, "top": 54, "r": 0 }, { "left": 12, "top": 63, "r": 0 }, { "left": 46, "top": 1, "r": 0 }, { "left": 82, "top": 75, "r": 0 }, { "left": 28, "top": 57, "r": 0 }, { "left": 26, "top": 0, "r": 0 }, { "left": 82, "top": 57, "r": 0 }, { "left": 22, "top": 16, "r": 0 }, { "left": 69, "top": 5, "r": 0 }, { "left": 52, "top": 27, "r": 0 }, { "left": 33, "top": 38, "r": 0 }, { "left": 78, "top": 20, "r": 0 }, { "left": 80, "top": 50, "r": 0 }],
				used: []
			},
			markerPlaced: false,
			inRedZone: false

		};
	},


	/*
 POSITIONS EARTH
 	positions:{
 			list:[
 				{"left":2, "top":10, "r":316},
 				{"left":30, "top":65, "r":0},
 				{"left":60, "top":25, "r":0},
 				{"left":86, "top":38, "r":0},
 				{"left":20, "top":20, "r":0},
 				{"left":25, "top":40, "r":0},
 				{"left":70, "top":36, "r":0},
 				{"left":42, "top":54, "r":0},
 				{"left":84, "top":9, "r":0},
 				{"left":5, "top":30, "r":0},
 				{"left": 82, "top": 75, "r": 0},
 				{"left": 28, "top": 57, "r": 0},
 				{"left": 26, "top": 0, "r": 0},
 				{"left": 82, "top": 57, "r": 0},
 				{"left": 22, "top": 16, "r": -43},
 				{"left": 69, "top": 5, "r": 0},
 				{"left": 52, "top": 27, "r": 0},
 				{"left": 33, "top": 38, "r": 0},
 				{"left": 78, "top": 20, "r": 0},
 				{"left": 80, "top": 50, "r": 0}
 			],
 			used:[]
 		},
 */

	watch: {

		currentCount: {
			handler: function handler(arr) {
				var _this = this;

				var items = 0;
				for (var i = 0; i < arr.length; i++) {
					items += arr[i];
					if (arr[i] == this.maxItem) {
						$("#" + this.names[i]).addClass("disabled");
					} else {
						$("#" + this.names[i]).removeClass("disabled");
					}
				}

				console.log('check:');
				console.log(items);
				console.log(this.maxCount);

				this.totalCount = items * this.maxCount + "%";

				if (items == this.maxCount) {
					var score = 0;
					for (var _i = 0; _i < arr.length; _i++) {
						if (this.currentCount[_i] == +this.correctCount[_i]) {
							score += 100 / this.correctCount.length;
							this.transitorPoints += 100 / this.correctCount.length;
						} else {
							var diff = this.currentCount[_i] - this.correctCount[_i];
							if (diff < 0) {
								diff = diff * -1;
							}

							// score += ( 100 - (diff*10))/this.correctCount.length;
							// this.transitorPoints += ( 100 - (diff*10))/this.correctCount.length;

							score += 25 - diff * 10;
							this.transitorPoints += 25 - diff * 10;
						}
						$("#" + this.names[_i]).addClass("disabled");
					}

					//do this at feedback screen
					// this.increaseTransitorScore(parseInt(this.roundData.questions.transitor_multiplier*(this.transitorPoints/10)));

					console.log('score');
					console.log(score);

					this.setRoundScore(score).then(function () {
						_this.setNextButtonAction(_this.finishWorldRound).then(function () {
							_this.setFeedbackData({
								correctScores: _this.correctCount,
								currentScores: _this.currentCount,
								names: _this.names,
								totalScores: _this.maxCount,
								transitors: parseInt(_this.roundData.questions.transitor_multiplier * (_this.transitorPoints / 10))
							}).then(function () {
								_this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": true });
							});
						});
					});
				} else {
					this.hideNextButton();
				}
			},
			deep: false
		}
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(['currentBlock', 'currentStage', 'currentRound', 'roundScore', 'questionData', "roundData", 'stageData']), {
		question: function question() {
			return this.questionData;
		},
		itemArray: function itemArray() {
			return this.question.items;
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}

	}),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["showNextButton", "hideNextButton", "setRoundScore", "logAnswers", "completeRound", "setNextButtonAction", "setFeedbackData", "increaseTransitorScore", "showTransitorScore"]), {
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},
		finishWorldRound: function finishWorldRound() {
			var _this2 = this;

			this.logAnswers(this.currentCount).then(function () {
				_this2.completeRound();
			});
		},
		moveOutDropZone: function moveOutDropZone(ev, ui) {
			this.mouseInDropZone = false;
			var component = this;
			ui.helper.off('mouseup').on('mouseup', function () {
				var name = $(this).attr('data-type');
				var nameIndex = component.names.indexOf(name);
				if (nameIndex >= 0) {
					__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(component.currentCount, nameIndex, component.currentCount[nameIndex] - 1);
				}
				var arr = component.positions.used;
				var index = component.positions.used.indexOf(+$(this).attr('count'));
				component.positions.used.splice(index, 1);
				$(this).remove();
			});
		},
		moveOverDropZone: function moveOverDropZone(ev, ui) {
			this.mouseInDropZone = true;
			ui.helper.off('mouseup').on('mouseup', null);
		},
		dropInDropZone: function dropInDropZone(ev, ui, jqueryContainer) {
			if (ev.target.id == "valid_dropzone") {
				var classes = $(ui.draggable).attr("class");
				//If item was already dragged. do not create a copy
				if (classes.includes("item-dragged")) return;
				var element = $(ui.draggable).clone();
				var name = "clonediv" + this.draggedItems;
				element.attr("id", name);
				element.addClass('item-dragged');
				jqueryContainer.append(element);
			}
		},
		startDragging: function startDragging() {
			this.mouseInDropZone = false;
			this.draggedItems++;
		},

		stopDragging: function stopDragging(ev, ui) {
			var screenWidth = $('.main-frame').width();
			var scale = screenWidth / 460;
			var holder = $('.visual-holder');
			//If our drop position is on our container.
			if (this.mouseInDropZone) {
				var objName = "#clonediv" + this.draggedItems;
				if ($(objName)) {
					$(objName).attr('data-type', ev.target.id);
					this.dropTarget(objName, this[ev.target.id], scale);
					var index = this.names.indexOf(ev.target.id);
					if (index >= 0) {
						__WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].set(this.currentCount, index, this.currentCount[index] + 1);
					}
				}
			}
		},
		dropTarget: function dropTarget(objName, obj, scale) {
			//Find the right index number by searching the used array.
			var count = 0;
			if (this.positions.used.length > 0) {
				for (var i = 0; i < this.maxCount; i++) {
					if (this.positions.used.includes(i)) continue;
					count = i;
					this.positions.used.push(i);
					break;
				}
			} else {
				this.positions.used.push(0);
			}
			$(objName).attr('count', count);

			//we need the factor of the actual image vs the div, so no matter how the image is displayed, the position always matches

			var factor = $('#visual-img').width() / $('#valid_dropzone').width();
			var offset = (100 - factor * 100) / 2;

			// console.log(this.positions.list[count].left);
			// console.log(factor);
			// console.log(offset);

			$(objName).css({
				width: 60 * scale + "px",
				height: 70 * scale + "px",
				"left": this.positions.list[count].left * factor + offset + "%",
				"top": this.positions.list[count].top + "%",
				"transform": "rotate(" + this.positions.list[count].r + "deg)"
			});

			var component = this;

			$(objName).draggable({
				containment: '.main-frame',
				revert: function revert(ev, ui) {
					var index = component.positions.used.indexOf(+$(this).attr('count'));
					index = component.positions.used[index];
					var draggable = $(this).data('uiDraggable');
					if (draggable != null) {
						$(this).data("uiDraggable").originalPosition = {
							left: component.positions.list[index].left + "%",
							top: component.positions.list[index].top + "%"
						};
					}
					return true;
				}
			});
		}
	})
});

/***/ }),

/***/ "eU6F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bodymovin__ = __webpack_require__("Iwrh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bodymovin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bodymovin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Lottie_vue__ = __webpack_require__("uQpZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	props: [],

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_4__Lottie_vue__["a" /* default */]
	},

	created: function created() {},
	mounted: function mounted() {

		console.log(this.transitorSoundFX);
	},
	data: function data() {
		return {
			id: 'animcontainer',
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */]
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["loadAnimation", "loadAudio"])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["transitorScore", "transitorShown", "transitorAnim", "transitorSound"]), {
		transitorAnimation: function transitorAnimation() {

			console.log(this.transitorAnim);

			if (this.transitorAnim) {
				return this.transitorAnim;
			} else {
				return 'media/rws_circulair/transitors/RWS_transitor_middel.json';
			}
		},
		transitorSoundFX: function transitorSoundFX() {

			console.log(this.transitorSound);

			if (this.transitorSound) {
				return this.transitorSound;
			} else {
				return 'media/instance_2/Nordwin_transitor.mp3';
			}
		}
	}),
	watch: {
		transitorScore: function transitorScore() {
			this.$refs.animation.play();
		}
	}

});

/***/ }),

/***/ "f0Ze":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Feedback_vue__ = __webpack_require__("TBnO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExplanationPopup_vue__ = __webpack_require__("Zp/M");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








//import * as mapData from './Utrecht_plattegrond.svg';


/* harmony default export */ __webpack_exports__["a"] = ({

	props: [],

	components: {
		Feedback: __WEBPACK_IMPORTED_MODULE_3__Feedback_vue__["a" /* default */]
	},

	beforeMount: function beforeMount() {},
	mounted: function mounted() {

		var component = this;

		//this.startUtrechtScene();

		$("#svgObject")[0].addEventListener('load', function () {
			component.startUtrechtScene();
		});
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_4__const_base__["a" /* url */],
			devEnv: __WEBPACK_IMPORTED_MODULE_4__const_base__["d" /* dev_env */],
			partOne: true,
			partOneState: 0,
			partTwoState: 0,
			draggedItems: 0,
			showNames: [],
			names: [],
			correctCount: [],
			currentCount: [],
			maxItem: 0,
			maxCount: 0,
			visuals: [],
			markerPlaced: false,
			inRedZone: false,
			explanationPopupActive: false
		};
	},


	watch: {

		markerPlaced: function markerPlaced(val) {
			var _this = this;

			if (val) {
				this.setNextButtonAction(this.nextPartForPartTwo).then(function () {
					_this.showNextButton();
				});
			} else {
				this.hideNextButton();
				this.partTwoState = 0;
			}
		},

		partOneState: function partOneState(val) {
			var _this2 = this;

			if (val == 0) {
				this.hideNextButton();
			}
			if (val == 1) {
				setTimeout(function () {
					_this2.setNextButtonAction(_this2.partOneFinal).then(function () {
						_this2.showNextButton();
					});
				}, 0);
			}
			if (val == 2) {
				setTimeout(function () {
					_this2.setNextButtonAction(_this2.toNextPart).then(function () {
						_this2.showNextButton();
					});
				}, 500);
			}
		},

		partTwoState: function partTwoState(val) {
			var _this3 = this;

			if (val <= 1) {
				var svgObject = document.querySelector("#svgObject").contentDocument;
				var root = svgObject.getElementsByClassName("cls-1")[0];
				root.style.opacity = val * .5;
				this.setNextButtonAction(this.nextPartForPartTwo).then(function () {
					_this3.showNextButton();
				});
			}
		},

		partOne: function partOne(val) {
			var component = this;
			if (val == false) {
				setTimeout(function () {
					$("#svgObject")[0].addEventListener('load', function () {
						//component.startUtrechtScene();
					});
				}, 1);
			}
		}

	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		utrecht: function utrecht() {
			return __webpack_require__("Ke9v");
		},
		utrechtSvg: function utrechtSvg() {
			return svgData;
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])(['currentBlock', 'currentStage', 'currentRound', 'roundScore', 'questionData', "roundData", 'stageData']), {
		question: function question() {
			return this.questionData;
		}
	}),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
		},
		partOneFinal: function partOneFinal() {
			this.partOneState = 2;
		},
		toNextPart: function toNextPart() {
			this.partOne = false;
		},
		nextPartForPartTwo: function nextPartForPartTwo() {
			if (this.partTwoState == 1) {
				this.completeRound();
			} else {
				this.partTwoState = 1;
			}
		},
		startUtrechtScene: function startUtrechtScene() {
			var _this4 = this;

			var component = this;

			console.log('start');

			// $('#svgObject').click(function(e){

			// 	console.log('click');

			// 	var pos = $(this).position();


			//        let cPosX = $('.inner').offset().left;
			// 	let cPosY = $('#svgObject').offset().top;
			// 	let posX = (pos.left-cPosX)+($('.crosshair').width()/2);
			// 	let posY = (pos.top-cPosY)+($('.crosshair').height()/2);
			// 	let es = svgObject.elementFromPoint(posX, posY);
			// 	if(es != null){
			// 		//root.style.opacity = .5;
			// 		component.markerPlaced = true;
			// 		if(es.id == ""){
			// 			component.inRedZone = true;
			// 			component.setUnderWater(true);
			// 		}else{
			// 			component.inRedZone = false;
			// 			component.setUnderWater(false);
			// 		}
			// 	}else{
			// 		component.markerPlaced = false;
			// 	}

			//        console.log((e.pageX - posX) + ' , ' + (e.pageY - posY));
			// });


			if (this.devEnv === 'local') {
				this.setNextButtonAction(this.completeRound).then(function () {
					_this4.showNextButton();
				});

				return false;
			}

			if (document.querySelector("#svgObject").contentDocument == null) {

				this.setNextButtonAction(this.completeRound).then(function () {
					_this4.showNextButton();
				});

				return false;
			}

			var svgObject = document.querySelector("#svgObject").contentDocument;

			console.log(svgObject);

			var root = svgObject.getElementsByClassName("cls-1")[0];
			console.log(root);

			root.style.opacity = 0;

			$(".crosshair").draggable({ containment: ".main-frame",
				start: function start() {},
				stop: function stop(ev, ui) {

					var pos = $(ui.helper).offset();
					var cPosX = $('.inner').offset().left;
					var cPosY = $('#svgObject').offset().top;
					var posX = pos.left - cPosX + $('.crosshair').width() / 2;
					var posY = pos.top - cPosY + $('.crosshair').height() / 2;
					var es = svgObject.elementFromPoint(posX, posY);
					if (es != null) {
						//root.style.opacity = .5;
						component.markerPlaced = true;
						if (es.id == "") {
							component.inRedZone = true;
							component.setUnderWater(true);
						} else {
							component.inRedZone = false;
							component.setUnderWater(false);
						}
					} else {
						component.markerPlaced = false;
					}
				}
			});
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["showNextButton", "hideNextButton", "setRoundScore", "completeRound", "setNextButtonAction", "setUnderWater"]))
});

/***/ }),

/***/ "g2PX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minigame"},[(_vm.stageType == 'Intro')?_c('Intro'):(_vm.stageType == 'Rounds')?_c('div',{staticClass:"minigame-content"},[(_vm.roundState == 'intro')?_c('RoundIntro'):(_vm.roundState == 'explanation')?_c('Explanation',{attrs:{"id":"questions"}}):(_vm.roundState == 'feedback')?_c('Feedback'):(_vm.roundType == 'simonsays')?_c('SimonSays'):(_vm.roundType == 'systeemdenken')?_c('SysteemDenken'):(_vm.roundType == 'systeemdenken_controlevragen')?_c('SysteemDenkenControleVragen'):(_vm.roundType == 'swipequiz')?_c('SwipeQuiz'):(_vm.roundType == 'abquiz')?_c('ABQuiz'):(_vm.roundType == 'multiquiz')?_c('MultiQuiz'):(_vm.roundType == 'matchingquiz')?_c('MatchingQuiz'):(_vm.roundType == 'worldquiz')?_c('World'):(_vm.roundType == 'landmark')?_c('LandMark'):(_vm.roundType == 'impactcalculator')?_c('ImpactCalculator'):(_vm.roundType == 'teamrole')?_c('TeamRole'):(_vm.roundType == 'mbtiprofile')?_c('MbtiProfile'):_vm._e()],1):(_vm.stageType == 'Score')?_c('Totem'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iGyP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"explanation mainTitle",staticStyle:{"position":"relative"}}),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('table',_vm._l((_vm.names),function(name,i){return _c('tr',[_c('td',[_c('div',{staticClass:"feedback__icon"},[_c('div',{staticClass:"feedback__icon__text"},[_vm._v(_vm._s(Math.round((_vm.correctScores[i]/_vm.totalScores)*100))+"%")]),_vm._v(" "),_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.items[i].visual}})])]),_vm._v(" "),_c('td',[_c('p',{staticStyle:{"padding":"2px"}},[_c('b',[_vm._v(_vm._s(_vm.names[i].replace(/_/g," ")))]),_vm._v(" (Jij had "+_vm._s(Math.round((_vm.currentScores[i]/_vm.totalScores)*100))+"%)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.feedbackArray[i]))])])])}))])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\tVerhoudingen\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\tDe juiste aarde\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\tGek om zo naar de wereld te kijken, he? Hieronder zie je de situatie in 2017.\n\t\t")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jBqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--landmark"},[_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('div',{staticClass:"utrecht"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.visual}}),_vm._v(" "),_c('object',{staticStyle:{"width":"100%","height":"auto"},attrs:{"id":"svgObject","data":_vm.baseUrl + _vm.questionData.hit_test_svg,"type":"image/svg+xml","width":"460","height":"460"}},[_vm._v("No SVG support")])])]),_vm._v(" "),_c('div',{staticClass:"crosshair",staticStyle:{"top":"calc(100% - 120px)","left":"50%"}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.croshair_visual}})]),_vm._v(" "),_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.question.header)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.question.subheader)+"\n\t\t")]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.question.questiontext)+"\n\t\t")])]),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jKnO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--simonsays",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.header)+"\n\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('div',{staticClass:"card card-simonsays"},[_c('div',{staticClass:"timer"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"timer__time"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.displayTime)+"\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.questionData.questiontext)}}),_vm._v(" "),_c('div',{staticClass:"simonsays__answer__holder"},[(_vm.questionData != null)?_c('div',{staticClass:"simonsays__answer__container"},_vm._l((_vm.questionData.answers),function(answer,index){return _c('div',{staticClass:"simonsays__answer",class:{'selected' : _vm.answers.includes(index)},on:{"click":function (){_vm.onAnswer(index)}}},[_c('img',{attrs:{"src":_vm.baseUrl + answer.visual}})])})):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"simonsays__info",on:{"click":_vm.showOverlay}},[_c('i',{staticClass:"fa fa-play"})]),_vm._v(" "),_c('div',{staticClass:"simonsays__legenda"},_vm._l((_vm.questionData.answers),function(answer,index){return _c('div',{staticClass:"simonsays__legenda__item"},[_vm._v("\n\t\t\t\t\t"+_vm._s(answer.label)+"\n\t\t\t\t")])}))]),_vm._v(" "),(_vm.question == true)?_c('Overlay',{attrs:{"header":_vm.questionData.header,"text":_vm.questionData.questiontext,"visual":_vm.baseUrl + _vm.questionData.visual,"on-click":_vm.hideOverlay}}):_vm._e(),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"additionalHTML":_vm.additionalHTML,"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer__icon"},[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "juKD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__ = __webpack_require__("01iT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b22f38b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__ = __webpack_require__("zRPJ");
function injectStyle (ssrContext) {
  __webpack_require__("rNp5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b22f38b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Preloader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b22f38b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preloader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kUzV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Minigame_vue__ = __webpack_require__("zoWV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a5065e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Minigame_vue__ = __webpack_require__("g2PX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Minigame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18a5065e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Minigame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kzJK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__ = __webpack_require__("3pys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98c0a072_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__ = __webpack_require__("RkXe");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98c0a072_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l3el":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("2nQx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02dd25ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("B6uW");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02dd25ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "leLd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('div',{staticClass:"timer"},[_vm._m(0,false,false),_vm._v(" "),_c('div',{staticClass:"timer__bar"},[_c('div',{staticClass:"timer__bar__filler",style:(_vm.style)})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer__iconHolder"},[_c('i',{staticClass:"fa fa-clock-o",attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lerZ":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMzMuNjMgMTMzLjYzIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwZDdmZjt9LmNscy0ye2ZpbGw6IzA3YmJmZDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlV0cmVjaHRfc3lzdGVlbWRlbmtlbi1vdXRwdXQ8L3RpdGxlPjxwb2x5bGluZSBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNjcuMTYgMjcuODYgMjguMjkgNjkuNzEgMjguMjkgMTI1LjA2IDEwNi4wNCAxMjUuMDYgMTA2LjA0IDY4LjY2IDY3LjE2IDI3Ljg2Ii8+PHBvbHlsaW5lIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSI2Ny4xNiAxOC43MyAyOC4yOSA2MC4xNSAyOC4yOSA2OS43MSA2Ny4xNiAyNy44NiAxMDYuMDQgNjguNjYgMTA2LjA0IDYwLjE1IDY3LjE2IDE4LjczIi8+PHBvbHlnb24gY2xhc3M9ImNscy0xIiBwb2ludHM9IjY3LjE2IDguMDkgNDMuMzUgMzEuMDggNDMuMzUgMTAuODkgMjguMjkgMTAuODkgMjguMjkgNDUuNjMgMTEuNzkgNjEuNTYgMjQgNzQuMzMgMjguMjkgNjkuNzEgMjguMjkgNjAuMTUgNjcuMTYgMTguNzMgMTA2LjA0IDYwLjE1IDEwNi4wNCA2OC42NiAxMTAuMzggNzMuMjIgMTIxLjg0IDYxLjc2IDY3LjE2IDguMDkiLz48L3N2Zz4="

/***/ }),

/***/ "mFD/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("y3B7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc783b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Ko49");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2bc783b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mcUU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__ = __webpack_require__("uQpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__["a" /* default */]
	},

	beforeMount: function beforeMount() {},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(_this.lastRound ? _this.toNextStage : _this.toNextRound).then(function () {
				_this.showNextButton();
			});
		}, 500);
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */],
			feedbackArray: []
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["setNextButtonAction", "showNextButton", "toNextStage", "toNextRound"])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["questionData", "feedbackData", "lastRound", 'roundData']), {

		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}
	})

});

/***/ }),

/***/ "mq1x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderBlock_vue__ = __webpack_require__("qmlP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		HeaderBlock: __WEBPACK_IMPORTED_MODULE_1__HeaderBlock_vue__["a" /* default */]
	},

	props: ['text', 'visual'],

	beforeMount: function beforeMount() {
		this.setTotem();
	},
	mounted: function mounted() {
		var _this = this;

		console.log('userImpact: ' + this.userImpact);

		if (this.lastBlock) {
			//console.log('last block!!!');
		} else {
			setTimeout(function () {
				_this.setNextButtonAction(_this.stopBlockTransition).then(function () {
					_this.showNextButton();
				});
			}, 500);
		}
		if (this.userImpact) {
			var wholeEarths = Math.floor(this.userImpact);
			var partlyEarth = this.userImpact - wholeEarths;

			for (var i = 0; i < wholeEarths; i++) {
				$('.earths_visual').append('<img class="whole-earth" src="' + this.baseUrl + 'media/rws_impact/earth_red.svg">');
			};

			if (partlyEarth > 0.4) {
				$('.earths_visual').append('<img class="half-earth" src="' + this.baseUrl + 'media/rws_impact/half_earth_red.svg">');
			}
		}
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */],
			totem: {},
			sdgClusters: { economy: [8, 9, 10, 12], society: [1, 2, 3, 4, 5, 7, 11, 16], biosphere: [6, 13, 14, 15] },
			typeLabels: { economy: 'Economie', society: 'Mens', biosphere: 'Milieu' }
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
		getScoreFromBlockIndex: function getScoreFromBlockIndex(index) {

			var score = 0;
			var rounds = 0;
			var block = this.blocks[index];

			for (var i = 0; i < block.data_structure.length; i++) {
				var stage = block.data_structure[i];

				if (stage.type != "Rounds") continue;

				for (var j = 0; j < stage.data.rounds.length; j++) {

					var round = stage.data.rounds[j];

					// console.log(round);

					if (round.score !== undefined && round.questions.usescore === "Yes") {
						rounds++;
						score += round.score;
					}
				}
			}

			// console.log('getScoreFromBlockIndex');
			// console.log(score);
			// console.log(rounds);

			return Math.round(score / rounds);
		},
		getSdgCountFromBlockIndex: function getSdgCountFromBlockIndex(index) {

			var rounds = 0;
			var block = this.blocks[index];

			var sdgObject = {};

			sdgObject.sdgCount = [];

			for (var i = 0; i < block.data_structure.length; i++) {
				var stage = block.data_structure[i];

				if (stage.type != "Rounds") continue;

				for (var j = 0; j < stage.data.rounds.length; j++) {

					var round = stage.data.rounds[j];

					console.log('round: ');
					console.log(round);

					if (typeof round.sdgs !== 'undefined' && round.questions.usescore === "Yes") {

						for (var l = 0; l < round.sdgs.length; l++) {

							var sdgIndex = round.sdgs[l];

							console.log('sdgIndex: ' + sdgIndex);

							if (typeof sdgObject.sdgCount[sdgIndex] === 'undefined') {

								sdgObject.sdgCount[sdgIndex] = 1;
							} else {
								sdgObject.sdgCount[sdgIndex] += 1;
							}
						}
					}
				}
			}

			//sdgClusters
			sdgObject.clusters = {};
			for (var property in this.sdgClusters) {
				if (this.sdgClusters.hasOwnProperty(property)) {

					var _cluster = this.sdgClusters[property];
					var clusterCount = 0;

					for (var _j = 0; _j < _cluster.length; _j++) {
						if (sdgObject.sdgCount[_cluster[_j]] > 0) {
							clusterCount += sdgObject.sdgCount[_cluster[_j]];
						}
					}

					sdgObject.clusters[property] = clusterCount;
				}
			};

			var bestScoredCluster = 0;
			var cluster = '';
			for (var _property in sdgObject.clusters) {
				if (sdgObject.clusters.hasOwnProperty(_property)) {

					if (sdgObject.clusters[_property] > bestScoredCluster) {
						bestScoredCluster = sdgObject.clusters[_property];

						cluster = _property;
					}
				}
			}

			sdgObject.bestCluster = cluster;

			console.log('getSdgCountFromBlockIndex');
			console.log(sdgObject.sdgCount);
			console.log(sdgObject.clusters);
			console.log(sdgObject.bestCluster);

			return sdgObject;
		},
		setTotem: function setTotem() {

			var visuals = [];
			var scores = [];
			var labels = [];
			var types = [];
			var sdgs = [];

			// for(let i = 0 ; i <this.blocks.length  ; i++){

			for (var i = this.blocks.length - 1; i >= 0; i--) {

				var block = this.blocks[i];

				var settings = block.settings;
				if (settings == null || settings.score == null || settings.score.use == null || settings.score.use != "Yes") continue;

				types.push(settings.score.label);

				sdgs.push(this.getSdgCountFromBlockIndex(i));

				//console.log(block.type);

				if (typeof settings.score.displaylabel !== 'undefined') {
					labels.push(settings.score.displaylabel == null ? "Not defined" : settings.score.displaylabel);
				} else {
					labels.push(settings.score.label == null ? "Not defined" : settings.score.label);
				}

				if (this.currentBlock < i) {

					visuals.push(settings.score.visual_off_state);
					scores.push(-1);
				} else {

					if (this.blocks[this.currentBlock].settings.score.template == 'Ladder') {

						if (this.currentBlock == i) {

							visuals.push(settings.score.visual_on_state);
						} else {

							visuals.push(settings.score.visual_off_state);
						}
					} else {

						visuals.push(settings.score.visual_on_state);
					}

					scores.push(this.getScoreFromBlockIndex(i));
				}
			}

			if (this.blocks[this.currentBlock].settings.score.template == 'Ladder' || this.blocks[this.currentBlock].settings.score.template == 'Totem') {
				// || 
				visuals.reverse();
				scores.reverse();
				labels.reverse();
				types.reverse();
				sdgs.reverse();
			}

			this.totem = {
				visuals: visuals,
				scores: scores,
				labels: labels,
				types: types,
				sdgs: sdgs
			};
		}
	}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setNextButtonAction', 'showNextButton', 'stopBlockTransition'])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["roundData", "stageData", 'currentBlock', 'lastBlock', 'blocks', 'userImpact']), {
		visualExists: function visualExists() {
			return this.stageData != null && this.stageData.visual != null;
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.stageData.background + ')';
		}
	})

});

/***/ }),

/***/ "mwU7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['header', 'visual', 'text'],
	mounted: function mounted() {},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_1__const_base__["a" /* url */]
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])([])),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapGetters */])([]))

});

/***/ }),

/***/ "nU93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("O2i0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fef6479_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("z7Oh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fef6479_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "npeb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("HGTs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2451290_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("jKnO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2451290_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ntFc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swipe-container",attrs:{"cardbg":_vm.cardbg}},[_c('v-touch',{staticClass:"swipe-container__touch",class:_vm.addedClass,on:{"panstart":function($event){},"panmove":_vm.onPan,"panend":_vm.onPanEnd}},[_c('div',{staticClass:"question"},[_c('div',{staticClass:"question__header"},[_c('p',[_vm._v(_vm._s(_vm.header))])]),_vm._v(" "),_c('img',{staticClass:"swipe-container__image",attrs:{"draggable":"false","src":_vm.image}}),_vm._v(" "),_c('div',{staticClass:"question__text"},[_c('p',[_vm._v(_vm._s(_vm.questiontext))])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qmlP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBlock_vue__ = __webpack_require__("DEP7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1804b9fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBlock_vue__ = __webpack_require__("rzn4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1804b9fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rNp5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rnhp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--matchingquiz",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"matchingquiz__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.questionData.header)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader"},[_vm._v("\n\t                    "+_vm._s(_vm.roundData.questions.subheader)+"\n\t                ")]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v(_vm._s(_vm.questionData.questiontext))])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),_c('div',{staticClass:"buttonQuizContent"},[_c('div',{staticClass:"image-box"},[(_vm.questionData != null)?_c('div',{staticClass:"shadow-box",staticStyle:{"touch-action":"none","user-select":"none","-webkit-user-drag":"none","-webkit-tap-highlight-color":"rgba(0, 0, 0, 0)"}},[_c('div',{staticClass:"image-box-table"},[_c('div',{staticClass:"base centered"},[_c('img',{staticStyle:{"pointer-events":"none"},attrs:{"src":_vm.baseUrl + _vm.questionData.visual}}),_vm._v(" "),_c('v-touch',{staticClass:"shadow-box",on:{"panstart":_vm.onPanStart,"panmove":_vm.onPan,"panend":_vm.onPanEnd}},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"nav nav__prev"},[_c('span',{staticClass:"nav_button",class:{'disabled':_vm.currentQuestion==0},on:{"click":_vm.previous}},[_c('i',{staticClass:"fa fa-angle-left fa-2x"})])]),_vm._v(" "),_c('div',{staticClass:"nav nav__next"},[_c('span',{staticClass:"nav_button",class:{'disabled':_vm.lastQuestion},on:{"click":_vm.next}},[_c('i',{staticClass:"fa fa-angle-right fa-2x"})])])])])],1)])]):_vm._e()])])]),_vm._v(" "),(_vm.questionData != null)?_c('div',{staticClass:"button-conainer"},_vm._l((_vm.questionData.answers),function(answer,index){return _c('AnswerButton',{key:index,attrs:{"question":_vm.currentQuestion,"index":index,"answer":_vm.answers[index],"text":answer.answer_text,"on-click":function () {_vm.onQuestionAnswer(index)}}})})):_vm._e()])]),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"additionalHTML":_vm.additionalHTML,"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rzn4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.header)}}),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.subHeader)}}),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.bodytext)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sHyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['onClick', 'text'],

	data: function data() {
		return {};
	},
	mounted: function mounted() {},


	watch: {},

	computed: {},

	methods: {}

});

/***/ }),

/***/ "tBSM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Root_vue__ = __webpack_require__("Ryrf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1488c5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Root_vue__ = __webpack_require__("w890");
function injectStyle (ssrContext) {
  __webpack_require__("K/2v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Root_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1488c5e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Root_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tCaD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__("9qgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['cardbg', 'image', 'onanswer', 'deadZone', 'questiontext', 'header'],

	mounted: function mounted() {
		$('.swipe-container').css('background-image', 'url("' + this.cardbg + '")');
		$('.swipe-container__image').on('dragstart', function (e) {
			e.preventDefault();
		});
	},
	data: function data() {
		return {
			addedClass: ""
		};
	},

	methods: {
		onPan: function onPan(e) {

			var el = this.$el.querySelector('.swipe-container__touch');
			var img = this.$el.querySelector('.swipe-container__image');

			var vertical = e.deltaY;
			var horizontal = e.deltaX;
			if (vertical > 0) vertical = 0;

			if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
				el.style.transform = "translate(" + horizontal + "px,0px)";
			} else {
				el.style.transform = "translate(0px," + vertical + "px)";
			}

			if (Math.abs(e.deltaX) < this.deadZone && Math.abs(e.deltaY) < this.deadZone) {
				el.className = 'swipe-container__touch';
				//el.style.border = "2px solid #fff";
				return;
			}

			if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
				if (e.deltaX > 0) {
					el.className = 'swipe-container__touch swiperight';
					//el.style.border = "5px solid #95d934";
				} else if (e.deltaX < 0) {
					el.className = 'swipe-container__touch swipeleft';
					//el.style.border = "5px solid #cc0000";
				}
			} else {
				el.className = 'swipe-container__touch swipeup';
				//el.style.border = "5px solid #ff9900";
			}
		},
		onPanEnd: function onPanEnd(e) {
			var _this = this;

			var el = this.$el.querySelector('.swipe-container__touch');
			var img = this.$el.querySelector('.swipe-container__image');

			el.className = 'swipe-container__touch';
			//el.style.border = "0px solid #fff";

			if (Math.abs(e.deltaX) < this.deadZone && Math.abs(e.deltaY) < this.deadZone) {
				el.style.transform = "translate(0px,0px)";
				return;
			}

			var answer = "Dont know";

			if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
				if (e.deltaX > 0) {
					answer = "Yes";
					this.moveAway(el, 500, 0);
				} else if (e.deltaX < 0) {
					answer = "No";
					this.moveAway(el, -500, 0);
				}
			} else {
				this.moveAway(el, 0, -1000);
			}

			setTimeout(function () {
				_this.$emit("onanswer", answer);
				el.style.left = 0;
				el.style.top = 0;
				el.style.opacity = 1;
				el.style.transform = "translate(0px,0px)";
			}, 800);
		},
		moveAway: function moveAway(el, left, top) {
			el.style.opacity = 1;
			__WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(el, {
				opacity: 0,
				left: left,
				top: top
			}, {
				duration: 500,
				easing: [0.39, 0.67, 0.04, 0.98]
			});
		}
	}

});

/***/ }),

/***/ "tU1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__ = __webpack_require__("uQpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	props: ['correctScores', 'currentScores', 'names', 'totalScores'],

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__["a" /* default */]
	},

	mounted: function mounted() {
		this.setFeedback();
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */],
			feedbackArray: []
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])([]), {
		setFeedback: function setFeedback() {
			for (var i = 0; i < this.names.length; i++) {
				switch (i) {
					case 0:
						//Industrie
						if (this.currentScores[i] > +this.correctScores[i]) this.feedbackArray.push("Industrie te hoog.");else if (this.currentScores[i] < +this.correctScores[i]) this.feedbackArray.push("Industrie te laag.");else this.feedbackArray.push("Industrie perfect.");
						break;
					case 1:
						//Landbouw
						if (this.currentScores[i] > +this.correctScores[i]) this.feedbackArray.push("Landbouw te hoog.");else if (this.currentScores[i] < +this.correctScores[i]) this.feedbackArray.push("Landbouw te laag.");else this.feedbackArray.push("Landbouw perfect.");
						break;
					case 2:
						//Natuur
						if (this.currentScores[i] > +this.correctScores[i]) this.feedbackArray.push("Natuur te hoog.");else if (this.currentScores[i] < +this.correctScores[i]) this.feedbackArray.push("Natuur te laag.");else this.feedbackArray.push("Natuur perfect.");
						break;
					case 3:
						//Onbruikbare grond
						if (this.currentScores[i] > +this.correctScores[i]) this.feedbackArray.push("Onbruikbare grond te hoog.");else if (this.currentScores[i] < +this.correctScores[i]) this.feedbackArray.push("Onbruikbare grond te laag.");else this.feedbackArray.push("Onbruikbare grond perfect.");
						break;
				}
			}
		}
	}),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["questionData"]))

});

/***/ }),

/***/ "tf2C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__ = __webpack_require__("uQpZ");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_3__Lottie_vue__["a" /* default */]
	},
	props: [],

	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(function () {
				_this.toNextRoundState();
			}).then(function () {
				_this.showNextButton({ "btn": true, "btn-progres": true, "btn-progres-utrecht-whiteLine": false });
			});
		}, 500);

		this.showTransitorScore(false);
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */]
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['showNextButton', 'setNextButtonAction', 'setRoundState', "showTransitorScore"]), {
		toNextRoundState: function toNextRoundState() {
			if (this.roundData.questions.hide_explanation == "Yes") this.setRoundState("Round");else this.setRoundState("explanation");
		}
	}),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['stageData', 'roundData']), {
		visualExists: function visualExists() {
			return this.roundData != null && this.roundData.questions.intro_visual != null;
		},
		visualIsJson: function visualIsJson() {
			if (this.roundData == null || this.roundData.questions.intro_visual == null) return false;
			var fileExtension = this.roundData.questions.intro_visual.substr(this.roundData.questions.intro_visual.lastIndexOf('.') + 1);
			return fileExtension.toLowerCase() == 'json';
		},


		backgroundImage: function backgroundImage() {

			if (this.roundData.questions.intro_background === null) {
				return '';
			}

			return 'url(' + this.baseUrl + this.roundData.questions.intro_background + ')';
		}
	})

});

/***/ }),

/***/ "tw99":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "txUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--mbtiProfiling",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"mbtiProfiling__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.header)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.questionData.subheader)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"question-header"},[_vm._v(_vm._s(_vm.questionData.questionheader))]),_vm._v(" "),_c('div',{staticClass:"question-text"},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.questionData.questiontext)+"\n\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"visual",staticStyle:{"position":"relative"}},[_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.visual,"alt":""}})])])]),_vm._v(" "),_c('div',{staticClass:"btn__explanation",on:{"click":_vm.showExplanationPopup}},[_c('i',{staticClass:"fa fa-question"})]),_vm._v(" "),(_vm.questionData != null)?_c('div',{staticClass:"centered"},[_c('div',{staticClass:"card card-valueQuiz"},[_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"shadow-box",on:{"click":function () {_vm.onQuestionAnswer(_vm.questionData.answers[0].mbti_classification)}}},[(typeof _vm.questionData.answers[0].visual != 'undefined')?_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[0].visual,"alt":""}}):_vm._e(),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[0].answer_text)}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[0].answer_text)}})])])])]),_vm._v(" "),_c('div',{staticClass:"answer-divider"}),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"shadow-box",on:{"click":function () {_vm.onQuestionAnswer(_vm.questionData.answers[1].mbti_classification)}}},[(typeof _vm.questionData.answers[1].visual != 'undefined')?_c('img',{attrs:{"src":_vm.baseUrl + _vm.questionData.answers[1].visual,"alt":""}}):_vm._e(),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[1].answer_text)}}),_vm._v(" "),_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"text"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.questionData.answers[0].answer_text)}})])])])]),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"btn-answer",on:{"click":function () {_vm.onQuestionAnswer('1')}}},[_vm._v("\n\t\t\t\t\t\t\tA\n\t\t\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"image-box"},[_c('div',{staticClass:"btn-answer",on:{"click":function () {_vm.onQuestionAnswer('2')}}},[_vm._v("\n\t\t\t\t\t\t\tB\n\t\t\t\t\t\t")])])])]):_vm._e()])]),_vm._v(" "),(_vm.explanationPopupActive == true)?_c('ExplanationPopup',{attrs:{"on-click":_vm.hideExplanationPopup}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u3Bt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"question__header"},[_c('p',[_vm._v(_vm._s(_vm.header))])]),_vm._v(" "),_c('img',{staticClass:"question__visual",attrs:{"src":_vm.baseUrl + _vm.visual}}),_vm._v(" "),_c('div',{staticClass:"question__text"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uQpZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lottie_vue__ = __webpack_require__("2ghZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e631d50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lottie_vue__ = __webpack_require__("EJor");
function injectStyle (ssrContext) {
  __webpack_require__("tw99")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e631d50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lottie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e631d50_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lottie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uYIM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        currentRound: 0,
        roundCount: 0,
        data: null,
        type: ""
    },
    mutations: {
        initiateStage: function initiateStage(state) {
            state.currentRound = 0;
        },
        setStageType: function setStageType(state, type) {
            state.type = type;
        },
        setCurrentRound: function setCurrentRound(state, int) {
            state.currentRound = int;
        },
        setRoundCount: function setRoundCount(state, int) {
            state.roundCount = int;
        },
        setStageData: function setStageData(state, stageData) {
            state.data = stageData;
        }
    },
    actions: {
        setStageData: function setStageData(store, data) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var stageType = data.type;

                var roundCount = 0;
                var roundData = null;

                if (stageType == "Rounds") {
                    roundCount = data.data.rounds.length;
                    roundData = data.data.rounds[store.state.currentRound];
                }
                //console.log(stageType);
                //console.log(data);
                store.commit("initiateStage");
                store.commit("setStageType", stageType);
                store.commit("setRoundCount", roundCount);
                store.commit("setStageData", data.data);
                store.dispatch("setRoundData", roundData).then(function () {
                    resolve();
                });
            });
        },
        toNextRound: function toNextRound(store) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setCurrentRound", store.state.currentRound + 1);
                var roundData = store.state.data == null || store.state.data.rounds == null ? null : store.state.data.rounds[store.state.currentRound];
                store.dispatch("setRoundData", roundData).then(function () {
                    resolve();
                });
            });
        }
    },
    getters: {
        stageData: function stageData(state) {
            return state.data;
        },
        currentRound: function currentRound(state) {
            return state.currentRound;
        },
        roundCount: function roundCount(state) {
            return state.roundCount;
        },
        lastRound: function lastRound(state) {
            return state.currentRound >= state.roundCount - 1;
        },
        stageType: function stageType(state) {
            return state.type;
        }
    }
});

/***/ }),

/***/ "us9v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dcpBlock"},[(_vm.stageType == 'Sdg')?_c('Sdg'):(_vm.stageType == 'Dcp')?_c('Dcp'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v2Jv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-overlay card"},[_c('div',{staticClass:"fixed-overlay__header"},[_vm._v("\n\t\t"+_vm._s(_vm.header)+"\n\t")]),_vm._v(" "),_c('div',{staticClass:"fixed-overlay__text",domProps:{"innerHTML":_vm._s(_vm.text)}}),_vm._v(" "),(_vm.visualExists && _vm.visualIsJson)?_c('Lottie',{staticStyle:{"margin":"auto","position":"relative"},attrs:{"animationpath":_vm.visual,"name":"intro-animation","loop":"true","ratio":"meet","autoplay":"true"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn btn-progres",on:{"click":_vm.onClick}},[_vm._v("\n\t\tVerder\n\t")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vQ2g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage red",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"card card-popup flex flexColumn"},[_c('div',{staticClass:"header__container header__container-explanation"},[_c('div',{staticClass:"header header-white",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.roundData.questions.header)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader subHeader-white",staticStyle:{"position":"relative"}},[_vm._v(_vm._s(_vm.roundData.questions.subheader))]),_vm._v(" "),_c('div',{staticClass:"text text-white",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.roundData.questions.explanation)}})]),_vm._v(" "),(_vm.visualExists && _vm.visualIsJson)?_c('Lottie',{staticStyle:{"margin":"auto","position":"relative"},attrs:{"name":"explenation-animation","loop":"true","ratio":"meet","animationpath":_vm.baseUrl + _vm.roundData.questions.visual}}):(_vm.visualExists)?_c('div',{staticClass:"centered visual"},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.roundData.questions.visual}})]):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vxI4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__ = __webpack_require__("uQpZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Lottie: __WEBPACK_IMPORTED_MODULE_1__Lottie_vue__["a" /* default */]
	},

	beforeMount: function beforeMount() {
		this.findCorrectFeedback();
	},
	mounted: function mounted() {
		var _this = this;

		setTimeout(function () {
			_this.setNextButtonAction(_this.lastRound ? _this.toNextStage : _this.toNextRound).then(function () {
				_this.showNextButton().then(function () {
					_this.setMbtiProfile(_this.mbtiProfile);
				});
			});
		}, 500);
	},
	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */],
			classificationsArray: { "E": 0, "I": 0, "S": 0, "N": 0, "T": 0, "F": 0, "J": 0, "P": 0 },
			classificationPairsArray: ["E,I", "S,N", "T,F", "J,P"],
			classificationResult: [],
			classificationResultString: false,
			trueColors: {
				'guardian': ['Goud', '#DB9F49', 'Verzorger'],
				'artisan': ['Oranje', '#FFAE61', 'Vakman'],
				'idealist': ['Blauw', '#17ABB4', 'Idealist'],
				'rationalist': ['Groen', '#17B46F', 'Rationalist']
			},
			trueColorsClassification: {
				'guardian': ['ESTJ', 'ISTJ', 'ESFJ', 'ISFJ'],
				'artisan': ['ESTP', 'ISTP', 'ESFP', 'ISFP'],
				'idealist': ['ENFJ', 'INFJ', 'ENFP', 'INFP'],
				'rationalist': ['ENTJ', 'INTJ', 'ENTP', 'INTP']
			},
			trueColorsClassificationResult: false,
			mbtiProfile: {
				"mbtiClassification": false,
				"trueColorClassification": false
			}
		};
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["setNextButtonAction", "showNextButton", "toNextStage", "toNextRound", "setMbtiProfile"]), {
		findCorrectFeedback: function findCorrectFeedback() {

			for (var i = 0; i < this.feedbackData.answers.length; i++) {
				var answer = this.feedbackData.answers[i];
				this.classificationsArray[answer]++;
			}

			//check which of each pairs is the favourite
			for (var _i = 0; _i < this.classificationPairsArray.length; _i++) {
				var pair = this.classificationPairsArray[_i].split(",");
				var highest = 0;
				var dominatingClass = false;
				for (var j = 0; j < pair.length; j++) {
					if (this.classificationsArray[pair[j]] > highest) {

						highest = this.classificationsArray[pair[j]];

						dominatingClass = pair[j];
					} else {
						dominatingClass = pair[0];
					}
				}

				this.classificationResult.push(dominatingClass);
			}

			this.classificationResultString = this.classificationResult.join("");

			//find the trueColors indicator

			for (var k in this.trueColorsClassification) {
				if (this.trueColorsClassification.hasOwnProperty(k)) {

					if (this.trueColorsClassification[k].indexOf(this.classificationResultString) !== -1) {

						this.trueColorsClassificationResult = k;
					}
				}
			}

			this.mbtiProfile.mbtiClassification = this.classificationResultString;
			this.mbtiProfile.trueColorClassification = this.trueColors[this.trueColorsClassificationResult];

			console.log(this.mbtiProfile.trueColorClassification[2]);
		}
	}),
	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["questionData", "feedbackData", "lastRound", 'roundData']), {
		feedback: function feedback() {

			for (var i = 0; i < this.roundData.questions.feedback.length; i++) {

				if (this.roundData.questions.feedback[i].mbtiprofile == this.mbtiProfile.trueColorClassification[2]) {

					return this.roundData.questions.feedback[i];
				}
			}

			return this.roundData.questions.feedback[0];
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}
	})

});

/***/ }),

/***/ "w890":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-frame",class:_vm.isIOS,style:({ 'height': _vm.deviceHeight })},[(_vm.gameLoaded)?_c('div',{staticClass:"root"},[_c('ContentBlock')],1):(_vm.browserNotAllowed)?_c('div',{staticClass:"root browser-not-allowed-message"},[_vm._m(0,false,false)]):_c('div',[_vm._m(1,false,false),_vm._v(" "),_c('div',{staticClass:"loading"},[_c('p',[_vm._v(_vm._s(_vm.infoText))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-popup"},[_c('h2',[_vm._v("¡¿Asjemenou?!")]),_vm._v(" "),_c('p',[_vm._v("Aiii, wat vervelend. Op deze telefoon kunnen we je helaas geen optimale speelervaring bieden.")]),_vm._v(" "),_c('p',[_vm._v("We raden je aan om het op je laptop of desktop computer te proberen.")]),_vm._v(" "),_c('div',{staticClass:"visual"},[_c('i',{staticClass:"fa fa-minus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sk-circle"},[_c('div',{staticClass:"sk-circle1 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle2 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle3 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle4 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle5 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle6 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle7 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle8 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle9 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle10 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle11 sk-child"}),_vm._v(" "),_c('div',{staticClass:"sk-circle12 sk-child"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wIOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-popup card-popup__explanation",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container header__container-explanation"},[_c('div',{staticClass:"header header-white",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.questions.header)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"subHeader subHeader-white",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.roundData.questions.subheader)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text text-white",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.fullHTML)}})]),_vm._v(" "),(_vm.visualExists && _vm.visualIsJson)?_c('Lottie',{staticStyle:{"margin":"auto","position":"relative"},attrs:{"name":"explenation-animation","loop":"true","ratio":"meet","animationpath":_vm.baseUrl + _vm.roundData.questions.visual}}):(_vm.visualExists)?_c('div',{staticClass:"visual centered"},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.roundData.questions.visual}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"btn btn-progres btn-progres-utrecht-whiteLine",on:{"click":_vm.onClick}},[(_vm.language == 'NL')?_c('span',[_vm._v("sluit")]):(_vm.language == 'FR')?_c('span',[_vm._v("fermer")]):_c('span',[_vm._v("close")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wIkJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__ = __webpack_require__("mwU7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc738a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__ = __webpack_require__("u3Bt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Question_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dc738a9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Question_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//


//import './assets/fonts/fonts.css';

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'app',
	teamcode: '',
	resp_id: '',
	challenge_token: ''
});

/***/ }),

/***/ "xVd5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"impact-tool-feedback stage",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"header__container"},[_c('div',{staticClass:"subHeader",staticStyle:{"position":"relative"}},[(_vm.language == 'NL')?_c('span',[_vm._v("Verborgen impact")]):_c('span',[_vm._v("Votre empreinte cachée")])]),_vm._v(" "),_c('div',{staticClass:"header",staticStyle:{"position":"relative"}},[(_vm.language == 'NL')?_c('span',[_vm._v("Resultaten")]):_c('span',[_vm._v("Résultats")])]),_vm._v(" "),(_vm.language == 'NL')?_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\tAls iedereen zou leven zoals "),_c('span',{staticClass:"green bold"},[_vm._v("jij")]),_vm._v(" hebben we "+_vm._s(_vm.totalsEarths)+" aardes nodig. Je doet het dus "),(_vm.totalsEarths > 3.6)?_c('span',[_vm._v("slechter")]):_c('span',[_vm._v("beter")]),_vm._v(" dan de "),_c('span',{staticClass:"pink bold"},[_vm._v("gemiddelde Nederlander")]),_vm._v(". Op naar binnen de draagkracht van de planeet: max. 1 aarde! Jouw impact compenseer je met het aanplanten van "+_vm._s(_vm.treeCompensation)+" bomen.\n\t\t\t")]):_c('div',{staticClass:"text",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\tSi tout le monde vit comme "),_c('span',{staticClass:"green bold"},[_vm._v("vous")]),_vm._v(", nous avons besoin de "+_vm._s(_vm.totalsEarths)+" terres. Vous faites "),(_vm.totalsEarths > 3.6)?_c('span',[_vm._v("moins bien")]):_c('span',[_vm._v("mieux")]),_vm._v(" que le "),_c('span',{staticClass:"pink bold"},[_vm._v("Français moyen")]),_vm._v(". À l'intérieur de la capacité de charge de la planète: maximum 1 terre! Vous pouvez compenser votre impact en plantant "+_vm._s(_vm.treeCompensation)+" arbres.\n\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"panel"},[_c('div',{staticClass:"visual"},[_c('div',{staticClass:"visual--part left-side"},[_c('div',{staticClass:"visual_earths earths_visual"}),_vm._v(" "),_c('div',{staticClass:"visual_number"},[_vm._v(_vm._s(_vm.totalsEarths))])]),_vm._v(" "),_c('div',{staticClass:"visual--part right-side"},[_c('div',{staticClass:"visual_earths earths_visual_avg"}),_vm._v(" "),_c('div',{staticClass:"visual_number"},[_vm._v(_vm._s(_vm.totalsEarthsAvg))])])]),_vm._v(" "),_c('div',{staticClass:"legend"},[_c('div',{staticClass:"legend--part left-side"},[_c('div',{staticClass:"visual_header green"},[_vm._v(_vm._s(_vm.text_parts['jij'])+" "),_c('img',{staticClass:"visual-you",attrs:{"src":_vm.baseUrl+_vm.roundData.questions.visual_you}})])]),_vm._v(" "),_c('div',{staticClass:"legend--part right-side"},[_c('div',{staticClass:"visual_header pink"},[_vm._v(_vm._s(_vm.text_parts['country'])+" "),_c('img',{staticClass:"visual-average",attrs:{"src":_vm.baseUrl+_vm.roundData.questions.visual_average}})])])]),_vm._v(" "),_vm._l((_vm.ratios),function(data,i){return _c('div',{staticClass:"group"},[_c('div',{staticClass:"group-header"},[_vm._v(_vm._s(data[2]))]),_vm._v(" "),_c('div',{staticClass:"group-bar"},[_c('div',{staticClass:"bar-part right-bar"},[_c('div',{staticClass:"bar",style:(_vm.setWidth(data[1]))})]),_vm._v(" "),_c('div',{staticClass:"bar-part left-bar"},[_c('div',{staticClass:"bar",style:(_vm.setWidth(data[0]))})])])])}),_vm._v(" "),(this.challengeToken)?_c('div',{staticStyle:{"height":"auto","margin-bottom":"20px"}},[_vm._m(0,false,false)]):_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"http://onefutureplay.com/my-challenges"}},[_c('div',{staticClass:"btn btn-progres"},[_vm._v("Naar challenges")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xYNo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y3B7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RoundSlider_vue__ = __webpack_require__("QhFf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__const_base__ = __webpack_require__("PY/H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate__ = __webpack_require__("9qgI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ExplanationPopup_vue__ = __webpack_require__("Zp/M");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		RoundSlider: __WEBPACK_IMPORTED_MODULE_1__RoundSlider_vue__["a" /* default */],
		ExplanationPopup: __WEBPACK_IMPORTED_MODULE_5__ExplanationPopup_vue__["a" /* default */]
	},

	data: function data() {
		return {
			baseUrl: __WEBPACK_IMPORTED_MODULE_2__const_base__["a" /* url */],
			displayValues: [],
			sliderValue: 0,
			userAnswers: [],
			explanationPopupActive: false
		};
	},
	mounted: function mounted() {
		var _this = this;

		this.showTransitorScore(false);
		this.setSliderValue(0);
		this.setNextButtonAction(this.next).then(function () {
			_this.showNextButton();
		});
	},


	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* mapGetters */])(["lastQuestion", "currentBlock", "currentStage", "currentRound", "currentQuestion", "roundCount", "scores", "questionData", "roundData", "roundScore"]), {
		comment: function comment() {
			var _this2 = this;

			var commentText = "Undefined";
			this.questionData.comments.forEach(function (comment) {
				if (_this2.sliderValue >= +comment.frompoint) commentText = comment.comment_text;
			});
			return commentText;
		},


		backgroundImage: function backgroundImage() {
			return 'url(' + this.baseUrl + this.roundData.questions.question_background + ')';
		}

	}),

	watch: {
		currentQuestion: function currentQuestion(val) {
			this.setSliderValue(0);
		}
	},

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(['setNextButtonAction', "setFeedbackData", 'showNextButton', 'hideNextButton', "playAudio", "increaseTransitorScore", "showTransitorScore", "completeRound", "toNextQuestion", "addRoundScore", "setScore", "logAnswers"]), {
		hideExplanationPopup: function hideExplanationPopup() {
			this.explanationPopupActive = false;
			$('.btn--transition').removeClass('idle');
		},
		showExplanationPopup: function showExplanationPopup() {
			this.explanationPopupActive = true;
			$('.btn--transition').addClass('idle');
		},


		slideChange: function slideChange(data) {
			this.setSliderValue(data.value);
		},

		setSliderValue: function setSliderValue(val) {
			this.sliderValue = val;
			var stringValue = String(val);
			var maxValue = this.questionData.maxvalue;

			this.displayValues = stringValue.split("");
			var maxDisplayValue = String(maxValue).split("");

			var diffValue = maxDisplayValue.length - this.displayValues.length;

			for (var i = diffValue - 1; i >= 0; i--) {
				this.displayValues.unshift('0');
			};
		},
		next: function next() {
			var _this3 = this;

			this.userAnswers.push(this.sliderValue);
			if (this.lastQuestion) {
				this.hideNextButton().then(function () {
					setTimeout(function () {
						_this3.completeRound();
					}, 500);
				});

				this.setFeedbackData({
					userAnswers: this.userAnswers,
					totalScores: 10
				});

				this.logAnswers(this.userAnswers);
			} else {
				this.toNextQuestion().then(function () {
					_this3.setButtonAction();
				});
			}
		},
		setButtonAction: function setButtonAction() {
			var _this4 = this;

			this.hideNextButton().then(function () {
				_this4.setNextButtonAction(_this4.next).then(function () {
					setTimeout(function () {
						_this4.showNextButton();
					}, 200);
				});
			});
		}
	})

});

/***/ }),

/***/ "yFxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block",class:'block'+_vm.currentBlock},[_c('Preloader'),_vm._v(" "),_c('Transitors'),_vm._v(" "),_c('transition',{attrs:{"appear":"","name":"block-transition","css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"before-leave":_vm.beforeLeave,"leave":_vm.leave,"after-leave":_vm.transitionOutReady}},[(_vm.blockTransitioning)?_c('div',{staticClass:"block-transition"},[(_vm.blockType == 'intro')?_c('Intro'):_vm._e(),_vm._v(" "),(_vm.blockType == 'dcp')?_c('DcpBlock'):(_vm.blockType == 'cutscene')?_c('Cutscene'):(_vm.blockType == 'gameblock')?_c('Minigame'):_vm._e(),_vm._v(" "),(_vm.blockType == 'personalia')?_c('Personalia'):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"appear":"","name":"btn--transition","enter-class":"btn--transition-down","enter-active-class":"btn--transition-in","enter-to-class":"btn--transition-final","leave-class":"btn--transition-final","leave-active-class":"btn--transition-out","leave-to-class":"btn--transition-down"}},[(_vm.nextButtonShown)?_c('div',{staticClass:"btn--transition",class:_vm.nextButtonClass,on:{"click":_vm.nextAction}},[_vm._v(_vm._s(_vm.nextButtonLabel))]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yI0o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("/5sW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__const_base__ = __webpack_require__("PY/H");






/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            baseUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["a" /* url */]
        };
    },


    state: {
        loaded: false,
        instanceId: -1,
        apiUrl: __WEBPACK_IMPORTED_MODULE_3__const_base__["c" /* api_url */],
        userId: false,
        userRole: false,
        mbtiProfile: {
            mbtiClassification: false,
            trueColorClassification: false
        },
        userImpact: false,
        dcpProfileText: false,
        teamCode: false,
        respondent: false,
        challengeToken: false,
        emailVerificationCompleted: false,
        currentBlock: 0,
        transitorScore: 0,
        transitorShown: false,
        transitorAnim: false,
        transitorSound: false,
        soundtrackPlaying: false,
        lastBlock: false,
        blocks: [],
        globalSettings: {},
        globalGroups: {},
        answerLogs: [],
        sdgLogs: [],
        nextButton: false,
        nextButtonClass: {
            btn: true,
            "btn-progres": true,
            "btn-progres-utrecht-whiteLine": false
        },
        underWater: false,
        nextButtonAction: function nextButtonAction() {}
    },
    mutations: {
        setEmailVerificationCompleted: function setEmailVerificationCompleted(state, action) {
            state.emailVerificationCompleted = true;
        },
        setNextButtonAction: function setNextButtonAction(state, action) {
            state.nextButtonAction = action;
        },
        setTransitor: function setTransitor(state, obj) {
            state.transitorAnim = obj.transitor_animation;
            state.transitorSound = obj.transitor_sound;
        },
        setTransitorSound: function setTransitorSound(state, sound) {
            state.transitorSound = sound;
        },
        showTransitorScore: function showTransitorScore(state, action) {
            state.transitorShown = action;
        },
        IncreaseTransitorScore: function IncreaseTransitorScore(state, quantity) {
            state.transitorScore += quantity;
        },
        setSoundTrackState: function setSoundTrackState(state, audioInstance) {
            state.soundtrackPlaying = audioInstance;
        },
        setNextButton: function setNextButton(state, show) {
            state.nextButton = show;
        },
        setInstanceId: function setInstanceId(state, id) {
            state.instanceId = id;
        },
        setUserId: function setUserId(state, id) {
            state.userId = id;
        },
        setUserRole: function setUserRole(state, id) {
            state.userRole = id;
        },
        setMbtiProfile: function setMbtiProfile(state, obj) {
            state.mbtiProfile.mbtiClassification = obj.mbtiClassification;
            state.mbtiProfile.trueColorClassification = obj.trueColorClassification;
        },
        setDcpProfileText: function setDcpProfileText(state, profileTextArrayJson) {
            state.dcpProfileText = profileTextArrayJson;
        },
        setUserImpact: function setUserImpact(state, impact) {
            state.userImpact = impact;
        },
        setTeamCode: function setTeamCode(state, id) {
            state.teamCode = id;
        },
        setChallengeToken: function setChallengeToken(state, token) {
            state.challengeToken = token;
        },
        setRespondentId: function setRespondentId(state, id) {
            state.resp_id = id;
        },
        setRespondent: function setRespondent(state, obj) {
            state.respondent = obj;
        },
        setGameLoaded: function setGameLoaded(state) {
            state.loaded = true;
        },
        incrementCurrentBlock: function incrementCurrentBlock(state) {
            state.currentBlock++;
        },
        resetCurrentBlock: function resetCurrentBlock(state) {
            state.currentBlock = 0;
        },
        clearBlocks: function clearBlocks(state, block) {
            state.blocks = [];
        },
        addBlock: function addBlock(state, block) {
            state.blocks.push(block);
        },
        setLastBlock: function setLastBlock(state) {
            state.lastBlock = state.currentBlock >= state.blocks.length - 1;
        },
        setNextButtonClass: function setNextButtonClass(state, obj) {
            state.nextButtonClass = obj;
        },
        setUnderWater: function setUnderWater(state, bool) {
            state.underWater = bool;
        },
        logAnswers: function logAnswers(state, data) {
            var block = state.blocks[data.block];
            if (block == undefined) return;
            var stage = block.data_structure[data.stage];
            if (stage == undefined) return;
            var round = stage.data.rounds[data.round];
            if (round == undefined) return;
            round["answers"] = data.answers;
        },
        logSdgs: function logSdgs(state, data) {
            var block = state.blocks[data.block];
            if (block == undefined) return;
            var stage = block.data_structure[data.stage];
            if (stage == undefined) return;
            var round = stage.data.rounds[data.round];
            if (round == undefined) return;
            round["sdgs"] = data.sdgs;
        },
        setGlobalSettings: function setGlobalSettings(state, settings) {
            state.globalSettings = settings;
        },
        setGlobalGroups: function setGlobalGroups(state, groups) {
            state.globalGroups = groups;
        },
        setRoundScore: function setRoundScore(state, data) {
            var block = state.blocks[data.block];
            if (block == undefined) return;
            var stage = block.data_structure[data.stage];
            if (stage == undefined) return;
            var round = stage.data.rounds[data.round];
            if (round == undefined) return;
            round["score"] = data.score;
        }
    },
    actions: {
        setEmailVerificationCompleted: function setEmailVerificationCompleted(store) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log('teamcode: '+id);
                store.commit("setEmailVerificationCompleted", true);
                resolve();
            });
        },
        setTransitorSound: function setTransitorSound(store, sound) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log(object);
                store.commit("setTransitorSound", sound);
                resolve();
            });
        },
        setNextButtonClass: function setNextButtonClass(store, object) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log(object);
                store.commit("setNextButtonClass", object);
                resolve();
            });
        },
        showTransitorScore: function showTransitorScore(store, action) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("showTransitorScore", action);
                resolve();
            });
        },
        increaseTransitorScore: function increaseTransitorScore(store, quantity) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("IncreaseTransitorScore", quantity);
                resolve();
            });
        },
        setUserRole: function setUserRole(store, id) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log('role: '+id);
                store.commit("setUserRole", id);
                resolve();
            });
        },
        setMbtiProfile: function setMbtiProfile(store, obj) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log('role: '+id);
                store.commit("setMbtiProfile", obj);
                resolve();
            });
        },
        setUserImpact: function setUserImpact(store, impact) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log('teamcode: '+id);
                store.commit("setUserImpact", impact);
                resolve();
            });
        },
        setTeamCode: function setTeamCode(store, id) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log('teamcode: '+id);
                store.commit("setTeamCode", id);
                resolve();
            });
        },
        setChallengeToken: function setChallengeToken(store, token) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                console.log('challengeToken: ' + token);
                store.commit("setChallengeToken", token);
                resolve();
            });
        },
        setRespondentId: function setRespondentId(store, id) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log('setRespondentId: '+id);
                store.commit("setRespondentId", id);
                resolve();
            });
        },
        setRespondent: function setRespondent(store, obj) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                //console.log('setRespondent: '+obj);
                store.commit("setRespondent", obj);
                resolve();
            });
        },
        toNextBlock: function toNextBlock(store) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("incrementCurrentBlock");
                _this.dispatch("setBlock").then(function () {
                    resolve();
                });
            });
        },
        setBlock: function setBlock(store) {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this2.dispatch("setBlockData", {
                    blockType: store.state.blocks[store.state.currentBlock].type,
                    settings: store.state.blocks[store.state.currentBlock].settings,
                    stages: store.state.blocks[store.state.currentBlock].data_structure
                }).then(function () {
                    store.commit("setLastBlock");
                    resolve();
                });
            });
        },
        loadGameData: function loadGameData(store, teamcode) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {

                if (typeof teamcode !== "undefined") {
                    store.commit("setTeamCode", teamcode);
                }

                //console.log(this.$route.query.teamcode);

                //store.commit("setRespondentId" , teamcode);

                /* store.dispatch("applyData", data).then(() => {
                    resolve();
                });
                return;
                */

                // .get(
                //         store.state.apiUrl +
                //             "api/v2/loadinstance?id=32&teamcode=" +
                //             teamcode
                //     )
                //     .then(response => {

                //Vue.http.get('data.json').then(response => {

                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.get(store.state.apiUrl + "api/v2/loadinstance?id=23teamcode=" + teamcode).then(function (response) {

                    var data = response.body;
                    store.dispatch("applyData", data).then(function () {
                        resolve();
                    });
                }).catch(function (response) {
                    reject("Could not load data");
                });
            });
        },
        applyData: function applyData(store, data) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("clearBlocks");
                store.commit("setGlobalSettings", JSON.parse(data.settings));
                store.commit("setGlobalGroups", data.groups);
                store.commit("setUserId", data.session_id);

                store.commit("setRespondent", data.respondent);

                store.commit("setInstanceId", data.id);

                store.commit("setTransitor", JSON.parse(data.settings).assets);

                store.commit("setDcpProfileText", data.dcpText);

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(data.blockData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var blockData = _step.value;

                        store.commit("addBlock", blockData);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                store.dispatch("setBlock").then(function () {
                    store.commit("setGameLoaded");
                    resolve();
                });
            });
        },
        showNextButton: function showNextButton(store, classObj) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setNextButton", true);
                store.commit("setNextButtonClass", classObj != undefined ? classObj : {
                    btn: true,
                    "btn-progres": true,
                    "btn-progres-utrecht-whiteLine": false
                });
                resolve();
            });
        },
        setNextButtonAction: function setNextButtonAction(store, action) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setNextButtonAction", action);
                resolve();
            });
        },
        hideNextButton: function hideNextButton(store) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setNextButton", false);
                resolve();
            });
        },
        setUnderWater: function setUnderWater(store, bool) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setUnderWater", bool);
                resolve();
            });
        },
        logAnswers: function logAnswers(store, answers) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var data = {
                    block: store.getters.currentBlock,
                    stage: store.getters.currentStage,
                    round: store.getters.currentRound,
                    answers: answers
                };

                store.commit("logAnswers", data);

                var log = {
                    user_id: store.getters.userId,
                    instance_id: store.getters.instanceId,
                    block_id: store.getters.blocks[store.getters.currentBlock].id,
                    round_id: store.getters.currentRound,
                    gametype: store.getters.roundData.gametype,
                    answers: answers
                };

                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(store.state.apiUrl + "api/v2/saveroundscore", log).then(function (response) {
                    //console.log('Response from saveroundscore:');
                    //console.log(response.body);
                }).catch(function (response) {
                    //console.log(response);
                });

                resolve();
            });
        },
        saveAnswerLogs: function saveAnswerLogs(store) {
            // NOT USED

            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var body = {
                    user_id: store.getters.userId,
                    instance_id: store.getters.instanceId,
                    answers: store.getters.answerLogs,
                    pointsjson: store.getters.scores
                };

                __WEBPACK_IMPORTED_MODULE_2_vue__["a" /* default */].http.post(store.state.apiUrl + "api/v2/savescore", body).then(function (response) {
                    //console.log(response.body);
                    resolve();
                }).catch(function (response) {
                    //console.log(response);
                    reject("Could not save answers.");
                });
            });
        },
        setRoundScore: function setRoundScore(store, score) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var data = {
                    block: store.getters.currentBlock,
                    stage: store.getters.currentStage,
                    round: store.getters.currentRound,
                    score: score
                };

                store.commit("setRoundScore", data);
                resolve();
            });
        },
        logSdgs: function logSdgs(store, sdgs) {
            return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var data = {
                    block: store.getters.currentBlock,
                    stage: store.getters.currentStage,
                    round: store.getters.currentRound,
                    sdgs: sdgs
                };

                store.commit("logSdgs", data);

                var log = {
                    user_id: store.getters.userId,
                    instance_id: store.getters.instanceId,
                    block_id: store.getters.blocks[store.getters.currentBlock].id,
                    round_id: store.getters.currentRound,
                    gametype: store.getters.roundData.gametype,
                    sdgs: sdgs
                };

                // Vue.http
                //     .post(store.state.apiUrl + "api/v2/saveroundscore", log)
                //     .then(response => {
                //         //console.log('Response from saveroundscore:');
                //         //console.log(response.body);
                //     })
                //     .catch(response => {
                //         //console.log(response);
                //     });

                resolve();
            });
        }
    },

    getters: {
        emailVerificationCompleted: function emailVerificationCompleted(state) {
            return state.emailVerificationCompleted;
        },
        instanceId: function instanceId(state) {
            return state.instanceId;
        },
        userId: function userId(state) {
            return state.userId;
        },
        gameLoaded: function gameLoaded(state) {
            return state.loaded;
        },
        blocks: function blocks(state) {
            return state.blocks;
        },
        currentBlock: function currentBlock(state) {
            return state.currentBlock;
        },
        lastBlock: function lastBlock(state) {
            return state.lastBlock;
        },
        nextButtonShown: function nextButtonShown(state) {
            return state.nextButton;
        },
        nextButtonClass: function nextButtonClass(state) {
            return state.nextButtonClass;
        },
        nextButtonAction: function nextButtonAction(state) {
            return state.nextButtonAction;
        },
        underWater: function underWater(state) {
            return state.underWater;
        },
        transitorScore: function transitorScore(state) {
            return state.transitorScore;
        },
        transitorShown: function transitorShown(state) {
            return state.transitorShown;
        },
        transitorAnim: function transitorAnim(state) {
            return state.transitorAnim;
        },
        transitorSound: function transitorSound(state) {
            return state.transitorSound;
        },
        answerLogs: function answerLogs(state) {
            return state.answerLogs;
        },
        sdgLogs: function sdgLogs(state) {
            return state.sdgLogs;
        },
        globalSettings: function globalSettings(state) {
            return state.globalSettings;
        },
        globalGroups: function globalGroups(state) {
            return state.globalGroups;
        },
        userRole: function userRole(state) {
            return state.userRole;
        },
        userImpact: function userImpact(state) {
            return state.userImpact;
        },
        mbtiProfile: function mbtiProfile(state) {
            return state.mbtiProfile;
        },
        teamCode: function teamCode(state) {
            return state.teamCode;
        },
        challengeToken: function challengeToken(state) {
            return state.challengeToken;
        },
        resp_id: function resp_id(state) {
            return state.resp_id;
        },
        respondent: function respondent(state) {
            return state.respondent;
        },
        dcpProfileText: function dcpProfileText(state) {
            return state.dcpProfileText;
        }
    }
});

/***/ }),

/***/ "yIM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        type: "",
        currentStage: 0,
        stageCount: 0,
        settings: {},
        stages: [],
        transitioning: false
    },
    mutations: {
        setCurrentStage: function setCurrentStage(state, currentStage) {
            state.currentStage = currentStage;
        },
        setBlockType: function setBlockType(state, type) {
            state.type = type;
        },
        setBlockSettings: function setBlockSettings(state, settings) {
            state.settings = settings;
        },
        setTransitioning: function setTransitioning(state, bool) {
            state.transitioning = bool;
        },
        setBlockStages: function setBlockStages(state, stageArray) {
            if (!Array.isArray(stageArray)) {
                console.log("Trying to add stages but it is not an array");
                state.stages = [];
                state.stageCount = state.stages.length;
                return;
            }
            state.stages = stageArray;
            state.stageCount = state.stages.length;
        }
    },
    actions: {
        setBlockData: function setBlockData(store, data) {
            var _this = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                console.log('setBlockData: hide_intro:');
                console.log(data.stages[0].data.hide_intro);
                console.log(data.stages[0].data.use == "No");

                if (data.blockType == "gameblock" && data.stages[0].type == "Intro" && data.stages[0].data.hide_intro == "Yes") {
                    store.commit("setCurrentStage", 1);
                } else if (data.blockType == "dcp" && data.stages[0].type == "Sdg" && data.stages[0].data.use == "No") {
                    store.commit("setCurrentStage", 1);
                } else {
                    store.commit("setCurrentStage", 0);
                }

                store.commit("setBlockType", data.blockType);
                store.commit("setBlockSettings", data.settings);
                store.commit("setBlockStages", data.stages);
                if (store.state.stages[store.state.currentStage] == undefined) {
                    reject("No stage data in block.");
                } else {
                    _this.dispatch("setStageData", store.state.stages[store.state.currentStage]).then(function () {
                        resolve();
                    });
                }
            });
        },
        toNextStage: function toNextStage(store) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setCurrentStage", store.state.currentStage + 1);
                store.dispatch("setStageData", store.state.stages[store.state.currentStage]).then(function () {
                    var stageType = store.getters.stageType;
                    var blockSettings = store.getters.blockSettings;

                    var useScore = "No";
                    if (typeof blockSettings.score !== 'undefined') {
                        useScore = blockSettings == null ? "No" : blockSettings.score.use;
                    }

                    if (stageType == "Score" && useScore == "No") {
                        console.log("Skip totem");
                        store.dispatch("toNextBlock").then(function () {
                            resolve();
                        });
                    } else {
                        resolve();
                    }
                });
            });
        },
        startBlockTransition: function startBlockTransition(store) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setTransitioning", true);
                resolve();
            });
        },
        stopBlockTransition: function stopBlockTransition(store) {
            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                store.commit("setTransitioning", false);
                resolve();
            });
        }
    },
    getters: {
        blockType: function blockType(state) {
            return state.type;
        },
        blockSettings: function blockSettings(state) {
            return state.settings;
        },
        blockTransitioning: function blockTransitioning(state) {
            return state.transitioning;
        },
        lastStage: function lastStage(state) {
            return state.currentStage >= state.stageCount - 1;
        },
        currentStage: function currentStage(state) {
            return state.currentStage;
        },
        stageCount: function stageCount(state) {
            return state.stageCount;
        }
    }
});

/***/ }),

/***/ "z7Oh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage stage--feedback red",style:({ 'background-image': _vm.backgroundImage })},[_c('div',{staticClass:"feedback__background-overlay background-overlay"},[_c('div',{staticClass:"content-container"},[_c('div',{staticClass:"header__container header__container-explanation shadow-box"},[_c('div',{staticClass:"subHeader text-whiteX",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.feedback.subheader)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"header header-whiteX",staticStyle:{"position":"relative"}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.feedback.header)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"text text-whiteX",staticStyle:{"position":"relative"},domProps:{"innerHTML":_vm._s(_vm.feedback.feedbacktext)}})]),_vm._v(" "),(typeof _vm.feedback.visual!== 'undefined')?_c('div',{staticClass:"centered"},[_c('img',{staticClass:"visual",attrs:{"src":_vm.baseUrl + _vm.feedback.visual}})]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zRPJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"none","height":"auto","position":"absolute"}},[_vm._l((_vm.imgArrayNow),function(img,index){return _c('div',{key:index,staticClass:"imgContainer"},[_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":_vm.baseUrl + img}})])}),_vm._v(" "),_vm._l((_vm.imgArrayNext),function(img,index){return _c('div',{key:index,staticClass:"imgContainer"},[_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":_vm.baseUrl + img}})])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zUoG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overlay_vue__ = __webpack_require__("DWO9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7b6ffd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overlay_vue__ = __webpack_require__("v2Jv");
function injectStyle (ssrContext) {
  __webpack_require__("Spgx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c7b6ffd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Overlay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c7b6ffd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Overlay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zoWV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__minigames_abquiz_Index_vue__ = __webpack_require__("J/Do");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__minigames_multiquiz_Index_vue__ = __webpack_require__("HvA9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minigames_matchingquiz_Index_vue__ = __webpack_require__("WGiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__minigames_swipequiz_Index_vue__ = __webpack_require__("DV0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__minigames_systeemdenken_Index_vue__ = __webpack_require__("+Aaa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__minigames_SysteemdenkenControleVragen_Index_vue__ = __webpack_require__("DNWK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__minigames_simonsays_Index_vue__ = __webpack_require__("npeb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__minigames_world_Index_vue__ = __webpack_require__("+xvR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__minigames_landmark_Index_vue__ = __webpack_require__("8CVL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__minigames_impactcalculator_Index_vue__ = __webpack_require__("mFD/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__minigames_teamrole_Index_vue__ = __webpack_require__("l3el");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__minigames_mbtiprofile_Index_vue__ = __webpack_require__("GIBH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__minigames_Intro_vue__ = __webpack_require__("aCIB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__minigames_RoundIntro_vue__ = __webpack_require__("EvVh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__minigames_Explanation_vue__ = __webpack_require__("FYtz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__minigames_Totem_vue__ = __webpack_require__("cuXJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__minigames_feedback_Index_vue__ = __webpack_require__("LiO2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({

	components: {
		Intro: __WEBPACK_IMPORTED_MODULE_13__minigames_Intro_vue__["a" /* default */],
		RoundIntro: __WEBPACK_IMPORTED_MODULE_14__minigames_RoundIntro_vue__["a" /* default */],
		Explanation: __WEBPACK_IMPORTED_MODULE_15__minigames_Explanation_vue__["a" /* default */],
		Totem: __WEBPACK_IMPORTED_MODULE_16__minigames_Totem_vue__["a" /* default */],
		Feedback: __WEBPACK_IMPORTED_MODULE_17__minigames_feedback_Index_vue__["a" /* default */],
		ABQuiz: __WEBPACK_IMPORTED_MODULE_1__minigames_abquiz_Index_vue__["a" /* default */],
		MultiQuiz: __WEBPACK_IMPORTED_MODULE_2__minigames_multiquiz_Index_vue__["a" /* default */],
		MatchingQuiz: __WEBPACK_IMPORTED_MODULE_3__minigames_matchingquiz_Index_vue__["a" /* default */],
		SwipeQuiz: __WEBPACK_IMPORTED_MODULE_4__minigames_swipequiz_Index_vue__["a" /* default */],
		SysteemDenken: __WEBPACK_IMPORTED_MODULE_5__minigames_systeemdenken_Index_vue__["a" /* default */],
		SysteemDenkenControleVragen: __WEBPACK_IMPORTED_MODULE_6__minigames_SysteemdenkenControleVragen_Index_vue__["a" /* default */],
		SimonSays: __WEBPACK_IMPORTED_MODULE_7__minigames_simonsays_Index_vue__["a" /* default */],
		World: __WEBPACK_IMPORTED_MODULE_8__minigames_world_Index_vue__["a" /* default */],
		LandMark: __WEBPACK_IMPORTED_MODULE_9__minigames_landmark_Index_vue__["a" /* default */],
		ImpactCalculator: __WEBPACK_IMPORTED_MODULE_10__minigames_impactcalculator_Index_vue__["a" /* default */],
		TeamRole: __WEBPACK_IMPORTED_MODULE_11__minigames_teamrole_Index_vue__["a" /* default */],
		MbtiProfile: __WEBPACK_IMPORTED_MODULE_12__minigames_mbtiprofile_Index_vue__["a" /* default */]
	},

	computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_vuex__["a" /* mapGetters */])(["roundState", "blockType", "stageType", "roundCompleted", "roundExplained", "roundType"])),

	methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_vuex__["b" /* mapActions */])([]))

});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js